const en = {
  'nav.home': 'Home',
  'nav.allParts': 'All Parts',
  'nav.cart': 'Cart',
  'nav.myAccount': 'My Account',
  'nav.myOrders': 'My Orders',
  'nav.sellerPortal': 'Seller Portal',
  'nav.adminPanel': 'Admin Panel',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.logout': 'Logout',
  'nav.makes': 'Vehicle Makes',
  'header.freeShipping': "Fast delivery to the EU, UK & Norway",
  'header.returns': '14-day returns',
  'header.light': 'Light',
  'header.dark': 'Dark',
  'header.searchPlaceholder': 'Search by part number, OEM code, or keyword...',
  'header.searchMobile': 'Search parts...',
  'search.partsFound': '{count} parts found',
  'search.sortBy': 'Sort by',
  'search.relevance': 'Relevance',
  'search.priceLowHigh': 'Price: Low to High',
  'search.priceHighLow': 'Price: High to Low',
  'search.newest': 'Newest',
  'search.priceRange': 'Price Range',
  'search.make': 'Make',
  'search.model': 'Model',
  'search.year': 'Year',
  'search.category': 'Category',
  'search.subcategory': 'Subcategory',
  'search.condition': 'Condition',
  'search.allMakes': 'All makes',
  'search.allModels': 'All models',
  'search.allYears': 'All years',
  'search.allCategories': 'All categories',
  'search.allSubcategories': 'All subcategories',
  'search.allConditions': 'All conditions',
  'search.clearFilters': 'Clear all filters',
  'search.noResults': 'No parts found matching your criteria',
  'search.noResultsHint': 'Try broadening your search or adjusting filters',
  'search.addToCart': 'Add to Cart',
  'product.addToCart': 'Add to Cart',
  'product.freeShipping': "Shipping to the EU, UK & Norway",
  'product.reviews': 'Reviews',
  'product.writeReview': 'Write a Review',
  'product.signInReview': 'Sign in to write a review',
  'product.noReviews': 'No reviews yet. Be the first to review!',
  'product.seller': 'Seller',
  'product.condition': 'Condition',
  'product.oemCodes': 'OEM Codes',
  'product.inStock': 'In Stock ({qty} available)',
  'product.outOfStock': 'Out of Stock',
  'product.reviewTitle': 'Title',
  'product.reviewContent': 'Review',
  'product.submitReview': 'Submit Review',
  'product.avgRating': 'Average Rating',
  'product.ratingDist': 'Rating Distribution',
  'cart.title': 'Shopping Cart',
  'cart.empty': 'Your cart is empty',
  'cart.emptyHint': 'Browse our selection of auto parts to get started',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Shipping',
  'cart.total': 'Total',
  'cart.checkout': 'Proceed to Checkout',
  'cart.each': 'each',
  'cart.continueShopping': 'Continue Shopping',
  'cart.freeShipping': 'Delivery calculated at checkout',
  'checkout.orderSummary': 'Order Summary',
  'checkout.or': 'or',
  'checkout.continueAsGuest': 'Continue as guest',
  'checkout.guestHint': 'Your order confirmation will be emailed to you. You can create an account anytime to track orders.',
  'checkout.createAccountLabel': 'Create an account',
  'checkout.createAccountHint': 'Save your details, track this order, and check out faster next time.',
  'checkout.password': 'Password',
  'checkout.passwordPlaceholder': 'At least 8 characters',
  'checkout.createAccountEmailNote': 'We use the email from your shipping details as your login.',
  'checkout.subtotal': 'Subtotal',
  'checkout.shipping': 'Shipping',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Place Order',
  'checkout.processing': 'Processing...',
  'checkout.shippingInfo': 'Shipping Information',
  'checkout.billingInfo': 'Billing Information',
  'checkout.paymentInfo': 'Payment Information',
  'checkout.firstName': 'First Name',
  'checkout.lastName': 'Last Name',
  'checkout.email': 'Email',
  'checkout.address': 'Address',
  'checkout.city': 'City',
  'checkout.country': 'Country',
  'checkout.postalCode': 'Postal Code',
  'checkout.cardNumber': 'Card Number',
  'checkout.expiryDate': 'Expiry Date',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Same as shipping address',
  'customer.orders': 'Orders',
  'customer.messages': 'Messages',
  'customer.returns': 'Returns',
  'customer.orderHistory': 'Order History',
  'customer.noOrders': 'No orders placed yet',
  'customer.orderNo': 'Order #',
  'customer.orderDate': 'Date',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'View Details',
  'customer.backToOrders': 'Back to Orders',
  'customer.orderDetail': 'Order Details',
  'customer.requestReturn': 'Request a Return',
  'customer.returnReason': 'Reason for return',
  'customer.returnDescription': 'Additional details (optional)',
  'customer.submitReturn': 'Submit Return Request',
  'customer.returnSuccess': 'Your return request has been submitted successfully.',
  'customer.returnPending': 'A representative will review it shortly.',
  'customer.conversations': 'Conversations',
  'customer.noMessages': 'No conversations yet',
  'customer.send': 'Send',
  'customer.returnStatus.pending': 'Pending',
  'customer.returnStatus.approved': 'Approved',
  'customer.returnStatus.rejected': 'Rejected',
  'customer.returnStatus.processing': 'Processing',
  'customer.returnId': 'Return ID',
  'customer.orderId': 'Order ID',
  'customer.reason': 'Reason',
  'customer.description': 'Description',
  'customer.noReturns': 'No returns submitted yet',
  'customer.noReturnsHint': 'If you need to return an item, go to your order details and click "Request a Return".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'My Listings',
  'vendor.orders': 'Orders',
  'vendor.addListing': 'Add Listing',
  'vendor.bulkImport': 'Bulk Import',
  'vendor.revenue': 'Revenue',
  'vendor.totalOrders': 'Orders',
  'vendor.totalListings': 'Listings',
  'vendor.totalViews': 'Views',
  'vendor.recentOrders': 'Recent Orders',
  'vendor.noOrders': 'No orders yet',
  'vendor.editListing': 'Edit',
  'vendor.deleteListing': 'Delete',
  'vendor.priceLabel': 'Price ({symbol}) *',
  'vendor.importCSV': 'Import CSV Listings',
  'vendor.downloadTemplate': 'Download CSV Template',
  'vendor.chooseFile': 'Choose CSV File',
  'vendor.startImport': 'Start Import',
  'vendor.instructions': 'How to Import',
  'vendor.previewData': 'Preview (first 5 rows)',
  'vendor.importResults': 'Import Results',
  'vendor.listingsCreated': 'listings created successfully',
  'vendor.errors': 'Errors',
  'vendor.noFile': 'No file selected',
  'vendor.requiredColumns': 'Upload a CSV file with the following columns. Only title and price are required.',
  'admin.users': 'Users',
  'admin.sellers': 'Sellers',
  'admin.listings': 'Listings',
  'admin.orders': 'Orders',
  'admin.approve': 'Approve',
  'admin.suspend': 'Suspend',
  'admin.delete': 'Delete',
  'admin.totalUsers': 'Total Users',
  'admin.totalSellers': 'Total Sellers',
  'admin.totalListings': 'Total Listings',
  'admin.totalOrders': 'Total Orders',
  'admin.pendingSellers': 'Pending Sellers',
  'admin.email': 'Email',
  'admin.name': 'Name',
  'admin.role': 'Role',
  'admin.status': 'Status',
  'admin.actions': 'Actions',
  'admin.company': 'Company',
  'admin.rating': 'Rating',
  'admin.sales': 'Sales',
  'admin.title': 'Title',
  'admin.price': 'Price',
  'admin.category': 'Category',
  'admin.orderNo': 'Order #',
  'admin.buyer': 'Buyer',
  'admin.date': 'Date',
  'admin.total': 'Total',
  'home.heroTitle': "Used Auto Parts Online Shop · 4.2M+ Parts",
  'home.heroSubtitle': "Find original and aftermarket parts for any European vehicle. Delivery to the EU, UK and Norway.",
  'home.searchHero': 'Search for any part number, make, or keyword',
  'home.featuredParts': 'Featured Parts',
  'home.viewAll': 'View All Parts',
  'home.freeShipping': "EU, UK & Norway Delivery",
  'home.freeShippingDesc': "Delivery across the EU, UK & Norway",
  'home.returns': '14-Day Returns',
  'home.returnsDesc': 'Hassle-free return policy',
  'home.securePayment': 'Secure Payment',
  'home.securePaymentDesc': 'SSL encrypted transactions',
  'home.qualityParts': 'Quality Parts',
  'home.qualityPartsDesc': "Original manufacturer parts",
  'home.whyChoose': 'Why Choose zivu.eu?',
  'home.trustedSellers': "Fitment Checked",
  'home.trustedSellersDesc': 'Every part photographed and fitment-checked before listing',
  'makes.title': 'Vehicle Makes',
  'makes.subtitle': 'Browse parts by vehicle manufacturer',
  'makes.searchPlaceholder': 'Search makes...',
  'makes.popular': 'Popular Makes',
  'makeDetail.subtitle': 'Browse models and find parts',
  'makeDetail.selectModel': 'Select Model',
  'makeDetail.selectYear': 'Select Year',
  'footer.tagline': "Online shop for used and refurbished auto parts. Shipping across the EU, UK and Norway.",
  'footer.shop': 'Shop',
  'footer.allParts': 'All Parts',
  'footer.engineParts': 'Engine Parts',
  'footer.bodyParts': 'Body Parts',
  'footer.electrical': 'Electrical',
  'footer.refurbished': 'Refurbished',
  'footer.information': 'Information',
  'footer.aboutUs': 'About Us',
  'footer.deliveryInfo': 'Delivery Info',
  'footer.returnsRefunds': 'Returns & Refunds',
  'footer.paymentMethods': 'Payment Methods',
  'footer.contactUs': 'Contact Us',
  'footer.support': 'Support',
  'footer.helpCenter': 'Help Center',
  'footer.shippingInfo': 'Shipping Info',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Warranty',
  'footer.sellers': 'Sellers',
  'footer.sellOnZivu': 'Sell on zivu.eu',
  'footer.sellerPortal': 'Seller Portal',
  'footer.sellerTerms': 'Seller Terms',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.euMarketplace': 'EU · UK · Norway',
  'login.welcomeBack': 'Welcome Back',
  'login.signInToContinue': 'Sign in to your account to continue',
  'login.emailLabel': 'Email',
  'login.passwordLabel': 'Password',
  'login.emailPh': 'you@example.com',
  'login.forgotPassword': 'Forgot password?',
  'login.signingIn': 'Signing in…',
  'login.signInBtn': 'Sign In',
  'login.orContinueWith': 'Or continue with',
  'login.continueWithGoogle': 'Continue with Google',
  'login.noAccount': 'Don\'t have an account?',
  'login.signUp': 'Sign up',
  'register.title': 'Create Account',
  'register.subtitle': "Create an account to buy used and refurbished auto parts",
  'register.firstName': 'First Name',
  'register.lastName': 'Last Name',
  'register.emailLabel': 'Email',
  'register.passwordLabel': 'Password',
  'register.confirmPassword': 'Confirm Password',
  'register.creating': 'Creating account…',
  'register.createBtn': 'Create Account',
  'register.alreadyHave': 'Already have an account?',
  'register.signIn': 'Sign in',
  'register.byCreating': 'By creating an account, you agree to our',
  'customer.nav.overview': 'Overview',
  'customer.nav.myOrders': 'My Orders',
  'customer.nav.myGarage': 'My Garage',
  'customer.nav.myReviews': 'My Reviews',
  'customer.nav.favorites': 'Favorites',
  'customer.nav.messages': 'Messages',
  'customer.nav.returns': 'Returns',
  'customer.nav.addresses': 'Addresses',
  'customer.nav.settings': 'Settings',
  'customer.dashboardSubtitle': 'Manage your orders and account settings',
  'customer.recentOrders': 'Recent Orders',
  'customer.noOrdersYet': 'No orders yet',
  'customer.myOrdersTitle': 'My Orders',
  'customer.trackManage': 'Track and manage your orders',
  'customer.browseParts': 'Browse Parts',
  'customer.orderNotFound': 'Order not found',
  'customer.cancelOrderTitle': 'Cancel this order?',
  'customer.cancelOrderDesc': 'This action cannot be undone. Your payment will be refunded.',
  'customer.keepOrder': 'Keep Order',
  'customer.statusHistory': 'Status History',
  'customer.orderItems': 'Order Items',
  'customer.discount': 'Discount',
  'customer.shippingAddressTitle': 'Shipping Address',
  'customer.billingAddressTitle': 'Billing Address',
  'customer.needToReturn': 'Need to return this order?',
  'customer.returnRequestForm': 'Return Request Form',
  'customer.cancelBtn': 'Cancel',
  'customer.returnSubmitted': 'Return request submitted',
  'customer.returnReviewMsg': 'Our team will review your request and get back to you shortly.',
  'customer.newMessageTitle': 'New Message',
  'customer.sending': 'Sending…',
  'customer.sendMessage': 'Send Message',
  'customer.messagesTitle': 'Messages',
  'customer.myFavoritesTitle': 'My Favorites',
  'customer.noFavoritesYet': 'No favorites yet',
  'customer.noTimelineData': 'No timeline data available',
  'customer.returnsTitle': 'Returns',
  'customer.noReturnsYet': 'No returns yet',
  'customer.myAddressesTitle': 'My Addresses',
  'customer.noAddressesSaved': 'No addresses saved',
  'customer.defaultBadge': 'Default',
  'customer.businessAccount': 'Business Account',
  'customer.currentStatus': 'Current status',
  'customer.companyAddress': 'Registered company address',
  'status.pending': 'Pending',
  'status.confirmed': 'Confirmed',
  'status.paid': 'Paid',
  'status.processing': 'Processing',
  'status.shipped': 'Shipped',
  'status.delivered': 'Delivered',
  'status.completed': 'Completed',
  'status.cancelled': 'Cancelled',
  'status.refunded': 'Refunded',
  'status.returnRequested': 'Return Requested',
  'status.returning': 'Returning',
  'status.returned': 'Returned',
  'status.returnRejected': 'Return Rejected',
  'cart.itemsSubtotalLabel': 'Items Subtotal',
  'cart.discountLabel': 'Discount',
  'cart.allPricesVat': 'All prices include VAT',
  'cart.allPricesNet': 'Net of VAT — buyer self-accounts under reverse charge',
  'cart.secureCheckout': 'Secure checkout powered by Stripe',
  'cart.orderSummary': 'Order Summary',
  'checkout.title': 'Checkout',
  'checkout.buyerType': 'Buyer Type',
  'checkout.private': 'Private / Individual',
  'checkout.privateSub': 'Personal purchase',
  'checkout.company': 'Company / Organization',
  'checkout.companySub': 'B2B with VAT invoice',
  'checkout.companyDetails': 'Company Details',
  'checkout.companyName': 'Company Name',
  'checkout.companyNamePh': 'Acme GmbH',
  'checkout.vatNumberLabel': 'VAT Number (recommended)',
  'checkout.vatValidating': 'Validating VAT number…',
  'checkout.streetPh': 'Street and number',
  'checkout.shippingTitle': 'Shipping',
  'checkout.standardDelivery': 'Standard Delivery',
  'checkout.billingTitle': 'Billing Address',
  'checkout.sameAsShipping': 'Same as shipping address',
  'checkout.secureCheckout': 'Secure checkout powered by Stripe',
  'checkout.buyerProtection': "14-day right of withdrawal",
  'checkout.firstNamePh': 'Jane',
  'checkout.lastNamePh': 'Smith',
  'checkout.processingBtn': 'Processing…',
  'checkout.termsShort': 'Terms',
  'checkout.privacyShort': 'Privacy Policy',
  'checkout.detailsStep': 'Details',
  'checkout.shippingBilling': 'Shipping & billing',
  'checkout.paymentStep': 'Payment',
  'checkout.secureViaStripe': 'Secure via Stripe',
  'checkout.acceptTerms': 'I agree to the',
  'checkout.and': 'and',
  'register.firstNamePh': 'John',
  'register.lastNamePh': 'Doe',
  'register.termsLink': 'Terms of Service',
  'register.privacyLink': 'Privacy Policy',
  'product.clickToZoom': 'Click to zoom',
  'product.deliveryEstimate': 'Delivery Estimate',
  'product.selectCountry': 'Select your country',
  'product.inStockShort': 'In Stock',
  'product.outOfStockShort': 'Out of Stock',
  'product.askQuestion': 'Ask a Question',
  'product.askQuestionPh': 'Hi, I have a question about this part. Is it compatible with my car?',
  'product.soldBy': 'Sold by',
  'product.yourReview': 'Your Review',
  'product.reviewTitlePh': 'Summarise your experience',
  'product.reviewBodyPh': 'Share your experience with this part — fitment, quality, delivery…',
  'product.noReviewsYet': 'No reviews yet.',
  'product.beFirstReview': 'Be the first to review this part!',
  'product.notFound': 'Product not found',
  'product.browseAll': 'Browse all parts',
  'product.qualityAssessment': 'Quality Assessment',
  'product.aiAssessed': 'AI-assessed from photos',
  'product.aiDisclaimer': 'Automated visual estimate — verify against the photos.',
  'product.newSeller': 'New Seller',
  'product.description': 'Product Description',
  'product.keyFeatures': 'Key Features',
  'product.compatibility': 'Vehicle Compatibility',
  'product.oemNumbersTitle': 'OEM Part Numbers',
  'product.totalSales': 'Total Sales',
  'product.aboutSeller': 'About the Seller',
  'product.moreFromSeller': 'More from this Seller',
  'product.youMayAlsoLike': 'You May Also Like',
  'product.copyOem': 'Copy OEM code',
  'product.securePayment': 'Secure Payment',
  'product.newLabel': 'New',
  'product.sellerInfoNa': 'Seller information not available',
  'home.heroBadge': '4.2M+ Parts Available',
  'home.heroTitle1': 'Find Your',
  'home.heroTitle2': 'Auto Part',
  'home.heroPara': "A European online shop for quality used and refurbished auto parts. Search by OEM code or vehicle model.",
  'home.searchPlaceholder': 'Enter OEM code or part number (e.g. OEM-A123-4567)',
  'home.searchByVehicle': 'Search by Vehicle',
  'home.searchByVehicleSub': 'Select your car to find compatible parts',
  'home.makeLabel': 'Make',
  'home.modelLabel': 'Model',
  'home.generationLabel': 'Generation',
  'home.partNameLabel': 'Part Name',
  'home.selectMake': 'Select make',
  'home.selectModel': 'Select model',
  'home.selectGeneration': 'Select generation',
  'home.partPlaceholder': 'e.g. Brake pads, Alternator…',
  'home.searchPartsBtn': 'Search Parts',
  'home.browseByCategoryTitle': 'Browse by Category',
  'home.browseByCategorySub': 'Find parts organized by type',
  'common.viewAll': 'View All',
  'header.shipWithin': 'We ship within 72 working hours',
  'header.returns14': '14-day returns',
  'header.deliveryEU': 'Delivery across the EU, UK & Norway',
  'header.inclVat': 'Incl. VAT',
  'header.exclVat': 'Excl. VAT',
  'cat.air-conditioning-heating-system-radiators': 'Air Conditioning, Heating & Radiators',
  'cat.body-body-parts-hook': 'Body & Hood',
  'cat.brake-system': 'Brake System',
  'cat.cabin-interior': 'Cabin & Interior',
  'cat.devices-switches-electronic-system': 'Electrical & Electronics',
  'cat.door': 'Doors',
  'cat.engine': 'Engine',
  'cat.exterior-front-body-parts': 'Exterior Front Body',
  'cat.exterior-rear-body-parts': 'Exterior Rear Body',
  'cat.front-axle': 'Front Axle',
  'cat.fuel-mixture-system': 'Fuel System',
  'cat.gas-exhaust-system': 'Exhaust System',
  'cat.gearbox-clutch-transmission': 'Gearbox, Clutch & Transmission',
  'cat.glass': 'Glass',
  'cat.headlight-headlamp-washing-cleaning-system': 'Headlights & Washers',
  'cat.lighting-system': 'Lighting',
  'cat.other-parts': 'Other Parts',
  'cat.rear-axle': 'Rear Axle',
  'cat.wheels-tires-caps': 'Wheels & Tires',
};

const de = {
  'nav.home': 'Startseite',
  'nav.allParts': 'Alle Teile',
  'nav.cart': 'Warenkorb',
  'nav.myAccount': 'Mein Konto',
  'nav.myOrders': 'Meine Bestellungen',
  'nav.sellerPortal': 'Verkäuferportal',
  'nav.adminPanel': 'Admin-Bereich',
  'nav.login': 'Anmelden',
  'nav.register': 'Registrieren',
  'nav.logout': 'Abmelden',
  'nav.makes': 'Fahrzeugmarken',
  'header.freeShipping': "Schnelle Lieferung in die EU, UK & Norwegen",
  'header.returns': '14-Tage-Rückgabe',
  'header.light': 'Hell',
  'header.dark': 'Dunkel',
  'header.searchPlaceholder': 'Suche nach Teilnummer, OEM-Code oder Schlüsselwort...',
  'header.searchMobile': 'Teile suchen...',
  'search.partsFound': '{count} Teile gefunden',
  'search.sortBy': 'Sortierung',
  'search.relevance': 'Relevanz',
  'search.priceLowHigh': 'Preis: Niedrig bis Hoch',
  'search.priceHighLow': 'Preis: Hoch bis Niedrig',
  'search.newest': 'Neueste',
  'search.priceRange': 'Preisbereich',
  'search.make': 'Marke',
  'search.model': 'Modell',
  'search.year': 'Jahr',
  'search.category': 'Kategorie',
  'search.subcategory': 'Unterkategorie',
  'search.condition': 'Zustand',
  'search.allMakes': 'Alle Marken',
  'search.allModels': 'Alle Modelle',
  'search.allYears': 'Alle Jahre',
  'search.allCategories': 'Alle Kategorien',
  'search.allSubcategories': 'Alle Unterkategorien',
  'search.allConditions': 'Alle Zustände',
  'search.clearFilters': 'Alle Filter zurücksetzen',
  'search.noResults': 'Keine Teile gefunden, die Ihren Kriterien entsprechen',
  'search.noResultsHint': 'Versuchen Sie, Ihre Suche zu erweitern oder Filter anzupassen',
  'search.addToCart': 'In den Warenkorb',
  'product.addToCart': 'In den Warenkorb',
  'product.freeShipping': "Versand in die EU, UK & Norwegen",
  'product.reviews': 'Bewertungen',
  'product.writeReview': 'Bewertung schreiben',
  'product.signInReview': 'Melden Sie sich an, um eine Bewertung zu schreiben',
  'product.noReviews': 'Noch keine Bewertungen. Seien Sie der Erste!',
  'product.seller': 'Verkäufer',
  'product.condition': 'Zustand',
  'product.oemCodes': 'OEM-Codes',
  'product.inStock': 'Auf Lager ({qty} verfügbar)',
  'product.outOfStock': 'Nicht auf Lager',
  'product.reviewTitle': 'Titel',
  'product.reviewContent': 'Bewertung',
  'product.submitReview': 'Bewertung senden',
  'product.avgRating': 'Durchschnittliche Bewertung',
  'product.ratingDist': 'Bewertungsverteilung',
  'cart.title': 'Warenkorb',
  'cart.empty': 'Ihr Warenkorb ist leer',
  'cart.emptyHint': 'Durchsuchen Sie unsere Auswahl an Autoersatzteilen',
  'cart.subtotal': 'Zwischensumme',
  'cart.shipping': 'Versand',
  'cart.total': 'Gesamt',
  'cart.checkout': 'Zur Kasse',
  'cart.each': 'pro Stück',
  'cart.continueShopping': 'Weiter Einkaufen',
  'cart.freeShipping': 'Lieferung wird an der Kasse berechnet',
  'checkout.orderSummary': 'Bestellzusammenfassung',
  'checkout.subtotal': 'Zwischensumme',
  'checkout.shipping': 'Versand',
  'checkout.total': 'Gesamt',
  'checkout.placeOrder': "Zahlungspflichtig bestellen",
  'checkout.processing': 'Verarbeitung...',
  'checkout.shippingInfo': 'Versandanschrift',
  'checkout.billingInfo': 'Rechnungsanschrift',
  'checkout.paymentInfo': 'Zahlungsinformationen',
  'checkout.firstName': 'Vorname',
  'checkout.lastName': 'Nachname',
  'checkout.email': 'E-Mail',
  'checkout.address': 'Adresse',
  'checkout.city': 'Stadt',
  'checkout.country': 'Land',
  'checkout.postalCode': 'Postleitzahl',
  'checkout.cardNumber': 'Kartennummer',
  'checkout.expiryDate': 'Ablaufdatum',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Gleich wie Versandanschrift',
  'customer.orders': 'Bestellungen',
  'customer.messages': 'Nachrichten',
  'customer.returns': 'Retouren',
  'customer.orderHistory': 'Bestellverlauf',
  'customer.noOrders': 'Noch keine Bestellungen',
  'customer.orderNo': 'Bestellung #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Gesamt',
  'customer.viewDetails': 'Details anzeigen',
  'customer.backToOrders': 'Zurück zu den Bestellungen',
  'customer.orderDetail': 'Bestelldetails',
  'customer.requestReturn': 'Retoure beantragen',
  'customer.returnReason': 'Grund für die Retoure',
  'customer.returnDescription': 'Zusätzliche Details (optional)',
  'customer.submitReturn': 'Retoure-Anfrage senden',
  'customer.returnSuccess': 'Ihre Retoure-Anfrage wurde erfolgreich eingereicht.',
  'customer.returnPending': 'Ein Mitarbeiter wird sie in Kürze prüfen.',
  'customer.conversations': 'Gespräche',
  'customer.noMessages': 'Noch keine Gespräche',
  'customer.send': 'Senden',
  'customer.returnStatus.pending': 'Ausstehend',
  'customer.returnStatus.approved': 'Genehmigt',
  'customer.returnStatus.rejected': 'Abgelehnt',
  'customer.returnStatus.processing': 'In Bearbeitung',
  'customer.returnId': 'Retoure-ID',
  'customer.orderId': 'Bestellungs-ID',
  'customer.reason': 'Grund',
  'customer.description': 'Beschreibung',
  'customer.noReturns': 'Noch keine Retouren eingereicht',
  'customer.noReturnsHint': 'Wenn Sie einen Artikel zurücksenden möchten, gehen Sie zu Ihren Bestelldetails und klicken Sie auf "Retoure beantragen".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'Meine Listings',
  'vendor.orders': 'Bestellungen',
  'vendor.addListing': 'Listing hinzufügen',
  'vendor.bulkImport': 'Massenimport',
  'vendor.revenue': 'Umsatz',
  'vendor.totalOrders': 'Bestellungen',
  'vendor.totalListings': 'Listings',
  'vendor.totalViews': 'Aufrufe',
  'vendor.recentOrders': 'Kürzliche Bestellungen',
  'vendor.noOrders': 'Noch keine Bestellungen',
  'vendor.editListing': 'Bearbeiten',
  'vendor.deleteListing': 'Löschen',
  'vendor.priceLabel': 'Preis ({symbol}) *',
  'vendor.importCSV': 'CSV-Listings importieren',
  'vendor.downloadTemplate': 'CSV-Vorlage herunterladen',
  'vendor.chooseFile': 'CSV-Datei auswählen',
  'vendor.startImport': 'Import starten',
  'vendor.instructions': 'Wie man importiert',
  'vendor.previewData': 'Vorschau (erste 5 Zeilen)',
  'vendor.importResults': 'Importergebnisse',
  'vendor.listingsCreated': 'Listings erfolgreich erstellt',
  'vendor.errors': 'Fehler',
  'vendor.noFile': 'Keine Datei ausgewählt',
  'vendor.requiredColumns': 'Laden Sie eine CSV-Datei mit den folgenden Spalten hochladen. Nur Titel und Preis sind erforderlich.',
  'admin.users': 'Benutzer',
  'admin.sellers': 'Verkäufer',
  'admin.listings': 'Listings',
  'admin.orders': 'Bestellungen',
  'admin.approve': 'Genehmigen',
  'admin.suspend': 'Sperren',
  'admin.delete': 'Löschen',
  'admin.totalUsers': 'Gesamte Benutzer',
  'admin.totalSellers': 'Gesamte Verkäufer',
  'admin.totalListings': 'Gesamte Listings',
  'admin.totalOrders': 'Gesamte Bestellungen',
  'admin.pendingSellers': 'Wartende Verkäufer',
  'admin.email': 'E-Mail',
  'admin.name': 'Name',
  'admin.role': 'Rolle',
  'admin.status': 'Status',
  'admin.actions': 'Aktionen',
  'admin.company': 'Unternehmen',
  'admin.rating': 'Bewertung',
  'admin.sales': 'Verkäufe',
  'admin.title': 'Titel',
  'admin.price': 'Preis',
  'admin.category': 'Kategorie',
  'admin.orderNo': 'Bestellung #',
  'admin.buyer': 'Käufer',
  'admin.date': 'Datum',
  'admin.total': 'Gesamt',
  'home.heroTitle': "Online-Shop für gebrauchte Autoteile · 4,2 Mio.+ Teile",
  'home.heroSubtitle': "Finden Sie Original- und Ersatzteile für jedes europäische Fahrzeug. Lieferung in die EU, nach Großbritannien und Norwegen.",
  'home.searchHero': 'Suche nach Teilnummer, Marke oder Schlüsselwort',
  'home.featuredParts': 'Empfohlene Teile',
  'home.viewAll': 'Alle Teile anzeigen',
  'home.freeShipping': "Lieferung EU, UK & Norwegen",
  'home.freeShippingDesc': "Lieferung in die EU, GB & Norwegen",
  'home.returns': '14-Tage-Retoure',
  'home.returnsDesc': 'Unkomplizierte Rückgabepolitik',
  'home.securePayment': 'Sichere Zahlung',
  'home.securePaymentDesc': 'SSL-verschlüsselte Transaktionen',
  'home.qualityParts': 'Qualitätsteile',
  'home.qualityPartsDesc': "Originalteile der Hersteller",
  'home.whyChoose': 'Warum zivu.eu wählen?',
  'home.trustedSellers': "Passgenauigkeit geprüft",
  'home.trustedSellersDesc': "Jedes Teil wird vor der Einstellung fotografiert und auf Passgenauigkeit geprüft",
  'makes.title': 'Fahrzeugmarken',
  'makes.subtitle': 'Teile nach Fahrzeughersteller durchsuchen',
  'makes.searchPlaceholder': 'Marken suchen...',
  'makes.popular': 'Beliebte Marken',
  'makeDetail.subtitle': 'Modelle durchsuchen und Teile finden',
  'makeDetail.selectModel': 'Modell auswählen',
  'makeDetail.selectYear': 'Jahr auswählen',
  'footer.tagline': "Online-Shop für gebrauchte und aufbereitete Autoteile. Versand in die EU, nach Großbritannien und Norwegen.",
  'footer.shop': 'Shop',
  'footer.allParts': 'Alle Teile',
  'footer.engineParts': 'Motorteile',
  'footer.bodyParts': 'Karosserieteile',
  'footer.electrical': 'Elektrik',
  'footer.refurbished': 'Aufbereitet',
  'footer.information': 'Information',
  'footer.aboutUs': 'Über uns',
  'footer.deliveryInfo': 'Lieferinformationen',
  'footer.returnsRefunds': 'Retouren & Rückerstattung',
  'footer.paymentMethods': 'Zahlungsmethoden',
  'footer.contactUs': 'Kontakt',
  'footer.support': 'Hilfe',
  'footer.helpCenter': 'Hilfezentrum',
  'footer.shippingInfo': 'Versandinfo',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garantie',
  'footer.sellers': 'Verkäufer',
  'footer.sellOnZivu': 'Auf zivu.eu verkaufen',
  'footer.sellerPortal': 'Verkäuferportal',
  'footer.sellerTerms': 'Verkäuferbedingungen',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'AGB',
  'footer.euMarketplace': "EU · UK · Norwegen",
  'login.welcomeBack': 'Willkommen zurück',
  'login.signInToContinue': 'Melden Sie sich an, um fortzufahren',
  'login.emailLabel': 'E-Mail',
  'login.passwordLabel': 'Passwort',
  'login.emailPh': 'sie@beispiel.de',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.signingIn': 'Anmeldung läuft…',
  'login.signInBtn': 'Anmelden',
  'login.orContinueWith': 'Oder weiter mit',
  'login.continueWithGoogle': 'Mit Google fortfahren',
  'login.noAccount': 'Noch kein Konto?',
  'login.signUp': 'Registrieren',
  'register.title': 'Konto erstellen',
  'register.subtitle': "Erstellen Sie ein Konto, um gebrauchte und überholte Autoteile zu kaufen",
  'register.firstName': 'Vorname',
  'register.lastName': 'Nachname',
  'register.emailLabel': 'E-Mail',
  'register.passwordLabel': 'Passwort',
  'register.confirmPassword': 'Passwort bestätigen',
  'register.creating': 'Konto wird erstellt…',
  'register.createBtn': 'Konto erstellen',
  'register.alreadyHave': 'Sie haben bereits ein Konto?',
  'register.signIn': 'Anmelden',
  'register.byCreating': 'Mit der Registrierung akzeptieren Sie unsere',
  'customer.nav.overview': 'Übersicht',
  'customer.nav.myOrders': 'Meine Bestellungen',
  'customer.nav.myGarage': 'Meine Garage',
  'customer.nav.myReviews': 'Meine Bewertungen',
  'customer.nav.favorites': 'Favoriten',
  'customer.nav.messages': 'Nachrichten',
  'customer.nav.returns': 'Rücksendungen',
  'customer.nav.addresses': 'Adressen',
  'customer.nav.settings': 'Einstellungen',
  'customer.dashboardSubtitle': 'Verwalten Sie Ihre Bestellungen und Kontoeinstellungen',
  'customer.recentOrders': 'Letzte Bestellungen',
  'customer.noOrdersYet': 'Noch keine Bestellungen',
  'customer.myOrdersTitle': 'Meine Bestellungen',
  'customer.trackManage': 'Verfolgen und verwalten Sie Ihre Bestellungen',
  'customer.browseParts': 'Teile durchsuchen',
  'customer.orderNotFound': 'Bestellung nicht gefunden',
  'customer.cancelOrderTitle': 'Diese Bestellung stornieren?',
  'customer.cancelOrderDesc': 'Diese Aktion kann nicht rückgängig gemacht werden. Ihre Zahlung wird erstattet.',
  'customer.keepOrder': 'Bestellung behalten',
  'customer.statusHistory': 'Statusverlauf',
  'customer.orderItems': 'Bestellpositionen',
  'customer.discount': 'Rabatt',
  'customer.shippingAddressTitle': 'Lieferadresse',
  'customer.billingAddressTitle': 'Rechnungsadresse',
  'customer.needToReturn': 'Diese Bestellung zurücksenden?',
  'customer.returnRequestForm': 'Rücksendeformular',
  'customer.cancelBtn': 'Abbrechen',
  'customer.returnSubmitted': 'Rücksendeantrag gesendet',
  'customer.returnReviewMsg': 'Unser Team prüft Ihre Anfrage und meldet sich in Kürze.',
  'customer.newMessageTitle': 'Neue Nachricht',
  'customer.sending': 'Wird gesendet…',
  'customer.sendMessage': 'Nachricht senden',
  'customer.messagesTitle': 'Nachrichten',
  'customer.myFavoritesTitle': 'Meine Favoriten',
  'customer.noFavoritesYet': 'Noch keine Favoriten',
  'customer.noTimelineData': 'Keine Zeitachsendaten verfügbar',
  'customer.returnsTitle': 'Rücksendungen',
  'customer.noReturnsYet': 'Noch keine Rücksendungen',
  'customer.myAddressesTitle': 'Meine Adressen',
  'customer.noAddressesSaved': 'Keine Adressen gespeichert',
  'customer.defaultBadge': 'Standard',
  'customer.businessAccount': 'Geschäftskonto',
  'customer.currentStatus': 'Aktueller Status',
  'customer.companyAddress': 'Eingetragene Firmenanschrift',
  'status.pending': 'Ausstehend',
  'status.confirmed': 'Bestätigt',
  'status.paid': 'Bezahlt',
  'status.processing': 'In Bearbeitung',
  'status.shipped': 'Versandt',
  'status.delivered': 'Zugestellt',
  'status.completed': 'Abgeschlossen',
  'status.cancelled': 'Storniert',
  'status.refunded': 'Erstattet',
  'status.returnRequested': 'Rücksendung beantragt',
  'status.returning': 'Wird zurückgesendet',
  'status.returned': 'Zurückgesendet',
  'status.returnRejected': 'Rücksendung abgelehnt',
  'cart.itemsSubtotalLabel': 'Zwischensumme',
  'cart.discountLabel': 'Rabatt',
  'cart.allPricesVat': 'Alle Preise inkl. MwSt.',
  'cart.allPricesNet': 'Netto — der Käufer rechnet die MwSt. selbst ab (Reverse Charge)',
  'cart.secureCheckout': 'Sicherer Checkout mit Stripe',
  'cart.orderSummary': 'Bestellübersicht',
  'checkout.title': 'Kasse',
  'checkout.buyerType': 'Kundentyp',
  'checkout.private': 'Privat / Privatperson',
  'checkout.privateSub': 'Privatkauf',
  'checkout.company': 'Firma / Organisation',
  'checkout.companySub': 'B2B mit MwSt.-Rechnung',
  'checkout.companyDetails': 'Firmendaten',
  'checkout.companyName': 'Firmenname',
  'checkout.companyNamePh': 'Beispiel GmbH',
  'checkout.vatNumberLabel': 'USt-IdNr. (empfohlen)',
  'checkout.vatValidating': 'USt-IdNr. wird geprüft…',
  'checkout.streetPh': 'Straße und Hausnummer',
  'checkout.shippingTitle': 'Versand',
  'checkout.standardDelivery': 'Standardversand',
  'checkout.billingTitle': 'Rechnungsadresse',
  'checkout.sameAsShipping': 'Identisch mit Lieferadresse',
  'checkout.secureCheckout': 'Sicherer Checkout mit Stripe',
  'checkout.buyerProtection': "14 Tage Widerrufsrecht",
  'checkout.firstNamePh': 'Anna',
  'checkout.lastNamePh': 'Müller',
  'checkout.processingBtn': 'Wird verarbeitet…',
  'checkout.termsShort': 'AGB',
  'checkout.privacyShort': 'Datenschutz',
  'checkout.detailsStep': 'Daten',
  'checkout.shippingBilling': 'Versand & Rechnung',
  'checkout.paymentStep': 'Zahlung',
  'checkout.secureViaStripe': 'Sicher über Stripe',
  'checkout.acceptTerms': 'Ich akzeptiere die',
  'checkout.and': 'und die',
  'register.firstNamePh': 'Max',
  'register.lastNamePh': 'Mustermann',
  'register.termsLink': 'AGB',
  'register.privacyLink': 'Datenschutzerklärung',
  'product.clickToZoom': 'Zum Zoomen klicken',
  'product.deliveryEstimate': 'Lieferzeit-Schätzung',
  'product.selectCountry': 'Land auswählen',
  'product.inStockShort': 'Auf Lager',
  'product.outOfStockShort': 'Nicht auf Lager',
  'product.askQuestion': 'Frage stellen',
  'product.askQuestionPh': 'Hallo, ich habe eine Frage zu diesem Teil. Passt es zu meinem Auto?',
  'product.soldBy': 'Verkauft von',
  'product.yourReview': 'Ihre Bewertung',
  'product.reviewTitlePh': 'Erfahrung zusammenfassen',
  'product.reviewBodyPh': 'Teilen Sie Ihre Erfahrung mit diesem Teil — Passform, Qualität, Lieferung…',
  'product.noReviewsYet': 'Noch keine Bewertungen.',
  'product.beFirstReview': 'Bewerten Sie dieses Teil als Erster!',
  'product.notFound': 'Produkt nicht gefunden',
  'product.browseAll': 'Alle Teile durchsuchen',
  'product.qualityAssessment': 'Qualitätsbewertung',
  'product.aiAssessed': 'KI-bewertet anhand von Fotos',
  'product.aiDisclaimer': 'Automatische visuelle Schätzung – bitte anhand der Fotos prüfen.',
  'product.newSeller': 'Neuer Verkäufer',
  'product.description': 'Produktbeschreibung',
  'product.keyFeatures': 'Eigenschaften',
  'product.compatibility': 'Fahrzeugkompatibilität',
  'product.oemNumbersTitle': 'OEM-Teilenummern',
  'product.totalSales': 'Verkäufe gesamt',
  'product.aboutSeller': 'Über den Verkäufer',
  'product.moreFromSeller': 'Mehr von diesem Verkäufer',
  'product.youMayAlsoLike': 'Das könnte Sie auch interessieren',
  'product.copyOem': 'OEM-Code kopieren',
  'product.securePayment': 'Sichere Zahlung',
  'product.newLabel': 'Neu',
  'product.sellerInfoNa': 'Verkäuferinformationen nicht verfügbar',
  'home.heroBadge': '4,2 Mio.+ Teile verfügbar',
  'home.heroTitle1': 'Finde dein',
  'home.heroTitle2': 'Autoteil',
  'home.heroPara': "Ein europäischer Online-Shop für hochwertige gebrauchte und überholte Autoteile. Suchen Sie nach OEM-Nummer oder Fahrzeugmodell.",
  'home.searchPlaceholder': 'OEM-Code oder Teilenummer eingeben (z.B. OEM-A123-4567)',
  'home.searchByVehicle': 'Nach Fahrzeug suchen',
  'home.searchByVehicleSub': 'Wählen Sie Ihr Auto, um kompatible Teile zu finden',
  'home.makeLabel': 'Marke',
  'home.modelLabel': 'Modell',
  'home.generationLabel': 'Generation',
  'home.partNameLabel': 'Teilebezeichnung',
  'home.selectMake': 'Marke wählen',
  'home.selectModel': 'Modell wählen',
  'home.selectGeneration': 'Generation wählen',
  'home.partPlaceholder': 'z.B. Bremsbeläge, Lichtmaschine…',
  'home.searchPartsBtn': 'Teile suchen',
  'home.browseByCategoryTitle': 'Nach Kategorie suchen',
  'home.browseByCategorySub': 'Teile nach Typ organisiert finden',
  'common.viewAll': 'Alle anzeigen',
  'header.shipWithin': 'Versand innerhalb von 72 Werktagen',
  'header.returns14': '14 Tage Rückgaberecht',
  'header.deliveryEU': "Lieferung in die EU, nach Großbritannien & Norwegen",
  'header.inclVat': 'Inkl. MwSt.',
  'header.exclVat': 'Exkl. MwSt.',
  'cat.air-conditioning-heating-system-radiators': 'Klimaanlage, Heizung & Kühler',
  'cat.body-body-parts-hook': 'Karosserie & Motorhaube',
  'cat.brake-system': 'Bremsanlage',
  'cat.cabin-interior': 'Innenraum',
  'cat.devices-switches-electronic-system': 'Elektrik & Elektronik',
  'cat.door': 'Türen',
  'cat.engine': 'Motor',
  'cat.exterior-front-body-parts': 'Karosserie vorne',
  'cat.exterior-rear-body-parts': 'Karosserie hinten',
  'cat.front-axle': 'Vorderachse',
  'cat.fuel-mixture-system': 'Kraftstoffsystem',
  'cat.gas-exhaust-system': 'Abgasanlage',
  'cat.gearbox-clutch-transmission': 'Getriebe, Kupplung & Antrieb',
  'cat.glass': 'Scheiben',
  'cat.headlight-headlamp-washing-cleaning-system': 'Scheinwerfer & Waschanlage',
  'cat.lighting-system': 'Beleuchtung',
  'cat.other-parts': 'Sonstige Teile',
  'cat.rear-axle': 'Hinterachse',
  'cat.wheels-tires-caps': 'Räder & Reifen',
};

const fr = {
  'nav.home': 'Accueil',
  'nav.allParts': 'Toutes les pièces',
  'nav.cart': 'Panier',
  'nav.myAccount': 'Mon compte',
  'nav.myOrders': 'Mes commandes',
  'nav.sellerPortal': 'Portail vendeur',
  'nav.adminPanel': 'Panneau admin',
  'nav.login': 'Connexion',
  'nav.register': 'Inscription',
  'nav.logout': 'Déconnexion',
  'nav.makes': 'Marques de véhicules',
  'header.freeShipping': "Livraison rapide UE, R.-U. et Norvège",
  'header.returns': 'Retours sur 14 jours',
  'header.light': 'Clair',
  'header.dark': 'Sombre',
  'header.searchPlaceholder': 'Rechercher par numéro de pièce, code OEM ou mot-clé...',
  'header.searchMobile': 'Rechercher des pièces...',
  'search.partsFound': '{count} pièces trouvées',
  'search.sortBy': 'Trier par',
  'search.relevance': 'Pertinence',
  'search.priceLowHigh': 'Prix : du plus bas au plus haut',
  'search.priceHighLow': 'Prix : du plus haut au plus bas',
  'search.newest': 'Plus récent',
  'search.priceRange': 'Plage de prix',
  'search.make': 'Marque',
  'search.model': 'Modèle',
  'search.year': 'Année',
  'search.category': 'Catégorie',
  'search.subcategory': 'Sous-catégorie',
  'search.condition': 'État',
  'search.allMakes': 'Toutes les marques',
  'search.allModels': 'Tous les modèles',
  'search.allYears': 'Toutes les années',
  'search.allCategories': 'Toutes les catégories',
  'search.allSubcategories': 'Toutes les sous-catégories',
  'search.allConditions': 'Tous les états',
  'search.clearFilters': 'Effacer tous les filtres',
  'search.noResults': 'Aucune pièce trouvée correspondant à vos critères',
  'search.noResultsHint': 'Essayez d\'élargir votre recherche ou d\'ajuster les filtres',
  'search.addToCart': 'Ajouter au panier',
  'product.addToCart': 'Ajouter au panier',
  'product.freeShipping': "Expédition UE, R.-U. et Norvège",
  'product.reviews': 'Avis',
  'product.writeReview': 'Écrire un avis',
  'product.signInReview': 'Connectez-vous pour écrire un avis',
  'product.noReviews': 'Pas encore d\'avis. Soyez le premier !',
  'product.seller': 'Vendeur',
  'product.condition': 'État',
  'product.oemCodes': 'Codes OEM',
  'product.inStock': 'En stock ({qty} disponible)',
  'product.outOfStock': 'Hors de stock',
  'product.reviewTitle': 'Titre',
  'product.reviewContent': 'Avis',
  'product.submitReview': 'Soumettre l\'avis',
  'product.avgRating': 'Note moyenne',
  'product.ratingDist': 'Distribution des notes',
  'cart.title': 'Panier d\'achat',
  'cart.empty': 'Votre panier est vide',
  'cart.emptyHint': 'Parcourez notre sélection de pièces automobiles',
  'cart.subtotal': 'Sous-total',
  'cart.shipping': 'Expédition',
  'cart.total': 'Total',
  'cart.checkout': 'Passer à la caisse',
  'cart.each': 'par unité',
  'cart.continueShopping': 'Continuer les achats',
  'cart.freeShipping': 'Livraison calculée au paiement',
  'checkout.orderSummary': 'Résumé de la commande',
  'checkout.subtotal': 'Sous-total',
  'checkout.shipping': 'Expédition',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Passer la commande',
  'checkout.processing': 'En cours de traitement...',
  'checkout.shippingInfo': 'Informations d\'expédition',
  'checkout.billingInfo': 'Informations de facturation',
  'checkout.paymentInfo': 'Informations de paiement',
  'checkout.firstName': 'Prénom',
  'checkout.lastName': 'Nom',
  'checkout.email': 'Email',
  'checkout.address': 'Adresse',
  'checkout.city': 'Ville',
  'checkout.country': 'Pays',
  'checkout.postalCode': 'Code postal',
  'checkout.cardNumber': 'Numéro de carte',
  'checkout.expiryDate': 'Date d\'expiration',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Même que l\'adresse d\'expédition',
  'customer.orders': 'Commandes',
  'customer.messages': 'Messages',
  'customer.returns': 'Retours',
  'customer.orderHistory': 'Historique des commandes',
  'customer.noOrders': 'Pas encore de commandes',
  'customer.orderNo': 'Commande #',
  'customer.orderDate': 'Date',
  'customer.orderStatus': 'Statut',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Voir les détails',
  'customer.backToOrders': 'Retour aux commandes',
  'customer.orderDetail': 'Détails de la commande',
  'customer.requestReturn': 'Demander un retour',
  'customer.returnReason': 'Raison du retour',
  'customer.returnDescription': 'Détails supplémentaires (optionnel)',
  'customer.submitReturn': 'Soumettre la demande de retour',
  'customer.returnSuccess': 'Votre demande de retour a été soumise avec succès.',
  'customer.returnPending': 'Un représentant la vérifiera prochainement.',
  'customer.conversations': 'Conversations',
  'customer.noMessages': 'Pas encore de conversations',
  'customer.send': 'Envoyer',
  'customer.returnStatus.pending': 'En attente',
  'customer.returnStatus.approved': 'Approuvé',
  'customer.returnStatus.rejected': 'Rejeté',
  'customer.returnStatus.processing': 'En cours',
  'customer.returnId': 'ID de retour',
  'customer.orderId': 'ID de commande',
  'customer.reason': 'Raison',
  'customer.description': 'Description',
  'customer.noReturns': 'Pas encore de retours soumis',
  'customer.noReturnsHint': 'Si vous devez retourner un article, allez dans les détails de votre commande et cliquez sur "Demander un retour".',
  'vendor.dashboard': 'Tableau de bord',
  'vendor.myListings': 'Mes annonces',
  'vendor.orders': 'Commandes',
  'vendor.addListing': 'Ajouter une annonce',
  'vendor.bulkImport': 'Import en masse',
  'vendor.revenue': "Chiffre d'affaires",
  'vendor.totalOrders': 'Commandes',
  'vendor.totalListings': 'Annonces',
  'vendor.totalViews': 'Vues',
  'vendor.recentOrders': 'Commandes récentes',
  'vendor.noOrders': 'Pas encore de commandes',
  'vendor.editListing': 'Modifier',
  'vendor.deleteListing': 'Supprimer',
  'vendor.priceLabel': 'Prix ({symbol}) *',
  'vendor.importCSV': 'Importer des annonces CSV',
  'vendor.downloadTemplate': 'Télécharger le modèle CSV',
  'vendor.chooseFile': 'Choisir un fichier CSV',
  'vendor.startImport': "Démarrer l'import",
  'vendor.instructions': 'Comment importer',
  'vendor.previewData': 'Aperçu (5 premières lignes)',
  'vendor.importResults': "Résultats de l'import",
  'vendor.listingsCreated': 'annonces créées avec succès',
  'vendor.errors': 'Erreurs',
  'vendor.noFile': 'Aucun fichier sélectionné',
  'vendor.requiredColumns': 'Téléchargez un fichier CSV avec les colonnes suivantes. Seuls le titre et le prix sont requis.',
  'admin.users': 'Utilisateurs',
  'admin.sellers': 'Vendeurs',
  'admin.listings': 'Annonces',
  'admin.orders': 'Commandes',
  'admin.approve': 'Approuver',
  'admin.suspend': 'Suspendre',
  'admin.delete': 'Supprimer',
  'admin.totalUsers': 'Total des utilisateurs',
  'admin.totalSellers': 'Total des vendeurs',
  'admin.totalListings': 'Total des annonces',
  'admin.totalOrders': 'Total des commandes',
  'admin.pendingSellers': 'Vendeurs en attente',
  'admin.email': 'Email',
  'admin.name': 'Nom',
  'admin.role': 'Rôle',
  'admin.status': 'Statut',
  'admin.actions': 'Actions',
  'admin.company': 'Entreprise',
  'admin.rating': 'Note',
  'admin.sales': 'Ventes',
  'admin.title': 'Titre',
  'admin.price': 'Prix',
  'admin.category': 'Catégorie',
  'admin.orderNo': 'Commande #',
  'admin.buyer': 'Acheteur',
  'admin.date': 'Date',
  'admin.total': 'Total',
  'home.heroTitle': "Boutique en ligne de pièces auto d'occasion · 4,2 M+ pièces",
  'home.heroSubtitle': "Trouvez des pièces d'origine et de remplacement pour tout véhicule européen. Livraison vers l'UE, le Royaume-Uni et la Norvège.",
  'home.searchHero': 'Rechercher un numéro de pièce, une marque ou un mot-clé',
  'home.featuredParts': 'Pièces en vedette',
  'home.viewAll': 'Voir toutes les pièces',
  'home.freeShipping': "Livraison UE, R.-U. et Norvège",
  'home.freeShippingDesc': "Livraison vers l'UE, le Royaume-Uni et la Norvège",
  'home.returns': 'Retours sur 14 jours',
  'home.returnsDesc': 'Politique de retour sans problème',
  'home.securePayment': 'Paiement sécurisé',
  'home.securePaymentDesc': 'Transactions chiffrées SSL',
  'home.qualityParts': 'Pièces de qualité',
  'home.qualityPartsDesc': "Pièces d'origine constructeur",
  'home.whyChoose': 'Pourquoi choisir zivu.eu ?',
  'home.trustedSellers': "Compatibilité vérifiée",
  'home.trustedSellersDesc': "Chaque pièce est photographiée et sa compatibilité vérifiée avant publication",
  'makes.title': 'Marques de véhicules',
  'makes.subtitle': 'Parcourir les pièces par fabricant de véhicules',
  'makes.searchPlaceholder': 'Rechercher des marques...',
  'makes.popular': 'Marques populaires',
  'makeDetail.subtitle': 'Parcourir les modèles et trouver des pièces',
  'makeDetail.selectModel': 'Sélectionner le modèle',
  'makeDetail.selectYear': 'Sélectionner l\'année',
  'footer.tagline': "Boutique en ligne de pièces automobiles d'occasion et reconditionnées. Livraison dans l'UE, au Royaume-Uni et en Norvège.",
  'footer.shop': 'Boutique',
  'footer.allParts': 'Toutes les pièces',
  'footer.engineParts': 'Pièces moteur',
  'footer.bodyParts': 'Pièces carrosserie',
  'footer.electrical': 'Électrique',
  'footer.refurbished': 'Reconditionné',
  'footer.information': 'Informations',
  'footer.aboutUs': 'À propos',
  'footer.deliveryInfo': 'Infos livraison',
  'footer.returnsRefunds': 'Retours & remboursements',
  'footer.paymentMethods': 'Moyens de paiement',
  'footer.contactUs': 'Contactez-nous',
  'footer.support': 'Assistance',
  'footer.helpCenter': 'Centre d\'aide',
  'footer.shippingInfo': 'Infos expédition',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garantie',
  'footer.sellers': 'Vendeurs',
  'footer.sellOnZivu': 'Vendre sur zivu.eu',
  'footer.sellerPortal': 'Portail vendeur',
  'footer.sellerTerms': 'Conditions vendeur',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.euMarketplace': "UE · R.-U. · Norvège",
  'login.welcomeBack': 'Bentornato',
  'login.signInToContinue': 'Accedi al tuo account per continuare',
  'login.emailLabel': 'E-mail',
  'login.passwordLabel': 'Password',
  'login.emailPh': 'tu@esempio.com',
  'login.forgotPassword': 'Password dimenticata?',
  'login.signingIn': 'Accesso in corso…',
  'login.signInBtn': 'Accedi',
  'login.orContinueWith': 'Oppure continua con',
  'login.continueWithGoogle': 'Continua con Google',
  'login.noAccount': 'Non hai un account?',
  'login.signUp': 'Registrati',
  'register.title': 'Crea un account',
  'register.subtitle': "Créez un compte pour acheter des pièces auto d'occasion et reconditionnées",
  'register.firstName': 'Nome',
  'register.lastName': 'Cognome',
  'register.emailLabel': 'E-mail',
  'register.passwordLabel': 'Password',
  'register.confirmPassword': 'Conferma password',
  'register.creating': 'Creazione account…',
  'register.createBtn': 'Crea account',
  'register.alreadyHave': 'Hai già un account?',
  'register.signIn': 'Accedi',
  'register.byCreating': 'Creando un account, accetti i nostri',
  'customer.nav.overview': 'Panoramica',
  'customer.nav.myOrders': 'I miei ordini',
  'customer.nav.myGarage': 'Il mio garage',
  'customer.nav.myReviews': 'Le mie recensioni',
  'customer.nav.favorites': 'Preferiti',
  'customer.nav.messages': 'Messaggi',
  'customer.nav.returns': 'Resi',
  'customer.nav.addresses': 'Indirizzi',
  'customer.nav.settings': 'Impostazioni',
  'customer.dashboardSubtitle': 'Gestisci i tuoi ordini e le impostazioni del tuo account',
  'customer.recentOrders': 'Ordini recenti',
  'customer.noOrdersYet': 'Nessun ordine ancora',
  'customer.myOrdersTitle': 'I miei ordini',
  'customer.trackManage': 'Traccia e gestisci i tuoi ordini',
  'customer.browseParts': 'Sfoglia ricambi',
  'customer.orderNotFound': 'Ordine non trovato',
  'customer.cancelOrderTitle': 'Annullare questo ordine?',
  'customer.cancelOrderDesc': 'Questa azione non può essere annullata. Il pagamento verrà rimborsato.',
  'customer.keepOrder': 'Mantieni ordine',
  'customer.statusHistory': 'Storico stati',
  'customer.orderItems': 'Articoli ordine',
  'customer.discount': 'Sconto',
  'customer.shippingAddressTitle': 'Indirizzo di spedizione',
  'customer.billingAddressTitle': 'Indirizzo di fatturazione',
  'customer.needToReturn': 'Devi restituire questo ordine?',
  'customer.returnRequestForm': 'Modulo di reso',
  'customer.cancelBtn': 'Annulla',
  'customer.returnSubmitted': 'Richiesta di reso inviata',
  'customer.returnReviewMsg': 'Il nostro team esaminerà la richiesta e ti risponderà a breve.',
  'customer.newMessageTitle': 'Nuovo messaggio',
  'customer.sending': 'Invio…',
  'customer.sendMessage': 'Invia messaggio',
  'customer.messagesTitle': 'Messaggi',
  'customer.myFavoritesTitle': 'I miei preferiti',
  'customer.noFavoritesYet': 'Nessun preferito ancora',
  'customer.noTimelineData': 'Nessun dato di cronologia disponibile',
  'customer.returnsTitle': 'Resi',
  'customer.noReturnsYet': 'Nessun reso ancora',
  'customer.myAddressesTitle': 'I miei indirizzi',
  'customer.noAddressesSaved': 'Nessun indirizzo salvato',
  'customer.defaultBadge': 'Predefinito',
  'customer.businessAccount': 'Account aziendale',
  'customer.currentStatus': 'Stato attuale',
  'customer.companyAddress': 'Indirizzo registrato dell\'azienda',
  'status.pending': 'In attesa',
  'status.confirmed': 'Confermato',
  'status.paid': 'Pagato',
  'status.processing': 'In lavorazione',
  'status.shipped': 'Spedito',
  'status.delivered': 'Consegnato',
  'status.completed': 'Completato',
  'status.cancelled': 'Annullato',
  'status.refunded': 'Rimborsato',
  'status.returnRequested': 'Reso richiesto',
  'status.returning': 'In reso',
  'status.returned': 'Restituito',
  'status.returnRejected': 'Reso rifiutato',
  'login.welcomeBack': 'Bon retour',
  'login.signInToContinue': 'Connectez-vous à votre compte pour continuer',
  'login.emailLabel': 'E-mail',
  'login.passwordLabel': 'Mot de passe',
  'login.emailPh': 'vous@exemple.com',
  'login.forgotPassword': 'Mot de passe oublié ?',
  'login.signingIn': 'Connexion…',
  'login.signInBtn': 'Se connecter',
  'login.orContinueWith': 'Ou continuer avec',
  'login.continueWithGoogle': 'Continuer avec Google',
  'login.noAccount': 'Pas encore de compte ?',
  'login.signUp': 'S\'inscrire',
  'register.title': 'Créer un compte',
  'register.subtitle': "Créez un compte pour acheter des pièces auto d'occasion et reconditionnées",
  'register.firstName': 'Prénom',
  'register.lastName': 'Nom',
  'register.emailLabel': 'E-mail',
  'register.passwordLabel': 'Mot de passe',
  'register.confirmPassword': 'Confirmer le mot de passe',
  'register.creating': 'Création du compte…',
  'register.createBtn': 'Créer un compte',
  'register.alreadyHave': 'Vous avez déjà un compte ?',
  'register.signIn': 'Se connecter',
  'register.byCreating': 'En créant un compte, vous acceptez nos',
  'customer.nav.overview': 'Aperçu',
  'customer.nav.myOrders': 'Mes commandes',
  'customer.nav.myGarage': 'Mon garage',
  'customer.nav.myReviews': 'Mes avis',
  'customer.nav.favorites': 'Favoris',
  'customer.nav.messages': 'Messages',
  'customer.nav.returns': 'Retours',
  'customer.nav.addresses': 'Adresses',
  'customer.nav.settings': 'Paramètres',
  'customer.dashboardSubtitle': 'Gérez vos commandes et paramètres de compte',
  'customer.recentOrders': 'Commandes récentes',
  'customer.noOrdersYet': 'Aucune commande',
  'customer.myOrdersTitle': 'Mes commandes',
  'customer.trackManage': 'Suivez et gérez vos commandes',
  'customer.browseParts': 'Parcourir les pièces',
  'customer.orderNotFound': 'Commande introuvable',
  'customer.cancelOrderTitle': 'Annuler cette commande ?',
  'customer.cancelOrderDesc': 'Cette action ne peut pas être annulée. Votre paiement sera remboursé.',
  'customer.keepOrder': 'Garder la commande',
  'customer.statusHistory': 'Historique des statuts',
  'customer.orderItems': 'Articles de la commande',
  'customer.discount': 'Remise',
  'customer.shippingAddressTitle': 'Adresse de livraison',
  'customer.billingAddressTitle': 'Adresse de facturation',
  'customer.needToReturn': 'Besoin de retourner cette commande ?',
  'customer.returnRequestForm': 'Formulaire de retour',
  'customer.cancelBtn': 'Annuler',
  'customer.returnSubmitted': 'Demande de retour envoyée',
  'customer.returnReviewMsg': 'Notre équipe examinera votre demande et reviendra vers vous prochainement.',
  'customer.newMessageTitle': 'Nouveau message',
  'customer.sending': 'Envoi…',
  'customer.sendMessage': 'Envoyer le message',
  'customer.messagesTitle': 'Messages',
  'customer.myFavoritesTitle': 'Mes favoris',
  'customer.noFavoritesYet': 'Aucun favori',
  'customer.noTimelineData': 'Aucune donnée de chronologie disponible',
  'customer.returnsTitle': 'Retours',
  'customer.noReturnsYet': 'Aucun retour',
  'customer.myAddressesTitle': 'Mes adresses',
  'customer.noAddressesSaved': 'Aucune adresse enregistrée',
  'customer.defaultBadge': 'Par défaut',
  'customer.businessAccount': 'Compte professionnel',
  'customer.currentStatus': 'Statut actuel',
  'customer.companyAddress': 'Adresse enregistrée de la société',
  'status.pending': 'En attente',
  'status.confirmed': 'Confirmée',
  'status.paid': 'Payée',
  'status.processing': 'En préparation',
  'status.shipped': 'Expédiée',
  'status.delivered': 'Livrée',
  'status.completed': 'Terminée',
  'status.cancelled': 'Annulée',
  'status.refunded': 'Remboursée',
  'status.returnRequested': 'Retour demandé',
  'status.returning': 'En retour',
  'status.returned': 'Retournée',
  'status.returnRejected': 'Retour refusé',
  'cart.itemsSubtotalLabel': 'Subtotale articoli',
  'cart.discountLabel': 'Sconto',
  'cart.allPricesVat': 'Tutti i prezzi includono IVA',
  'cart.allPricesNet': 'IVA esclusa — l\'acquirente autoliquida l\'IVA in regime di reverse charge',
  'cart.secureCheckout': 'Pagamento sicuro con Stripe',
  'cart.orderSummary': 'Riepilogo ordine',
  'checkout.title': 'Pagamento',
  'checkout.buyerType': 'Tipo di acquirente',
  'checkout.private': 'Privato',
  'checkout.privateSub': 'Acquisto personale',
  'checkout.company': 'Azienda / Organizzazione',
  'checkout.companySub': 'B2B con fattura IVA',
  'checkout.companyDetails': 'Dati dell\'azienda',
  'checkout.companyName': 'Nome dell\'azienda',
  'checkout.companyNamePh': 'Acme S.r.l.',
  'checkout.vatNumberLabel': 'Partita IVA (consigliata)',
  'checkout.vatValidating': 'Verifica della partita IVA…',
  'checkout.streetPh': 'Via e numero civico',
  'checkout.shippingTitle': 'Spedizione',
  'checkout.standardDelivery': 'Spedizione standard',
  'checkout.billingTitle': 'Indirizzo di fatturazione',
  'checkout.sameAsShipping': 'Identico alla spedizione',
  'checkout.secureCheckout': 'Pagamento sicuro con Stripe',
  'checkout.buyerProtection': "Droit de rétractation de 14 jours",
  'checkout.firstNamePh': 'Giulia',
  'checkout.lastNamePh': 'Rossi',
  'checkout.processingBtn': 'In elaborazione…',
  'checkout.termsShort': 'Termini',
  'checkout.privacyShort': 'Privacy',
  'checkout.detailsStep': 'Dati',
  'checkout.shippingBilling': 'Spedizione e fatturazione',
  'checkout.paymentStep': 'Pagamento',
  'checkout.secureViaStripe': 'Sicuro tramite Stripe',
  'checkout.acceptTerms': 'Accetto i',
  'checkout.and': 'e la',
  'register.firstNamePh': 'Mario',
  'register.lastNamePh': 'Rossi',
  'register.termsLink': 'Termini di servizio',
  'register.privacyLink': 'Informativa sulla privacy',
  'product.clickToZoom': 'Clicca per ingrandire',
  'product.deliveryEstimate': 'Stima della consegna',
  'product.selectCountry': 'Seleziona il tuo paese',
  'product.inStockShort': 'Disponibile',
  'product.outOfStockShort': 'Esaurito',
  'product.askQuestion': 'Fai una domanda',
  'product.askQuestionPh': 'Salve, ho una domanda su questo ricambio. È compatibile con la mia auto?',
  'product.soldBy': 'Venduto da',
  'product.yourReview': 'La tua recensione',
  'product.reviewTitlePh': 'Riassumi la tua esperienza',
  'product.reviewBodyPh': 'Condividi la tua esperienza con questo ricambio — montaggio, qualità, consegna…',
  'product.noReviewsYet': 'Ancora nessuna recensione.',
  'product.beFirstReview': 'Sii il primo a recensire questo ricambio!',
  'product.notFound': 'Prodotto non trovato',
  'product.browseAll': 'Sfoglia tutti i ricambi',
  'product.qualityAssessment': 'Valutazione qualità',
  'product.aiAssessed': 'Valutato dall\'IA dalle foto',
  'product.aiDisclaimer': 'Stima visiva automatica: verifica con le foto.',
  'product.newSeller': 'Nuovo venditore',
  'product.description': 'Descrizione prodotto',
  'product.keyFeatures': 'Caratteristiche principali',
  'product.compatibility': 'Compatibilità veicolo',
  'product.oemNumbersTitle': 'Codici OEM',
  'product.totalSales': 'Vendite totali',
  'product.aboutSeller': 'Informazioni sul venditore',
  'product.moreFromSeller': 'Altro da questo venditore',
  'product.youMayAlsoLike': 'Potrebbe interessarti anche',
  'product.copyOem': 'Copia codice OEM',
  'product.securePayment': 'Pagamento sicuro',
  'product.newLabel': 'Nuovo',
  'product.sellerInfoNa': 'Informazioni venditore non disponibili',
  'cart.itemsSubtotalLabel': 'Sous-total des articles',
  'cart.discountLabel': 'Remise',
  'cart.allPricesVat': 'Tous les prix incluent la TVA',
  'cart.allPricesNet': 'Hors TVA — auto-liquidation par l’acheteur',
  'cart.secureCheckout': 'Paiement sécurisé via Stripe',
  'cart.orderSummary': 'Récapitulatif',
  'checkout.title': 'Paiement',
  'checkout.buyerType': 'Type d\'acheteur',
  'checkout.private': 'Particulier',
  'checkout.privateSub': 'Achat personnel',
  'checkout.company': 'Entreprise / Organisation',
  'checkout.companySub': 'B2B avec facture TVA',
  'checkout.companyDetails': 'Coordonnées de l\'entreprise',
  'checkout.companyName': 'Nom de l\'entreprise',
  'checkout.companyNamePh': 'Acme SARL',
  'checkout.vatNumberLabel': 'Numéro de TVA (recommandé)',
  'checkout.vatValidating': 'Vérification du numéro de TVA…',
  'checkout.streetPh': 'Rue et numéro',
  'checkout.shippingTitle': 'Livraison',
  'checkout.standardDelivery': 'Livraison standard',
  'checkout.billingTitle': 'Adresse de facturation',
  'checkout.sameAsShipping': 'Identique à la livraison',
  'checkout.secureCheckout': 'Paiement sécurisé via Stripe',
  'checkout.buyerProtection': "Droit de rétractation de 14 jours",
  'checkout.firstNamePh': 'Marie',
  'checkout.lastNamePh': 'Dupont',
  'checkout.processingBtn': 'Traitement…',
  'checkout.termsShort': 'CGV',
  'checkout.privacyShort': 'Confidentialité',
  'checkout.detailsStep': 'Détails',
  'checkout.shippingBilling': 'Livraison & facturation',
  'checkout.paymentStep': 'Paiement',
  'checkout.secureViaStripe': 'Sécurisé via Stripe',
  'checkout.acceptTerms': 'J\'accepte les',
  'checkout.and': 'et la',
  'register.firstNamePh': 'Jean',
  'register.lastNamePh': 'Dupont',
  'register.termsLink': 'Conditions d\'utilisation',
  'register.privacyLink': 'Politique de confidentialité',
  'product.clickToZoom': 'Cliquer pour zoomer',
  'product.deliveryEstimate': 'Estimation de livraison',
  'product.selectCountry': 'Sélectionnez votre pays',
  'product.inStockShort': 'En stock',
  'product.outOfStockShort': 'Rupture de stock',
  'product.askQuestion': 'Poser une question',
  'product.askQuestionPh': 'Bonjour, je voudrais savoir si cette pièce est compatible avec ma voiture.',
  'product.soldBy': 'Vendu par',
  'product.yourReview': 'Votre avis',
  'product.reviewTitlePh': 'Résumez votre expérience',
  'product.reviewBodyPh': 'Partagez votre expérience avec cette pièce — montage, qualité, livraison…',
  'product.noReviewsYet': 'Aucun avis pour le moment.',
  'product.beFirstReview': 'Soyez le premier à laisser un avis !',
  'product.notFound': 'Produit introuvable',
  'product.browseAll': 'Voir toutes les pièces',
  'product.qualityAssessment': 'Évaluation de la qualité',
  'product.aiAssessed': 'Évalué par IA à partir des photos',
  'product.aiDisclaimer': 'Estimation visuelle automatisée — à vérifier sur les photos.',
  'product.newSeller': 'Nouveau vendeur',
  'product.description': 'Description du produit',
  'product.keyFeatures': 'Caractéristiques',
  'product.compatibility': 'Compatibilité véhicule',
  'product.oemNumbersTitle': 'Numéros OEM',
  'product.totalSales': 'Ventes totales',
  'product.aboutSeller': 'À propos du vendeur',
  'product.moreFromSeller': 'Plus de ce vendeur',
  'product.youMayAlsoLike': 'Vous pourriez aussi aimer',
  'product.copyOem': 'Copier le code OEM',
  'product.securePayment': 'Paiement sécurisé',
  'product.newLabel': 'Nouveau',
  'product.sellerInfoNa': 'Informations vendeur indisponibles',
  'home.heroBadge': '4,2 M+ pièces disponibles',
  'home.heroTitle1': 'Trouvez votre',
  'home.heroTitle2': 'pièce auto',
  'home.heroPara': "Une boutique en ligne européenne de pièces auto d'occasion et reconditionnées de qualité. Recherchez par code OEM ou modèle de véhicule.",
  'home.searchPlaceholder': 'Entrez le code OEM ou numéro de pièce (ex. OEM-A123-4567)',
  'home.searchByVehicle': 'Rechercher par véhicule',
  'home.searchByVehicleSub': 'Sélectionnez votre voiture pour trouver des pièces compatibles',
  'home.makeLabel': 'Marque',
  'home.modelLabel': 'Modèle',
  'home.generationLabel': 'Génération',
  'home.partNameLabel': 'Nom de la pièce',
  'home.selectMake': 'Choisir une marque',
  'home.selectModel': 'Choisir un modèle',
  'home.selectGeneration': 'Choisir une génération',
  'home.partPlaceholder': 'ex. Plaquettes, Alternateur…',
  'home.searchPartsBtn': 'Rechercher des pièces',
  'home.browseByCategoryTitle': 'Parcourir par catégorie',
  'home.browseByCategorySub': 'Trouver des pièces organisées par type',
  'common.viewAll': 'Voir tout',
  'header.shipWithin': 'Expédition sous 72 heures ouvrées',
  'header.returns14': 'Retour sous 14 jours',
  'header.deliveryEU': "Livraison dans l'UE, au Royaume-Uni et en Norvège",
  'header.inclVat': 'TVA incluse',
  'header.exclVat': 'Hors TVA',
  'cat.air-conditioning-heating-system-radiators': 'Climatisation, Chauffage & Radiateurs',
  'cat.body-body-parts-hook': 'Carrosserie & Capot',
  'cat.brake-system': 'Système de freinage',
  'cat.cabin-interior': 'Habitacle & Intérieur',
  'cat.devices-switches-electronic-system': 'Électrique & Électronique',
  'cat.door': 'Portes',
  'cat.engine': 'Moteur',
  'cat.exterior-front-body-parts': 'Carrosserie avant',
  'cat.exterior-rear-body-parts': 'Carrosserie arrière',
  'cat.front-axle': 'Essieu avant',
  'cat.fuel-mixture-system': 'Système de carburant',
  'cat.gas-exhaust-system': 'Système d\'échappement',
  'cat.gearbox-clutch-transmission': 'Boîte, Embrayage & Transmission',
  'cat.glass': 'Vitres',
  'cat.headlight-headlamp-washing-cleaning-system': 'Phares & Lave-glaces',
  'cat.lighting-system': 'Éclairage',
  'cat.other-parts': 'Autres pièces',
  'cat.rear-axle': 'Essieu arrière',
  'cat.wheels-tires-caps': 'Roues & Pneus',
};

const es = {
  'nav.home': 'Inicio',
  'nav.allParts': 'Todas las piezas',
  'nav.cart': 'Carrito',
  'nav.myAccount': 'Mi cuenta',
  'nav.myOrders': 'Mis pedidos',
  'nav.sellerPortal': 'Portal de vendedor',
  'nav.adminPanel': 'Panel de administrador',
  'nav.login': 'Iniciar sesión',
  'nav.register': 'Registrarse',
  'nav.logout': 'Cerrar sesión',
  'nav.makes': 'Marcas de vehículos',
  'header.freeShipping': "Entrega rápida a UE, RU y Noruega",
  'header.returns': 'Devoluciones en 14 días',
  'header.light': 'Claro',
  'header.dark': 'Oscuro',
  'header.searchPlaceholder': 'Buscar por número de pieza, código OEM o palabra clave...',
  'header.searchMobile': 'Buscar piezas...',
  'search.partsFound': '{count} piezas encontradas',
  'search.sortBy': 'Ordenar por',
  'search.relevance': 'Relevancia',
  'search.priceLowHigh': 'Precio: de bajo a alto',
  'search.priceHighLow': 'Precio: de alto a bajo',
  'search.newest': 'Más reciente',
  'search.priceRange': 'Rango de precios',
  'search.make': 'Marca',
  'search.model': 'Modelo',
  'search.year': 'Año',
  'search.category': 'Categoría',
  'search.subcategory': 'Subcategoría',
  'search.condition': 'Condición',
  'search.allMakes': 'Todas las marcas',
  'search.allModels': 'Todos los modelos',
  'search.allYears': 'Todos los años',
  'search.allCategories': 'Todas las categorías',
  'search.allSubcategories': 'Todas las subcategorías',
  'search.allConditions': 'Todas las condiciones',
  'search.clearFilters': 'Limpiar todos los filtros',
  'search.noResults': 'No se encontraron piezas que coincidan con sus criterios',
  'search.noResultsHint': 'Intente ampliar su búsqueda o ajustar los filtros',
  'search.addToCart': 'Añadir al carrito',
  'product.addToCart': 'Añadir al carrito',
  'product.freeShipping': "Envío a UE, RU y Noruega",
  'product.reviews': 'Opiniones',
  'product.writeReview': 'Escribir opinión',
  'product.signInReview': 'Inicie sesión para escribir una opinión',
  'product.noReviews': 'Sin opiniones aún. ¡Sea el primero!',
  'product.seller': 'Vendedor',
  'product.condition': 'Condición',
  'product.oemCodes': 'Códigos OEM',
  'product.inStock': 'En stock ({qty} disponible)',
  'product.outOfStock': 'Sin stock',
  'product.reviewTitle': 'Título',
  'product.reviewContent': 'Opinión',
  'product.submitReview': 'Enviar opinión',
  'product.avgRating': 'Puntuación media',
  'product.ratingDist': 'Distribución de puntuaciones',
  'cart.title': 'Carrito de compras',
  'cart.empty': 'Su carrito está vacío',
  'cart.emptyHint': 'Explore nuestra selección de repuestos de automóviles',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Envío',
  'cart.total': 'Total',
  'cart.checkout': 'Proceder al pago',
  'cart.each': 'por unidad',
  'cart.continueShopping': 'Continuar compras',
  'cart.freeShipping': 'Envío calculado en el pago',
  'checkout.orderSummary': 'Resumen del pedido',
  'checkout.subtotal': 'Subtotal',
  'checkout.shipping': 'Envío',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Realizar pedido',
  'checkout.processing': 'Procesando...',
  'checkout.shippingInfo': 'Información de envío',
  'checkout.billingInfo': 'Información de facturación',
  'checkout.paymentInfo': 'Información de pago',
  'checkout.firstName': 'Nombre',
  'checkout.lastName': 'Apellido',
  'checkout.email': 'Correo electrónico',
  'checkout.address': 'Dirección',
  'checkout.city': 'Ciudad',
  'checkout.country': 'País',
  'checkout.postalCode': 'Código postal',
  'checkout.cardNumber': 'Número de tarjeta',
  'checkout.expiryDate': 'Fecha de caducidad',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Misma que la dirección de envío',
  'customer.orders': 'Pedidos',
  'customer.messages': 'Mensajes',
  'customer.returns': 'Devoluciones',
  'customer.orderHistory': 'Historial de pedidos',
  'customer.noOrders': 'Sin pedidos aún',
  'customer.orderNo': 'Pedido #',
  'customer.orderDate': 'Fecha',
  'customer.orderStatus': 'Estado',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Ver detalles',
  'customer.backToOrders': 'Volver a los pedidos',
  'customer.orderDetail': 'Detalles del pedido',
  'customer.requestReturn': 'Solicitar devolución',
  'customer.returnReason': 'Motivo de la devolución',
  'customer.returnDescription': 'Detalles adicionales (opcional)',
  'customer.submitReturn': 'Enviar solicitud de devolución',
  'customer.returnSuccess': 'Su solicitud de devolución se ha enviado correctamente.',
  'customer.returnPending': 'Un representante la revisará en poco tiempo.',
  'customer.conversations': 'Conversaciones',
  'customer.noMessages': 'Sin conversaciones aún',
  'customer.send': 'Enviar',
  'customer.returnStatus.pending': 'Pendiente',
  'customer.returnStatus.approved': 'Aprobada',
  'customer.returnStatus.rejected': 'Rechazada',
  'customer.returnStatus.processing': 'En proceso',
  'customer.returnId': 'ID de devolución',
  'customer.orderId': 'ID de pedido',
  'customer.reason': 'Motivo',
  'customer.description': 'Descripción',
  'customer.noReturns': 'Sin devoluciones enviadas aún',
  'customer.noReturnsHint': 'Si necesita devolver un artículo, vaya a los detalles de su pedido y haga clic en "Solicitar devolución".',
  'vendor.dashboard': 'Panel de control',
  'vendor.myListings': 'Mis anuncios',
  'vendor.orders': 'Pedidos',
  'vendor.addListing': 'Añadir anuncio',
  'vendor.bulkImport': 'Importación masiva',
  'vendor.revenue': 'Ingresos',
  'vendor.totalOrders': 'Pedidos',
  'vendor.totalListings': 'Anuncios',
  'vendor.totalViews': 'Vistas',
  'vendor.recentOrders': 'Pedidos recientes',
  'vendor.noOrders': 'Sin pedidos aún',
  'vendor.editListing': 'Editar',
  'vendor.deleteListing': 'Eliminar',
  'vendor.priceLabel': 'Precio ({symbol}) *',
  'vendor.importCSV': 'Importar anuncios CSV',
  'vendor.downloadTemplate': 'Descargar plantilla CSV',
  'vendor.chooseFile': 'Elegir archivo CSV',
  'vendor.startImport': 'Iniciar importación',
  'vendor.instructions': 'Cómo importar',
  'vendor.previewData': 'Vista previa (primeras 5 filas)',
  'vendor.importResults': 'Resultados de importación',
  'vendor.listingsCreated': 'anuncios creados correctamente',
  'vendor.errors': 'Errores',
  'vendor.noFile': 'Sin archivo seleccionado',
  'vendor.requiredColumns': 'Suba un archivo CSV con las siguientes columnas. Solo el título y el precio son requeridos.',
  'admin.users': 'Usuarios',
  'admin.sellers': 'Vendedores',
  'admin.listings': 'Anuncios',
  'admin.orders': 'Pedidos',
  'admin.approve': 'Aprobar',
  'admin.suspend': 'Suspender',
  'admin.delete': 'Eliminar',
  'admin.totalUsers': 'Usuarios totales',
  'admin.totalSellers': 'Vendedores totales',
  'admin.totalListings': 'Anuncios totales',
  'admin.totalOrders': 'Pedidos totales',
  'admin.pendingSellers': 'Vendedores pendientes',
  'admin.email': 'Correo electrónico',
  'admin.name': 'Nombre',
  'admin.role': 'Rol',
  'admin.status': 'Estado',
  'admin.actions': 'Acciones',
  'admin.company': 'Empresa',
  'admin.rating': 'Puntuación',
  'admin.sales': 'Ventas',
  'admin.title': 'Título',
  'admin.price': 'Precio',
  'admin.category': 'Categoría',
  'admin.orderNo': 'Pedido #',
  'admin.buyer': 'Comprador',
  'admin.date': 'Fecha',
  'admin.total': 'Total',
  'home.heroTitle': "Tienda online de repuestos de auto usados · 4,2 M+ piezas",
  'home.heroSubtitle': "Encuentre piezas originales y de repuesto para cualquier vehículo europeo. Envío a la UE, Reino Unido y Noruega.",
  'home.searchHero': 'Buscar por número de pieza, marca o palabra clave',
  'home.featuredParts': 'Piezas destacadas',
  'home.viewAll': 'Ver todas las piezas',
  'home.freeShipping': "Entrega UE, RU y Noruega",
  'home.freeShippingDesc': "Entrega a la UE, Reino Unido y Noruega",
  'home.returns': 'Devoluciones en 14 días',
  'home.returnsDesc': 'Política de devolución sin complicaciones',
  'home.securePayment': 'Pago seguro',
  'home.securePaymentDesc': 'Transacciones cifradas SSL',
  'home.qualityParts': 'Piezas de calidad',
  'home.qualityPartsDesc': "Piezas originales del fabricante",
  'home.whyChoose': '¿Por qué elegir zivu.eu?',
  'home.trustedSellers': "Compatibilidad verificada",
  'home.trustedSellersDesc': "Cada pieza se fotografía y se comprueba su compatibilidad antes de publicarse",
  'makes.title': 'Marcas de vehículos',
  'makes.subtitle': 'Explorar piezas por fabricante de vehículos',
  'makes.searchPlaceholder': 'Buscar marcas...',
  'makes.popular': 'Marcas populares',
  'makeDetail.subtitle': 'Explorar modelos y encontrar piezas',
  'makeDetail.selectModel': 'Seleccionar modelo',
  'makeDetail.selectYear': 'Seleccionar año',
  'footer.tagline': "Tienda online de repuestos de automóviles usados y reacondicionados. Envío a la UE, Reino Unido y Noruega.",
  'footer.shop': 'Tienda',
  'footer.allParts': 'Todos los repuestos',
  'footer.engineParts': 'Piezas de motor',
  'footer.bodyParts': 'Piezas de carrocería',
  'footer.electrical': 'Eléctrico',
  'footer.refurbished': 'Reacondicionado',
  'footer.information': 'Información',
  'footer.aboutUs': 'Sobre nosotros',
  'footer.deliveryInfo': 'Info de entrega',
  'footer.returnsRefunds': 'Devoluciones y reembolsos',
  'footer.paymentMethods': 'Métodos de pago',
  'footer.contactUs': 'Contáctenos',
  'footer.support': 'Soporte',
  'footer.helpCenter': 'Centro de ayuda',
  'footer.shippingInfo': 'Info de envío',
  'footer.faq': 'Preguntas frecuentes',
  'footer.warranty': 'Garantía',
  'footer.sellers': 'Vendedores',
  'footer.sellOnZivu': 'Vender en zivu.eu',
  'footer.sellerPortal': 'Portal del vendedor',
  'footer.sellerTerms': 'Condiciones del vendedor',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Condiciones',
  'footer.euMarketplace': "UE · RU · Noruega",
  'login.welcomeBack': 'Bienvenido de nuevo',
  'login.signInToContinue': 'Inicia sesión en tu cuenta para continuar',
  'login.emailLabel': 'Correo electrónico',
  'login.passwordLabel': 'Contraseña',
  'login.emailPh': 'tu@ejemplo.com',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.signingIn': 'Iniciando sesión…',
  'login.signInBtn': 'Iniciar sesión',
  'login.orContinueWith': 'O continuar con',
  'login.continueWithGoogle': 'Continuar con Google',
  'login.noAccount': '¿No tienes cuenta?',
  'login.signUp': 'Regístrate',
  'register.title': 'Crear cuenta',
  'register.subtitle': "Crea una cuenta para comprar piezas de auto usadas y reacondicionadas",
  'register.firstName': 'Nombre',
  'register.lastName': 'Apellidos',
  'register.emailLabel': 'Correo electrónico',
  'register.passwordLabel': 'Contraseña',
  'register.confirmPassword': 'Confirmar contraseña',
  'register.creating': 'Creando cuenta…',
  'register.createBtn': 'Crear cuenta',
  'register.alreadyHave': '¿Ya tienes una cuenta?',
  'register.signIn': 'Iniciar sesión',
  'register.byCreating': 'Al crear una cuenta, aceptas nuestros',
  'customer.nav.overview': 'Resumen',
  'customer.nav.myOrders': 'Mis pedidos',
  'customer.nav.myGarage': 'Mi garaje',
  'customer.nav.myReviews': 'Mis opiniones',
  'customer.nav.favorites': 'Favoritos',
  'customer.nav.messages': 'Mensajes',
  'customer.nav.returns': 'Devoluciones',
  'customer.nav.addresses': 'Direcciones',
  'customer.nav.settings': 'Configuración',
  'customer.dashboardSubtitle': 'Gestiona tus pedidos y la configuración de tu cuenta',
  'customer.recentOrders': 'Pedidos recientes',
  'customer.noOrdersYet': 'Aún no hay pedidos',
  'customer.myOrdersTitle': 'Mis pedidos',
  'customer.trackManage': 'Rastrea y gestiona tus pedidos',
  'customer.browseParts': 'Explorar piezas',
  'customer.orderNotFound': 'Pedido no encontrado',
  'customer.cancelOrderTitle': '¿Cancelar este pedido?',
  'customer.cancelOrderDesc': 'Esta acción no se puede deshacer. Tu pago será reembolsado.',
  'customer.keepOrder': 'Mantener pedido',
  'customer.statusHistory': 'Historial de estado',
  'customer.orderItems': 'Artículos del pedido',
  'customer.discount': 'Descuento',
  'customer.shippingAddressTitle': 'Dirección de envío',
  'customer.billingAddressTitle': 'Dirección de facturación',
  'customer.needToReturn': '¿Necesitas devolver este pedido?',
  'customer.returnRequestForm': 'Formulario de devolución',
  'customer.cancelBtn': 'Cancelar',
  'customer.returnSubmitted': 'Solicitud de devolución enviada',
  'customer.returnReviewMsg': 'Nuestro equipo revisará tu solicitud y se pondrá en contacto pronto.',
  'customer.newMessageTitle': 'Nuevo mensaje',
  'customer.sending': 'Enviando…',
  'customer.sendMessage': 'Enviar mensaje',
  'customer.messagesTitle': 'Mensajes',
  'customer.myFavoritesTitle': 'Mis favoritos',
  'customer.noFavoritesYet': 'Aún no hay favoritos',
  'customer.noTimelineData': 'No hay datos de cronología disponibles',
  'customer.returnsTitle': 'Devoluciones',
  'customer.noReturnsYet': 'Aún no hay devoluciones',
  'customer.myAddressesTitle': 'Mis direcciones',
  'customer.noAddressesSaved': 'Sin direcciones guardadas',
  'customer.defaultBadge': 'Predeterminada',
  'customer.businessAccount': 'Cuenta empresa',
  'customer.currentStatus': 'Estado actual',
  'customer.companyAddress': 'Dirección registrada de la empresa',
  'status.pending': 'Pendiente',
  'status.confirmed': 'Confirmado',
  'status.paid': 'Pagado',
  'status.processing': 'Procesando',
  'status.shipped': 'Enviado',
  'status.delivered': 'Entregado',
  'status.completed': 'Completado',
  'status.cancelled': 'Cancelado',
  'status.refunded': 'Reembolsado',
  'status.returnRequested': 'Devolución solicitada',
  'status.returning': 'Devolviendo',
  'status.returned': 'Devuelto',
  'status.returnRejected': 'Devolución rechazada',
  'cart.itemsSubtotalLabel': 'Subtotal de artículos',
  'cart.discountLabel': 'Descuento',
  'cart.allPricesVat': 'Todos los precios incluyen IVA',
  'cart.allPricesNet': 'Sin IVA — el comprador se autoliquida bajo inversión del sujeto pasivo',
  'cart.secureCheckout': 'Pago seguro con Stripe',
  'cart.orderSummary': 'Resumen del pedido',
  'checkout.title': 'Pago',
  'checkout.buyerType': 'Tipo de comprador',
  'checkout.private': 'Particular',
  'checkout.privateSub': 'Compra personal',
  'checkout.company': 'Empresa / Organización',
  'checkout.companySub': 'B2B con factura de IVA',
  'checkout.companyDetails': 'Datos de la empresa',
  'checkout.companyName': 'Nombre de la empresa',
  'checkout.companyNamePh': 'Acme S.L.',
  'checkout.vatNumberLabel': 'Número de IVA (recomendado)',
  'checkout.vatValidating': 'Validando número de IVA…',
  'checkout.streetPh': 'Calle y número',
  'checkout.shippingTitle': 'Envío',
  'checkout.standardDelivery': 'Envío estándar',
  'checkout.billingTitle': 'Dirección de facturación',
  'checkout.sameAsShipping': 'Misma que la dirección de envío',
  'checkout.secureCheckout': 'Pago seguro con Stripe',
  'checkout.buyerProtection': "Derecho de desistimiento de 14 días",
  'checkout.firstNamePh': 'María',
  'checkout.lastNamePh': 'García',
  'checkout.processingBtn': 'Procesando…',
  'checkout.termsShort': 'Términos',
  'checkout.privacyShort': 'Privacidad',
  'checkout.detailsStep': 'Datos',
  'checkout.shippingBilling': 'Envío y facturación',
  'checkout.paymentStep': 'Pago',
  'checkout.secureViaStripe': 'Seguro vía Stripe',
  'checkout.acceptTerms': 'Acepto los',
  'checkout.and': 'y la',
  'register.firstNamePh': 'Juan',
  'register.lastNamePh': 'Pérez',
  'register.termsLink': 'Términos del servicio',
  'register.privacyLink': 'Política de privacidad',
  'product.clickToZoom': 'Haga clic para ampliar',
  'product.deliveryEstimate': 'Estimación de entrega',
  'product.selectCountry': 'Seleccione su país',
  'product.inStockShort': 'En stock',
  'product.outOfStockShort': 'Agotado',
  'product.askQuestion': 'Hacer una pregunta',
  'product.askQuestionPh': 'Hola, tengo una pregunta sobre esta pieza. ¿Es compatible con mi coche?',
  'product.soldBy': 'Vendido por',
  'product.yourReview': 'Tu opinión',
  'product.reviewTitlePh': 'Resume tu experiencia',
  'product.reviewBodyPh': 'Comparte tu experiencia con esta pieza — ajuste, calidad, entrega…',
  'product.noReviewsYet': 'Aún no hay opiniones.',
  'product.beFirstReview': '¡Sé el primero en opinar sobre esta pieza!',
  'product.notFound': 'Producto no encontrado',
  'product.browseAll': 'Ver todas las piezas',
  'product.qualityAssessment': 'Evaluación de calidad',
  'product.aiAssessed': 'Evaluado por IA a partir de fotos',
  'product.aiDisclaimer': 'Estimación visual automática: verifíquela con las fotos.',
  'product.newSeller': 'Vendedor nuevo',
  'product.description': 'Descripción del producto',
  'product.keyFeatures': 'Características',
  'product.compatibility': 'Compatibilidad de vehículo',
  'product.oemNumbersTitle': 'Números OEM',
  'product.totalSales': 'Ventas totales',
  'product.aboutSeller': 'Sobre el vendedor',
  'product.moreFromSeller': 'Más de este vendedor',
  'product.youMayAlsoLike': 'También te puede interesar',
  'product.copyOem': 'Copiar código OEM',
  'product.securePayment': 'Pago seguro',
  'product.newLabel': 'Nuevo',
  'product.sellerInfoNa': 'Información del vendedor no disponible',
  'home.heroBadge': '4,2 M+ piezas disponibles',
  'home.heroTitle1': 'Encuentra tu',
  'home.heroTitle2': 'pieza de auto',
  'home.heroPara': "Una tienda online europea de piezas de auto usadas y reacondicionadas de calidad. Busca por código OEM o modelo de vehículo.",
  'home.searchPlaceholder': 'Ingrese el código OEM o número de pieza (ej. OEM-A123-4567)',
  'home.searchByVehicle': 'Buscar por vehículo',
  'home.searchByVehicleSub': 'Seleccione su coche para encontrar piezas compatibles',
  'home.makeLabel': 'Marca',
  'home.modelLabel': 'Modelo',
  'home.generationLabel': 'Generación',
  'home.partNameLabel': 'Nombre de la pieza',
  'home.selectMake': 'Seleccionar marca',
  'home.selectModel': 'Seleccionar modelo',
  'home.selectGeneration': 'Seleccionar generación',
  'home.partPlaceholder': 'ej. Pastillas de freno, Alternador…',
  'home.searchPartsBtn': 'Buscar piezas',
  'home.browseByCategoryTitle': 'Explorar por categoría',
  'home.browseByCategorySub': 'Encuentra piezas organizadas por tipo',
  'common.viewAll': 'Ver todo',
  'header.shipWithin': 'Enviamos en 72 horas laborables',
  'header.returns14': 'Devoluciones en 14 días',
  'header.deliveryEU': "Envío a la UE, Reino Unido y Noruega",
  'header.inclVat': 'IVA incluido',
  'header.exclVat': 'Sin IVA',
  'cat.air-conditioning-heating-system-radiators': 'Aire acondicionado, calefacción y radiadores',
  'cat.body-body-parts-hook': 'Carrocería y capó',
  'cat.brake-system': 'Sistema de frenos',
  'cat.cabin-interior': 'Cabina e interior',
  'cat.devices-switches-electronic-system': 'Eléctrica y electrónica',
  'cat.door': 'Puertas',
  'cat.engine': 'Motor',
  'cat.exterior-front-body-parts': 'Carrocería delantera',
  'cat.exterior-rear-body-parts': 'Carrocería trasera',
  'cat.front-axle': 'Eje delantero',
  'cat.fuel-mixture-system': 'Sistema de combustible',
  'cat.gas-exhaust-system': 'Sistema de escape',
  'cat.gearbox-clutch-transmission': 'Caja, embrague y transmisión',
  'cat.glass': 'Cristales',
  'cat.headlight-headlamp-washing-cleaning-system': 'Faros y limpiaparabrisas',
  'cat.lighting-system': 'Iluminación',
  'cat.other-parts': 'Otras piezas',
  'cat.rear-axle': 'Eje trasero',
  'cat.wheels-tires-caps': 'Ruedas y neumáticos',
};

const it = {
  'nav.home': 'Home',
  'nav.allParts': 'Tutte le parti',
  'nav.cart': 'Carrello',
  'nav.myAccount': 'Il mio account',
  'nav.myOrders': 'I miei ordini',
  'nav.sellerPortal': 'Portale venditore',
  'nav.adminPanel': 'Pannello admin',
  'nav.login': 'Accedi',
  'nav.register': 'Registrati',
  'nav.logout': 'Esci',
  'nav.makes': 'Marche di veicoli',
  'header.freeShipping': "Consegna rapida in UE, Regno Unito e Norvegia",
  'header.returns': 'Resi entro 14 giorni',
  'header.light': 'Chiaro',
  'header.dark': 'Scuro',
  'header.searchPlaceholder': 'Cerca per numero di parte, codice OEM o parola chiave...',
  'header.searchMobile': 'Cerca parti...',
  'search.partsFound': '{count} parti trovate',
  'search.sortBy': 'Ordina per',
  'search.relevance': 'Rilevanza',
  'search.priceLowHigh': 'Prezzo: dal più basso al più alto',
  'search.priceHighLow': 'Prezzo: dal più alto al più basso',
  'search.newest': 'Più recente',
  'search.priceRange': 'Intervallo di prezzo',
  'search.make': 'Marca',
  'search.model': 'Modello',
  'search.year': 'Anno',
  'search.category': 'Categoria',
  'search.subcategory': 'Sottocategoria',
  'search.condition': 'Condizione',
  'search.allMakes': 'Tutte le marche',
  'search.allModels': 'Tutti i modelli',
  'search.allYears': 'Tutti gli anni',
  'search.allCategories': 'Tutte le categorie',
  'search.allSubcategories': 'Tutte le sottocategorie',
  'search.allConditions': 'Tutte le condizioni',
  'search.clearFilters': 'Cancellare tutti i filtri',
  'search.noResults': 'Nessuna parte trovata che corrisponda ai tuoi criteri',
  'search.noResultsHint': 'Prova a allargare la tua ricerca o a modificare i filtri',
  'search.addToCart': 'Aggiungi al carrello',
  'product.addToCart': 'Aggiungi al carrello',
  'product.freeShipping': "Spedizione in UE, Regno Unito e Norvegia",
  'product.reviews': 'Opinioni',
  'product.writeReview': 'Scrivi opinione',
  'product.signInReview': "Accedi per scrivere un'opinione",
  'product.noReviews': 'Nessuna opinione ancora. Sii il primo!',
  'product.seller': 'Venditore',
  'product.condition': 'Condizione',
  'product.oemCodes': 'Codici OEM',
  'product.inStock': 'In stock ({qty} disponibile)',
  'product.outOfStock': 'Esaurito',
  'product.reviewTitle': 'Titolo',
  'product.reviewContent': 'Opinione',
  'product.submitReview': "Invia opinione",
  'product.avgRating': 'Voto medio',
  'product.ratingDist': 'Distribuzione dei voti',
  'cart.title': 'Carrello acquisti',
  'cart.empty': 'Il tuo carrello è vuoto',
  'cart.emptyHint': 'Sfoglia la nostra selezione di ricambio auto',
  'cart.subtotal': 'Subtotale',
  'cart.shipping': 'Spedizione',
  'cart.total': 'Totale',
  'cart.checkout': 'Procedere al pagamento',
  'cart.each': 'per unità',
  'cart.continueShopping': 'Continuare acquisti',
  'cart.freeShipping': 'Consegna calcolata al checkout',
  'checkout.orderSummary': 'Riepilogo ordine',
  'checkout.subtotal': 'Subtotale',
  'checkout.shipping': 'Spedizione',
  'checkout.total': 'Totale',
  'checkout.placeOrder': 'Effettua ordine',
  'checkout.processing': 'Elaborazione...',
  'checkout.shippingInfo': 'Informazioni di spedizione',
  'checkout.billingInfo': 'Informazioni di fatturazione',
  'checkout.paymentInfo': 'Informazioni di pagamento',
  'checkout.firstName': 'Nome',
  'checkout.lastName': 'Cognome',
  'checkout.email': 'Email',
  'checkout.address': 'Indirizzo',
  'checkout.city': 'Città',
  'checkout.country': 'Paese',
  'checkout.postalCode': 'CAP',
  'checkout.cardNumber': 'Numero carta',
  'checkout.expiryDate': 'Data di scadenza',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Stesso di indirizzo di spedizione',
  'customer.orders': 'Ordini',
  'customer.messages': 'Messaggi',
  'customer.returns': 'Resi',
  'customer.orderHistory': 'Storico ordini',
  'customer.noOrders': 'Nessun ordine ancora',
  'customer.orderNo': 'Ordine #',
  'customer.orderDate': 'Data',
  'customer.orderStatus': 'Stato',
  'customer.orderTotal': 'Totale',
  'customer.viewDetails': 'Vedi dettagli',
  'customer.backToOrders': 'Torna agli ordini',
  'customer.orderDetail': 'Dettagli ordine',
  'customer.requestReturn': 'Richiedere reso',
  'customer.returnReason': 'Motivo del reso',
  'customer.returnDescription': 'Dettagli aggiuntivi (opzionale)',
  'customer.submitReturn': 'Invia richiesta di reso',
  'customer.returnSuccess': 'La sua richiesta di reso è stata inviata con successo.',
  'customer.returnPending': 'Un rappresentante la verificherà a breve.',
  'customer.conversations': 'Conversazioni',
  'customer.noMessages': 'Nessuna conversazione ancora',
  'customer.send': 'Invia',
  'customer.returnStatus.pending': 'In attesa',
  'customer.returnStatus.approved': 'Approvato',
  'customer.returnStatus.rejected': 'Rifiutato',
  'customer.returnStatus.processing': 'In elaborazione',
  'customer.returnId': 'ID reso',
  'customer.orderId': 'ID ordine',
  'customer.reason': 'Motivo',
  'customer.description': 'Descrizione',
  'customer.noReturns': 'Nessun reso inviato ancora',
  'customer.noReturnsHint': 'Se è necessario restituire un articolo, vai ai dettagli del tuo ordine e clicca su "Richiedere reso".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'I miei annunci',
  'vendor.orders': 'Ordini',
  'vendor.addListing': 'Aggiungere annuncio',
  'vendor.bulkImport': 'Importazione masse',
  'vendor.revenue': 'Entrate',
  'vendor.totalOrders': 'Ordini',
  'vendor.totalListings': 'Annunci',
  'vendor.totalViews': 'Visualizzazioni',
  'vendor.recentOrders': 'Ordini recenti',
  'vendor.noOrders': 'Nessun ordine ancora',
  'vendor.editListing': 'Modifica',
  'vendor.deleteListing': 'Elimina',
  'vendor.priceLabel': 'Prezzo ({symbol}) *',
  'vendor.importCSV': 'Importare annunci CSV',
  'vendor.downloadTemplate': 'Scaricare modello CSV',
  'vendor.chooseFile': 'Scegliere file CSV',
  'vendor.startImport': 'Iniziare importazione',
  'vendor.instructions': 'Come importare',
  'vendor.previewData': 'Anteprima (primi 5 righe)',
  'vendor.importResults': 'Risultati importazione',
  'vendor.listingsCreated': 'annunci creati con successo',
  'vendor.errors': 'Errori',
  'vendor.noFile': 'Nessun file selezionato',
  'vendor.requiredColumns': 'Carica un file CSV con le seguenti colonne. Solo titolo e prezzo sono obbligatori.',
  'admin.users': 'Utenti',
  'admin.sellers': 'Venditori',
  'admin.listings': 'Annunci',
  'admin.orders': 'Ordini',
  'admin.approve': 'Approvare',
  'admin.suspend': 'Sospendere',
  'admin.delete': 'Eliminare',
  'admin.totalUsers': 'Utenti totali',
  'admin.totalSellers': 'Venditori totali',
  'admin.totalListings': 'Annunci totali',
  'admin.totalOrders': 'Ordini totali',
  'admin.pendingSellers': 'Venditori in attesa',
  'admin.email': 'Email',
  'admin.name': 'Nome',
  'admin.role': 'Ruolo',
  'admin.status': 'Stato',
  'admin.actions': 'Azioni',
  'admin.company': 'Azienda',
  'admin.rating': 'Voto',
  'admin.sales': 'Vendite',
  'admin.title': 'Titolo',
  'admin.price': 'Prezzo',
  'admin.category': 'Categoria',
  'admin.orderNo': 'Ordine #',
  'admin.buyer': 'Acquirente',
  'admin.date': 'Data',
  'admin.total': 'Totale',
  'home.heroTitle': "Negozio online di ricambi auto usati · 4,2 Mln+ ricambi",
  'home.heroSubtitle': "Trova parti originali e di ricambio per qualsiasi veicolo europeo. Spedizione in UE, Regno Unito e Norvegia.",
  'home.searchHero': 'Cerca per numero di parte, marca o parola chiave',
  'home.featuredParts': 'Parti in evidenza',
  'home.viewAll': 'Vedi tutte le parti',
  'home.freeShipping': "Consegna UE, Regno Unito e Norvegia",
  'home.freeShippingDesc': "Consegna in UE, Regno Unito e Norvegia",
  'home.returns': 'Resi entro 14 giorni',
  'home.returnsDesc': 'Politica di reso senza problemi',
  'home.securePayment': 'Pagamento sicuro',
  'home.securePaymentDesc': 'Transazioni cifrate SSL',
  'home.qualityParts': 'Parti di qualità',
  'home.qualityPartsDesc': "Ricambi originali del produttore",
  'home.whyChoose': 'Perché scegliere zivu.eu?',
  'home.trustedSellers': "Compatibilità verificata",
  'home.trustedSellersDesc': "Ogni ricambio viene fotografato e la compatibilità verificata prima della pubblicazione",
  'makes.title': 'Marche di veicoli',
  'makes.subtitle': 'Sfogliare parti per produttore di veicoli',
  'makes.searchPlaceholder': 'Cercare marche...',
  'makes.popular': 'Marche popolari',
  'makeDetail.subtitle': 'Sfogliare modelli e trovare parti',
  'makeDetail.selectModel': 'Selezionare modello',
  'makeDetail.selectYear': 'Selezionare anno',
  'footer.tagline': "Negozio online di ricambi auto usati e ricondizionati. Spedizione in UE, Regno Unito e Norvegia.",
  'footer.shop': 'Negozio',
  'footer.allParts': 'Tutti i ricambi',
  'footer.engineParts': 'Ricambi motore',
  'footer.bodyParts': 'Ricambi carrozzeria',
  'footer.electrical': 'Elettrico',
  'footer.refurbished': 'Ricondizionato',
  'footer.information': 'Informazioni',
  'footer.aboutUs': 'Chi siamo',
  'footer.deliveryInfo': 'Info consegna',
  'footer.returnsRefunds': 'Resi e rimborsi',
  'footer.paymentMethods': 'Metodi di pagamento',
  'footer.contactUs': 'Contattaci',
  'footer.support': 'Assistenza',
  'footer.helpCenter': 'Centro assistenza',
  'footer.shippingInfo': 'Info spedizione',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garanzia',
  'footer.sellers': 'Venditori',
  'footer.sellOnZivu': 'Vendi su zivu.eu',
  'footer.sellerPortal': 'Portale venditore',
  'footer.sellerTerms': 'Condizioni venditore',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Condizioni',
  'footer.euMarketplace': "UE · RU · Norvegia",
  'home.heroBadge': '4.2M+ ricambi disponibili',
  'home.heroTitle1': 'Trova il tuo',
  'home.heroTitle2': 'ricambio auto',
  'home.heroPara': "Un negozio online europeo di ricambi auto usati e ricondizionati di qualità. Cerca per codice OEM o modello del veicolo.",
  'home.searchPlaceholder': 'Inserisci il codice OEM o numero ricambio (es. OEM-A123-4567)',
  'home.searchByVehicle': 'Cerca per veicolo',
  'home.searchByVehicleSub': 'Seleziona la tua auto per trovare ricambi compatibili',
  'home.makeLabel': 'Marca',
  'home.modelLabel': 'Modello',
  'home.generationLabel': 'Generazione',
  'home.partNameLabel': 'Nome ricambio',
  'home.selectMake': 'Seleziona marca',
  'home.selectModel': 'Seleziona modello',
  'home.selectGeneration': 'Seleziona generazione',
  'home.partPlaceholder': 'es. Pastiglie freni, Alternatore…',
  'home.searchPartsBtn': 'Cerca ricambi',
  'home.browseByCategoryTitle': 'Sfoglia per categoria',
  'home.browseByCategorySub': 'Trova ricambi organizzati per tipo',
  'common.viewAll': 'Vedi tutto',
  'header.shipWithin': 'Spedizione entro 72 ore lavorative',
  'header.returns14': 'Reso entro 14 giorni',
  'header.deliveryEU': "Consegna in UE, Regno Unito e Norvegia",
  'header.inclVat': 'IVA inclusa',
  'header.exclVat': 'IVA esclusa',
  'cat.air-conditioning-heating-system-radiators': 'Climatizzazione, riscaldamento e radiatori',
  'cat.body-body-parts-hook': 'Carrozzeria e cofano',
  'cat.brake-system': 'Impianto frenante',
  'cat.cabin-interior': 'Abitacolo e interni',
  'cat.devices-switches-electronic-system': 'Elettrico ed elettronico',
  'cat.door': 'Porte',
  'cat.engine': 'Motore',
  'cat.exterior-front-body-parts': 'Carrozzeria anteriore',
  'cat.exterior-rear-body-parts': 'Carrozzeria posteriore',
  'cat.front-axle': 'Assale anteriore',
  'cat.fuel-mixture-system': 'Impianto carburante',
  'cat.gas-exhaust-system': 'Impianto di scarico',
  'cat.gearbox-clutch-transmission': 'Cambio, frizione e trasmissione',
  'cat.glass': 'Vetri',
  'cat.headlight-headlamp-washing-cleaning-system': 'Fari e tergicristalli',
  'cat.lighting-system': 'Illuminazione',
  'cat.other-parts': 'Altri ricambi',
  'cat.rear-axle': 'Assale posteriore',
  'cat.wheels-tires-caps': 'Ruote e pneumatici',
};

const pl = {
  'nav.home': 'Strona główna',
  'nav.allParts': 'Wszystkie części',
  'nav.cart': 'Koszyk',
  'nav.myAccount': 'Moje konto',
  'nav.myOrders': 'Moje zamówienia',
  'nav.sellerPortal': 'Portal sprzedawcy',
  'nav.adminPanel': 'Panel administracyjny',
  'nav.login': 'Zaloguj się',
  'nav.register': 'Zarejestruj się',
  'nav.logout': 'Wyloguj się',
  'nav.makes': 'Marki pojazdów',
  'header.freeShipping': "Szybka dostawa do UE, Wielkiej Brytanii i Norwegii",
  'header.returns': 'Zwroty w ciągu 14 dni',
  'header.light': 'Jasny',
  'header.dark': 'Ciemny',
  'header.searchPlaceholder': 'Szukaj po numerze części, kodzie OEM lub słowie kluczowym...',
  'header.searchMobile': 'Szukaj części...',
  'search.partsFound': 'Znaleziono {count} części',
  'search.sortBy': 'Sortuj po',
  'search.relevance': 'Trafność',
  'search.priceLowHigh': 'Cena: od najniższej do najwyższej',
  'search.priceHighLow': 'Cena: od najwyższej do najniższej',
  'search.newest': 'Najnowsze',
  'search.priceRange': 'Zakres cen',
  'search.make': 'Marka',
  'search.model': 'Model',
  'search.year': 'Rok',
  'search.category': 'Kategoria',
  'search.subcategory': 'Podkategoria',
  'search.condition': 'Stan',
  'search.allMakes': 'Wszystkie marki',
  'search.allModels': 'Wszystkie modele',
  'search.allYears': 'Wszystkie lata',
  'search.allCategories': 'Wszystkie kategorie',
  'search.allSubcategories': 'Wszystkie podkategorie',
  'search.allConditions': 'Wszystkie stany',
  'search.clearFilters': 'Wyczyść wszystkie filtry',
  'search.noResults': 'Nie znaleziono części spełniających Twoje kryteria',
  'search.noResultsHint': 'Spróbuj rozszerzyć wyszukiwanie lub dostosować filtry',
  'search.addToCart': 'Dodaj do koszyka',
  'product.addToCart': 'Dodaj do koszyka',
  'product.freeShipping': "Wysyłka do UE, Wielkiej Brytanii i Norwegii",
  'product.reviews': 'Opinie',
  'product.writeReview': 'Napisz opinię',
  'product.signInReview': 'Zaloguj się, aby napisać opinię',
  'product.noReviews': 'Jeszcze żadnych opinii. Bądź pierwszy!',
  'product.seller': 'Sprzedawca',
  'product.condition': 'Stan',
  'product.oemCodes': 'Kody OEM',
  'product.inStock': 'Na stanie ({qty} dostępne)',
  'product.outOfStock': 'Brak na stanie',
  'product.reviewTitle': 'Tytuł',
  'product.reviewContent': 'Opinia',
  'product.submitReview': 'Wyślij opinię',
  'product.avgRating': 'Średnia ocena',
  'product.ratingDist': 'Rozkład ocen',
  'cart.title': 'Koszyk zakupów',
  'cart.empty': 'Twój koszyk jest pusty',
  'cart.emptyHint': 'Przejrzyć naszą ofertę części samochodowych',
  'cart.subtotal': 'Suma netto',
  'cart.shipping': 'Przesyłka',
  'cart.total': 'Suma brutto',
  'cart.checkout': 'Przejdź do płatności',
  'cart.each': 'za sztukę',
  'cart.continueShopping': 'Kontynuuj zakupy',
  'cart.freeShipping': 'Dostawa obliczana przy kasie',
  'checkout.orderSummary': 'Podsumowanie zamówienia',
  'checkout.subtotal': 'Suma netto',
  'checkout.shipping': 'Przesyłka',
  'checkout.total': 'Suma brutto',
  'checkout.placeOrder': 'Złóż zamówienie',
  'checkout.processing': 'Przetwarzanie...',
  'checkout.shippingInfo': 'Informacje o przesyłce',
  'checkout.billingInfo': 'Informacje rozliczeniowe',
  'checkout.paymentInfo': 'Informacje o płatności',
  'checkout.firstName': 'Imię',
  'checkout.lastName': 'Nazwisko',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adres',
  'checkout.city': 'Miasto',
  'checkout.country': 'Kraj',
  'checkout.postalCode': 'Kod pocztowy',
  'checkout.cardNumber': 'Numer karty',
  'checkout.expiryDate': 'Data wygaśnięcia',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'To samo co adres przesyłki',
  'customer.orders': 'Zamówienia',
  'customer.messages': 'Wiadomości',
  'customer.returns': 'Zwroty',
  'customer.orderHistory': 'Historia zamówień',
  'customer.noOrders': 'Jeszcze żadnych zamówień',
  'customer.orderNo': 'Zamówienie #',
  'customer.orderDate': 'Data',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Suma',
  'customer.viewDetails': 'Pokaż szczegóły',
  'customer.backToOrders': 'Wróć do zamówień',
  'customer.orderDetail': 'Szczegóły zamówienia',
  'customer.requestReturn': 'Wnioskować o zwrot',
  'customer.returnReason': 'Powód zwrotu',
  'customer.returnDescription': 'Dodatkowe szczegóły (optional)',
  'customer.submitReturn': 'Wysłać wniosek o zwrot',
  'customer.returnSuccess': 'Wniosek o zwrot został złożony pomyślnie.',
  'customer.returnPending': 'Przedstawiciel zweryfikuje go w najbliższej przyszłości.',
  'customer.conversations': 'Rozmowy',
  'customer.noMessages': 'Jeszcze żadnych rozmów',
  'customer.send': 'Wyślij',
  'customer.returnStatus.pending': 'W toku',
  'customer.returnStatus.approved': 'Zaakceptowany',
  'customer.returnStatus.rejected': 'Odrzucony',
  'customer.returnStatus.processing': 'W przetwarzaniu',
  'customer.returnId': 'ID zwrotu',
  'customer.orderId': 'ID zamówienia',
  'customer.reason': 'Powód',
  'customer.description': 'Opis',
  'customer.noReturns': 'Jeszcze żadnych zwrotów',
  'customer.noReturnsHint': 'Jeśli musisz zwrócić artykuł, idź do szczegółów zamówienia i kliknij "Wnioskować o zwrot".',
  'vendor.dashboard': 'Pulpit',
  'vendor.myListings': 'Moje ogłoszenia',
  'vendor.orders': 'Zamówienia',
  'vendor.addListing': 'Dodać ogłoszenie',
  'vendor.bulkImport': 'Import masowy',
  'vendor.revenue': 'Przychody',
  'vendor.totalOrders': 'Zamówienia',
  'vendor.totalListings': 'Ogłoszenia',
  'vendor.totalViews': 'Wyświetlenia',
  'vendor.recentOrders': 'Niedawne zamówienia',
  'vendor.noOrders': 'Jeszcze żadnych zamówień',
  'vendor.editListing': 'Edytuj',
  'vendor.deleteListing': 'Usuń',
  'vendor.priceLabel': 'Cena ({symbol}) *',
  'vendor.importCSV': 'Importować ogłoszenia CSV',
  'vendor.downloadTemplate': 'Pobrać szablon CSV',
  'vendor.chooseFile': 'Wybrać plik CSV',
  'vendor.startImport': 'Rozpocząć import',
  'vendor.instructions': 'Jak importować',
  'vendor.previewData': 'Podgląd (pierwsze 5 wierszy)',
  'vendor.importResults': 'Wyniki importu',
  'vendor.listingsCreated': 'ogłoszeń utworzonych pomyślnie',
  'vendor.errors': 'Błędy',
  'vendor.noFile': 'Nie wybrano pliku',
  'vendor.requiredColumns': 'Prześlij plik CSV z następującymi kolumnami. Tylko tytuł i cena są wymagane.',
  'admin.users': 'Użytkownicy',
  'admin.sellers': 'Sprzedawcy',
  'admin.listings': 'Ogłoszenia',
  'admin.orders': 'Zamówienia',
  'admin.approve': 'Zatwierdzić',
  'admin.suspend': 'Zawieszać',
  'admin.delete': 'Usunąć',
  'admin.totalUsers': 'Całkowita liczba użytkowników',
  'admin.totalSellers': 'Całkowita liczba sprzedawców',
  'admin.totalListings': 'Całkowita liczba ogłoszeń',
  'admin.totalOrders': 'Całkowita liczba zamówień',
  'admin.pendingSellers': 'Sprzedawcy oczekujący',
  'admin.email': 'E-mail',
  'admin.name': 'Nazwa',
  'admin.role': 'Rola',
  'admin.status': 'Status',
  'admin.actions': 'Działania',
  'admin.company': 'Firma',
  'admin.rating': 'Ocena',
  'admin.sales': 'Sprzedaż',
  'admin.title': 'Tytuł',
  'admin.price': 'Cena',
  'admin.category': 'Kategoria',
  'admin.orderNo': 'Zamówienie #',
  'admin.buyer': 'Nabywca',
  'admin.date': 'Data',
  'admin.total': 'Suma',
  'home.heroTitle': "Sklep internetowy z używanymi częściami samochodowymi · 4,2 mln+ części",
  'home.heroSubtitle': "Znajdź oryginalne i zamienne części do każdego europejskiego pojazdu. Dostawa do UE, Wielkiej Brytanii i Norwegii.",
  'home.searchHero': 'Szukaj po numerze części, marce lub słowie kluczowym',
  'home.featuredParts': 'Polecane części',
  'home.viewAll': 'Pokaż wszystkie części',
  'home.freeShipping': "Dostawa UE, Wielka Brytania i Norwegia",
  'home.freeShippingDesc': "Dostawa do UE, Wielkiej Brytanii i Norwegii",
  'home.returns': 'Zwroty w 14 dniach',
  'home.returnsDesc': 'Bezproblemowa polityka zwrotów',
  'home.securePayment': 'Bezpieczna płatność',
  'home.securePaymentDesc': 'Transakcje szyfrowane SSL',
  'home.qualityParts': 'Części wysokej jakości',
  'home.qualityPartsDesc': "Oryginalne części producenta",
  'home.whyChoose': 'Dlaczego wybrać zivu.eu?',
  'home.trustedSellers': "Sprawdzone dopasowanie",
  'home.trustedSellersDesc': "Każda część jest fotografowana i sprawdzana pod kątem dopasowania przed publikacją",
  'makes.title': 'Marki pojazdów',
  'makes.subtitle': 'Przeglądać części według producenta pojazdu',
  'makes.searchPlaceholder': 'Szukać marek...',
  'makes.popular': 'Popularne marki',
  'makeDetail.subtitle': 'Przeglądać modele i znajdować części',
  'makeDetail.selectModel': 'Wybrać model',
  'makeDetail.selectYear': 'Wybrać rok',
  'footer.tagline': "Sklep internetowy z używanymi i odnowionymi częściami samochodowymi. Wysyłka do UE, Wielkiej Brytanii i Norwegii.",
  'footer.shop': 'Sklep',
  'footer.allParts': 'Wszystkie części',
  'footer.engineParts': 'Części silnika',
  'footer.bodyParts': 'Części karoserii',
  'footer.electrical': 'Elektryczne',
  'footer.refurbished': 'Odnowione',
  'footer.information': 'Informacje',
  'footer.aboutUs': 'O nas',
  'footer.deliveryInfo': 'Informacje o dostawie',
  'footer.returnsRefunds': 'Zwroty i reklamacje',
  'footer.paymentMethods': 'Metody płatności',
  'footer.contactUs': 'Kontakt',
  'footer.support': 'Wsparcie',
  'footer.helpCenter': 'Centrum pomocy',
  'footer.shippingInfo': 'Informacje o wysyłce',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Gwarancja',
  'footer.sellers': 'Sprzedawcy',
  'footer.sellOnZivu': 'Sprzedawaj na zivu.eu',
  'footer.sellerPortal': 'Portal sprzedawcy',
  'footer.sellerTerms': 'Warunki sprzedawcy',
  'footer.privacy': 'Prywatność',
  'footer.terms': 'Regulamin',
  'footer.euMarketplace': "UE · UK · Norwegia",
  'login.welcomeBack': 'Witaj ponownie',
  'login.signInToContinue': 'Zaloguj się, aby kontynuować',
  'login.emailLabel': 'E-mail',
  'login.passwordLabel': 'Hasło',
  'login.emailPh': 'ty@przyklad.pl',
  'login.forgotPassword': 'Nie pamiętasz hasła?',
  'login.signingIn': 'Logowanie…',
  'login.signInBtn': 'Zaloguj się',
  'login.orContinueWith': 'Lub kontynuuj z',
  'login.continueWithGoogle': 'Kontynuuj z Google',
  'login.noAccount': 'Nie masz konta?',
  'login.signUp': 'Zarejestruj się',
  'register.title': 'Utwórz konto',
  'register.subtitle': "Załóż konto, aby kupować używane i regenerowane części samochodowe",
  'register.firstName': 'Imię',
  'register.lastName': 'Nazwisko',
  'register.emailLabel': 'E-mail',
  'register.passwordLabel': 'Hasło',
  'register.confirmPassword': 'Potwierdź hasło',
  'register.creating': 'Tworzenie konta…',
  'register.createBtn': 'Utwórz konto',
  'register.alreadyHave': 'Masz już konto?',
  'register.signIn': 'Zaloguj się',
  'register.byCreating': 'Tworząc konto, akceptujesz nasze',
  'customer.nav.overview': 'Przegląd',
  'customer.nav.myOrders': 'Moje zamówienia',
  'customer.nav.myGarage': 'Mój garaż',
  'customer.nav.myReviews': 'Moje opinie',
  'customer.nav.favorites': 'Ulubione',
  'customer.nav.messages': 'Wiadomości',
  'customer.nav.returns': 'Zwroty',
  'customer.nav.addresses': 'Adresy',
  'customer.nav.settings': 'Ustawienia',
  'customer.dashboardSubtitle': 'Zarządzaj zamówieniami i ustawieniami konta',
  'customer.recentOrders': 'Ostatnie zamówienia',
  'customer.noOrdersYet': 'Brak zamówień',
  'customer.myOrdersTitle': 'Moje zamówienia',
  'customer.trackManage': 'Śledź i zarządzaj zamówieniami',
  'customer.browseParts': 'Przeglądaj części',
  'customer.orderNotFound': 'Nie znaleziono zamówienia',
  'customer.cancelOrderTitle': 'Anulować to zamówienie?',
  'customer.cancelOrderDesc': 'Tej operacji nie można cofnąć. Płatność zostanie zwrócona.',
  'customer.keepOrder': 'Zachowaj zamówienie',
  'customer.statusHistory': 'Historia statusu',
  'customer.orderItems': 'Pozycje zamówienia',
  'customer.discount': 'Rabat',
  'customer.shippingAddressTitle': 'Adres dostawy',
  'customer.billingAddressTitle': 'Adres rozliczeniowy',
  'customer.needToReturn': 'Potrzebujesz zwrócić to zamówienie?',
  'customer.returnRequestForm': 'Formularz zwrotu',
  'customer.cancelBtn': 'Anuluj',
  'customer.returnSubmitted': 'Zgłoszenie zwrotu wysłane',
  'customer.returnReviewMsg': 'Nasz zespół przeanalizuje zgłoszenie i wkrótce się skontaktuje.',
  'customer.newMessageTitle': 'Nowa wiadomość',
  'customer.sending': 'Wysyłanie…',
  'customer.sendMessage': 'Wyślij wiadomość',
  'customer.messagesTitle': 'Wiadomości',
  'customer.myFavoritesTitle': 'Moje ulubione',
  'customer.noFavoritesYet': 'Brak ulubionych',
  'customer.noTimelineData': 'Brak danych osi czasu',
  'customer.returnsTitle': 'Zwroty',
  'customer.noReturnsYet': 'Brak zwrotów',
  'customer.myAddressesTitle': 'Moje adresy',
  'customer.noAddressesSaved': 'Brak zapisanych adresów',
  'customer.defaultBadge': 'Domyślny',
  'customer.businessAccount': 'Konto firmowe',
  'customer.currentStatus': 'Bieżący status',
  'customer.companyAddress': 'Zarejestrowany adres firmy',
  'status.pending': 'Oczekuje',
  'status.confirmed': 'Potwierdzone',
  'status.paid': 'Opłacone',
  'status.processing': 'W realizacji',
  'status.shipped': 'Wysłane',
  'status.delivered': 'Dostarczone',
  'status.completed': 'Zakończone',
  'status.cancelled': 'Anulowane',
  'status.refunded': 'Zwrócone',
  'status.returnRequested': 'Zażądano zwrotu',
  'status.returning': 'Zwrot w trakcie',
  'status.returned': 'Zwrócono',
  'status.returnRejected': 'Zwrot odrzucony',
  'cart.itemsSubtotalLabel': 'Suma częściowa',
  'cart.discountLabel': 'Rabat',
  'cart.allPricesVat': 'Wszystkie ceny zawierają VAT',
  'cart.allPricesNet': 'Bez VAT — kupujący samodzielnie rozlicza VAT (odwrotne obciążenie)',
  'cart.secureCheckout': 'Bezpieczna płatność przez Stripe',
  'cart.orderSummary': 'Podsumowanie zamówienia',
  'checkout.title': 'Zamówienie',
  'checkout.buyerType': 'Typ kupującego',
  'checkout.private': 'Osoba prywatna',
  'checkout.privateSub': 'Zakup prywatny',
  'checkout.company': 'Firma / Organizacja',
  'checkout.companySub': 'B2B z fakturą VAT',
  'checkout.companyDetails': 'Dane firmy',
  'checkout.companyName': 'Nazwa firmy',
  'checkout.companyNamePh': 'Acme Sp. z o.o.',
  'checkout.vatNumberLabel': 'NIP (zalecane)',
  'checkout.vatValidating': 'Weryfikacja numeru NIP…',
  'checkout.streetPh': 'Ulica i numer',
  'checkout.shippingTitle': 'Dostawa',
  'checkout.standardDelivery': 'Dostawa standardowa',
  'checkout.billingTitle': 'Adres rozliczeniowy',
  'checkout.sameAsShipping': 'Taki sam jak adres dostawy',
  'checkout.secureCheckout': 'Bezpieczna płatność przez Stripe',
  'checkout.buyerProtection': "14-dniowe prawo odstąpienia",
  'checkout.firstNamePh': 'Anna',
  'checkout.lastNamePh': 'Kowalska',
  'checkout.processingBtn': 'Przetwarzanie…',
  'checkout.termsShort': 'Regulamin',
  'checkout.privacyShort': 'Prywatność',
  'checkout.detailsStep': 'Dane',
  'checkout.shippingBilling': 'Dostawa i rozliczenie',
  'checkout.paymentStep': 'Płatność',
  'checkout.secureViaStripe': 'Bezpieczne przez Stripe',
  'checkout.acceptTerms': 'Akceptuję',
  'checkout.and': 'oraz',
  'register.firstNamePh': 'Jan',
  'register.lastNamePh': 'Kowalski',
  'register.termsLink': 'Regulamin',
  'register.privacyLink': 'Politykę prywatności',
  'product.clickToZoom': 'Kliknij, aby powiększyć',
  'product.deliveryEstimate': 'Szacowany czas dostawy',
  'product.selectCountry': 'Wybierz kraj',
  'product.inStockShort': 'W magazynie',
  'product.outOfStockShort': 'Brak w magazynie',
  'product.askQuestion': 'Zadaj pytanie',
  'product.askQuestionPh': 'Cześć, mam pytanie o tę część. Czy pasuje do mojego auta?',
  'product.soldBy': 'Sprzedawca',
  'product.yourReview': 'Twoja recenzja',
  'product.reviewTitlePh': 'Podsumuj swoje doświadczenie',
  'product.reviewBodyPh': 'Podziel się doświadczeniem z tą częścią — dopasowanie, jakość, dostawa…',
  'product.noReviewsYet': 'Brak recenzji.',
  'product.beFirstReview': 'Bądź pierwszy, który oceni tę część!',
  'product.notFound': 'Nie znaleziono produktu',
  'product.browseAll': 'Przeglądaj wszystkie części',
  'product.qualityAssessment': 'Ocena jakości',
  'product.aiAssessed': 'Oceniono przez AI na podstawie zdjęć',
  'product.aiDisclaimer': 'Automatyczna ocena wizualna — zweryfikuj na zdjęciach.',
  'product.newSeller': 'Nowy sprzedawca',
  'product.description': 'Opis produktu',
  'product.keyFeatures': 'Kluczowe cechy',
  'product.compatibility': 'Kompatybilność z pojazdem',
  'product.oemNumbersTitle': 'Numery OEM',
  'product.totalSales': 'Łączna sprzedaż',
  'product.aboutSeller': 'O sprzedawcy',
  'product.moreFromSeller': 'Więcej od tego sprzedawcy',
  'product.youMayAlsoLike': 'Może Ci się spodobać',
  'product.copyOem': 'Skopiuj kod OEM',
  'product.securePayment': 'Bezpieczna płatność',
  'product.newLabel': 'Nowy',
  'product.sellerInfoNa': 'Informacje o sprzedawcy niedostępne',
  'home.heroBadge': '4,2 mln+ części dostępnych',
  'home.heroTitle1': 'Znajdź swoją',
  'home.heroTitle2': 'część samochodową',
  'home.heroPara': "Europejski sklep internetowy z wysokiej jakości używanymi i regenerowanymi częściami samochodowymi. Szukaj po kodzie OEM lub modelu pojazdu.",
  'home.searchPlaceholder': 'Wprowadź kod OEM lub numer części (np. OEM-A123-4567)',
  'home.searchByVehicle': 'Szukaj według pojazdu',
  'home.searchByVehicleSub': 'Wybierz swój samochód, aby znaleźć kompatybilne części',
  'home.makeLabel': 'Marka',
  'home.modelLabel': 'Model',
  'home.generationLabel': 'Generacja',
  'home.partNameLabel': 'Nazwa części',
  'home.selectMake': 'Wybierz markę',
  'home.selectModel': 'Wybierz model',
  'home.selectGeneration': 'Wybierz generację',
  'home.partPlaceholder': 'np. Klocki hamulcowe, Alternator…',
  'home.searchPartsBtn': 'Szukaj części',
  'home.browseByCategoryTitle': 'Przeglądaj według kategorii',
  'home.browseByCategorySub': 'Znajdź części uporządkowane według typu',
  'common.viewAll': 'Zobacz wszystko',
  'header.shipWithin': 'Wysyłka w 72 godziny robocze',
  'header.returns14': '14 dni na zwrot',
  'header.deliveryEU': "Dostawa do UE, Wielkiej Brytanii i Norwegii",
  'header.inclVat': 'Z VAT',
  'header.exclVat': 'Bez VAT',
  'cat.air-conditioning-heating-system-radiators': 'Klimatyzacja, ogrzewanie i chłodnice',
  'cat.body-body-parts-hook': 'Nadwozie i maska',
  'cat.brake-system': 'Układ hamulcowy',
  'cat.cabin-interior': 'Wnętrze',
  'cat.devices-switches-electronic-system': 'Elektryka i elektronika',
  'cat.door': 'Drzwi',
  'cat.engine': 'Silnik',
  'cat.exterior-front-body-parts': 'Nadwozie przód',
  'cat.exterior-rear-body-parts': 'Nadwozie tył',
  'cat.front-axle': 'Oś przednia',
  'cat.fuel-mixture-system': 'Układ paliwowy',
  'cat.gas-exhaust-system': 'Układ wydechowy',
  'cat.gearbox-clutch-transmission': 'Skrzynia, sprzęgło i napęd',
  'cat.glass': 'Szyby',
  'cat.headlight-headlamp-washing-cleaning-system': 'Reflektory i spryskiwacze',
  'cat.lighting-system': 'Oświetlenie',
  'cat.other-parts': 'Inne części',
  'cat.rear-axle': 'Oś tylna',
  'cat.wheels-tires-caps': 'Koła i opony',
};

const sv = {
  'nav.home': 'Hem',
  'nav.allParts': 'Alla delar',
  'nav.cart': 'Varukorg',
  'nav.myAccount': 'Mitt konto',
  'nav.myOrders': 'Mina beställningar',
  'nav.sellerPortal': 'Säljarportal',
  'nav.adminPanel': 'Adminpanel',
  'nav.login': 'Logga in',
  'nav.register': 'Registrera',
  'nav.logout': 'Logga ut',
  'nav.makes': 'Bilmärken',
  'header.freeShipping': "Snabb leverans till EU, Storbritannien & Norge",
  'header.returns': '14 dagars retur',
  'header.light': 'Ljus',
  'header.dark': 'Mörk',
  'header.searchPlaceholder': 'Sök efter artikelnummer, OEM-kod eller nyckelord...',
  'header.searchMobile': 'Sök delar...',
  'search.partsFound': '{count} delar hittades',
  'search.sortBy': 'Sortera efter',
  'search.relevance': 'Relevans',
  'search.priceLowHigh': 'Pris: Lägst till högst',
  'search.priceHighLow': 'Pris: Högst till lägst',
  'search.newest': 'Nyaste',
  'search.priceRange': 'Prisintervall',
  'search.make': 'Märke',
  'search.model': 'Modell',
  'search.year': 'År',
  'search.category': 'Kategori',
  'search.subcategory': 'Underkategori',
  'search.condition': 'Skick',
  'search.allMakes': 'Alla märken',
  'search.allModels': 'Alla modeller',
  'search.allYears': 'Alla år',
  'search.allCategories': 'Alla kategorier',
  'search.allSubcategories': 'Alla underkategorier',
  'search.allConditions': 'Alla skick',
  'search.clearFilters': 'Rensa alla filter',
  'search.noResults': 'Inga delar hittades som matchar dina kriterier',
  'search.noResultsHint': 'Försök bredda din sökning eller justera filtren',
  'search.addToCart': 'Lägg i varukorg',
  'product.addToCart': 'Lägg i varukorg',
  'product.freeShipping': "Frakt till EU, Storbritannien & Norge",
  'product.reviews': 'Recensioner',
  'product.writeReview': 'Skriv recension',
  'product.signInReview': 'Logga in för att skriva en recension',
  'product.noReviews': 'Inga recensioner ännu. Bli den första!',
  'product.seller': 'Säljare',
  'product.condition': 'Skick',
  'product.oemCodes': 'OEM-koder',
  'product.inStock': 'I lager ({qty} tillgängliga)',
  'product.outOfStock': 'Slut i lager',
  'product.reviewTitle': 'Titel',
  'product.reviewContent': 'Recension',
  'product.submitReview': 'Skicka recension',
  'product.avgRating': 'Genomsnittligt betyg',
  'product.ratingDist': 'Betygsfördelning',
  'cart.title': 'Varukorg',
  'cart.empty': 'Din varukorg är tom',
  'cart.emptyHint': 'Bläddra bland våra bildelar',
  'cart.subtotal': 'Delsumma',
  'cart.shipping': 'Frakt',
  'cart.total': 'Totalt',
  'cart.checkout': 'Gå till kassan',
  'cart.each': 'styck',
  'cart.continueShopping': 'Fortsätt handla',
  'cart.freeShipping': 'Leverans beräknas i kassan',
  'checkout.orderSummary': 'Ordersammanfattning',
  'checkout.subtotal': 'Delsumma',
  'checkout.shipping': 'Frakt',
  'checkout.total': 'Totalt',
  'checkout.placeOrder': 'Lägg beställning',
  'checkout.processing': 'Behandlar...',
  'checkout.shippingInfo': 'Leveransinformation',
  'checkout.billingInfo': 'Faktureringsinformation',
  'checkout.paymentInfo': 'Betalningsinformation',
  'checkout.firstName': 'Förnamn',
  'checkout.lastName': 'Efternamn',
  'checkout.email': 'E-post',
  'checkout.address': 'Adress',
  'checkout.city': 'Stad',
  'checkout.country': 'Land',
  'checkout.postalCode': 'Postnummer',
  'checkout.cardNumber': 'Kortnummer',
  'checkout.expiryDate': 'Utgångsdatum',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Samma som leveransadress',
  'customer.orders': 'Beställningar',
  'customer.messages': 'Meddelanden',
  'customer.returns': 'Returer',
  'customer.orderHistory': 'Orderhistorik',
  'customer.noOrders': 'Inga beställningar ännu',
  'customer.orderNo': 'Order #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Totalt',
  'customer.viewDetails': 'Visa detaljer',
  'customer.backToOrders': 'Tillbaka till beställningar',
  'customer.orderDetail': 'Orderdetaljer',
  'customer.requestReturn': 'Begär retur',
  'customer.returnReason': 'Anledning till retur',
  'customer.returnDescription': 'Ytterligare detaljer (valfritt)',
  'customer.submitReturn': 'Skicka returförfrågan',
  'customer.returnSuccess': 'Din returförfrågan har skickats.',
  'customer.returnPending': 'En representant granskar den snart.',
  'customer.conversations': 'Konversationer',
  'customer.noMessages': 'Inga konversationer ännu',
  'customer.send': 'Skicka',
  'customer.returnStatus.pending': 'Väntande',
  'customer.returnStatus.approved': 'Godkänd',
  'customer.returnStatus.rejected': 'Avvisad',
  'customer.returnStatus.processing': 'Behandlas',
  'customer.returnId': 'Retur-ID',
  'customer.orderId': 'Order-ID',
  'customer.reason': 'Anledning',
  'customer.description': 'Beskrivning',
  'customer.noReturns': 'Inga returer inlämnade ännu',
  'customer.noReturnsHint': 'Om du behöver returnera en artikel, gå till dina orderdetaljer och klicka på "Begär retur".',
  'vendor.dashboard': 'Instrumentpanel',
  'vendor.myListings': 'Mina annonser',
  'vendor.orders': 'Beställningar',
  'vendor.addListing': 'Lägg till annons',
  'vendor.bulkImport': 'Massimport',
  'vendor.revenue': 'Intäkter',
  'vendor.totalOrders': 'Beställningar',
  'vendor.totalListings': 'Annonser',
  'vendor.totalViews': 'Visningar',
  'vendor.recentOrders': 'Senaste beställningar',
  'vendor.noOrders': 'Inga beställningar ännu',
  'vendor.editListing': 'Redigera',
  'vendor.deleteListing': 'Ta bort',
  'vendor.priceLabel': 'Pris ({symbol}) *',
  'vendor.importCSV': 'Importera CSV-annonser',
  'vendor.downloadTemplate': 'Ladda ner CSV-mall',
  'vendor.chooseFile': 'Välj CSV-fil',
  'vendor.startImport': 'Starta import',
  'vendor.instructions': 'Hur man importerar',
  'vendor.previewData': 'Förhandsgranskning (första 5 rader)',
  'vendor.importResults': 'Importresultat',
  'vendor.listingsCreated': 'annonser skapades',
  'vendor.errors': 'Fel',
  'vendor.noFile': 'Ingen fil vald',
  'vendor.requiredColumns': 'Ladda upp en CSV-fil med följande kolumner. Endast titel och pris krävs.',
  'admin.users': 'Användare',
  'admin.sellers': 'Säljare',
  'admin.listings': 'Annonser',
  'admin.orders': 'Beställningar',
  'admin.approve': 'Godkänn',
  'admin.suspend': 'Suspendera',
  'admin.delete': 'Ta bort',
  'admin.totalUsers': 'Totalt antal användare',
  'admin.totalSellers': 'Totalt antal säljare',
  'admin.totalListings': 'Totalt antal annonser',
  'admin.totalOrders': 'Totalt antal beställningar',
  'admin.pendingSellers': 'Väntande säljare',
  'admin.email': 'E-post',
  'admin.name': 'Namn',
  'admin.role': 'Roll',
  'admin.status': 'Status',
  'admin.actions': 'Åtgärder',
  'admin.company': 'Företag',
  'admin.rating': 'Betyg',
  'admin.sales': 'Försäljning',
  'admin.title': 'Titel',
  'admin.price': 'Pris',
  'admin.category': 'Kategori',
  'admin.orderNo': 'Order #',
  'admin.buyer': 'Köpare',
  'admin.date': 'Datum',
  'admin.total': 'Totalt',
  'home.heroTitle': "Webbutik för begagnade bildelar · 4,2 M+ delar",
  'home.heroSubtitle': "Hitta original- och eftermarknadsdelar för alla europeiska fordon. Leverans till EU, Storbritannien och Norge.",
  'home.searchHero': 'Sök efter artikelnummer, märke eller nyckelord',
  'home.featuredParts': 'Utvalda delar',
  'home.viewAll': 'Visa alla delar',
  'home.freeShipping': "Leverans EU, Storbritannien & Norge",
  'home.freeShippingDesc': "Leverans till EU, Storbritannien & Norge",
  'home.returns': '14 dagars retur',
  'home.returnsDesc': 'Problemfri returpolicy',
  'home.securePayment': 'Säker betalning',
  'home.securePaymentDesc': 'SSL-krypterade transaktioner',
  'home.qualityParts': 'Kvalitetsdelar',
  'home.qualityPartsDesc': "Originaldelar från tillverkaren",
  'home.whyChoose': 'Varför välja zivu.eu?',
  'home.trustedSellers': "Passform kontrollerad",
  'home.trustedSellersDesc': "Varje del fotograferas och passformskontrolleras före publicering",
  'makes.title': 'Bilmärken',
  'makes.subtitle': 'Bläddra bland delar efter fordonstillverkare',
  'makes.searchPlaceholder': 'Sök märken...',
  'makes.popular': 'Populära märken',
  'makeDetail.subtitle': 'Bläddra bland modeller och hitta delar',
  'makeDetail.selectModel': 'Välj modell',
  'makeDetail.selectYear': 'Välj år',
  'footer.tagline': "Webbutik för begagnade och renoverade bildelar. Frakt till EU, Storbritannien och Norge.",
  'footer.shop': 'Butik',
  'footer.allParts': 'Alla delar',
  'footer.engineParts': 'Motordelar',
  'footer.bodyParts': 'Karossdelar',
  'footer.electrical': 'Elektriska',
  'footer.refurbished': 'Renoverade',
  'footer.information': 'Information',
  'footer.aboutUs': 'Om oss',
  'footer.deliveryInfo': 'Leveransinformation',
  'footer.returnsRefunds': 'Returer och återbetalningar',
  'footer.paymentMethods': 'Betalningsmetoder',
  'footer.contactUs': 'Kontakta oss',
  'footer.support': 'Support',
  'footer.helpCenter': 'Hjälpcenter',
  'footer.shippingInfo': 'Fraktinformation',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garanti',
  'footer.sellers': 'Säljare',
  'footer.sellOnZivu': 'Sälj på zivu.eu',
  'footer.sellerPortal': 'Säljarportal',
  'footer.sellerTerms': 'Säljarvillkor',
  'footer.privacy': 'Integritet',
  'footer.terms': 'Villkor',
  'footer.euMarketplace': "EU · UK · Norge",
};

const da = {
  'nav.home': 'Hjem',
  'nav.allParts': 'Alle dele',
  'nav.cart': 'Indkøbskurv',
  'nav.myAccount': 'Min konto',
  'nav.myOrders': 'Mine ordrer',
  'nav.sellerPortal': 'Sælgerportal',
  'nav.adminPanel': 'Adminpanel',
  'nav.login': 'Log ind',
  'nav.register': 'Registrer',
  'nav.logout': 'Log ud',
  'nav.makes': 'Bilmærker',
  'header.freeShipping': "Hurtig levering til EU, Storbritannien & Norge",
  'header.returns': '14 dages returnering',
  'header.light': 'Lys',
  'header.dark': 'Mørk',
  'header.searchPlaceholder': 'Søg efter delnummer, OEM-kode eller nøgleord...',
  'header.searchMobile': 'Søg dele...',
  'search.partsFound': '{count} dele fundet',
  'search.sortBy': 'Sorter efter',
  'search.relevance': 'Relevans',
  'search.priceLowHigh': 'Pris: Lav til høj',
  'search.priceHighLow': 'Pris: Høj til lav',
  'search.newest': 'Nyeste',
  'search.priceRange': 'Prisinterval',
  'search.make': 'Mærke',
  'search.model': 'Model',
  'search.year': 'År',
  'search.category': 'Kategori',
  'search.subcategory': 'Underkategori',
  'search.condition': 'Stand',
  'search.allMakes': 'Alle mærker',
  'search.allModels': 'Alle modeller',
  'search.allYears': 'Alle år',
  'search.allCategories': 'Alle kategorier',
  'search.allSubcategories': 'Alle underkategorier',
  'search.allConditions': 'Alle stande',
  'search.clearFilters': 'Ryd alle filtre',
  'search.noResults': 'Ingen dele fundet der matcher dine kriterier',
  'search.noResultsHint': 'Prøv at udvide din søgning eller juster filtrene',
  'search.addToCart': 'Læg i kurv',
  'product.addToCart': 'Læg i kurv',
  'product.freeShipping': "Forsendelse til EU, Storbritannien & Norge",
  'product.reviews': 'Anmeldelser',
  'product.writeReview': 'Skriv anmeldelse',
  'product.signInReview': 'Log ind for at skrive en anmeldelse',
  'product.noReviews': 'Ingen anmeldelser endnu. Vær den første!',
  'product.seller': 'Sælger',
  'product.condition': 'Stand',
  'product.oemCodes': 'OEM-koder',
  'product.inStock': 'På lager ({qty} tilgængelige)',
  'product.outOfStock': 'Ikke på lager',
  'product.reviewTitle': 'Titel',
  'product.reviewContent': 'Anmeldelse',
  'product.submitReview': 'Send anmeldelse',
  'product.avgRating': 'Gennemsnitlig bedømmelse',
  'product.ratingDist': 'Bedømmelsesfordeling',
  'cart.title': 'Indkøbskurv',
  'cart.empty': 'Din kurv er tom',
  'cart.emptyHint': 'Gennemse vores udvalg af bildele',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Forsendelse',
  'cart.total': 'Total',
  'cart.checkout': 'Gå til kassen',
  'cart.each': 'styk',
  'cart.continueShopping': 'Fortsæt med at handle',
  'cart.freeShipping': 'Levering beregnes ved kassen',
  'checkout.orderSummary': 'Ordreoversigt',
  'checkout.subtotal': 'Subtotal',
  'checkout.shipping': 'Forsendelse',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Afgiv ordre',
  'checkout.processing': 'Behandler...',
  'checkout.shippingInfo': 'Leveringsoplysninger',
  'checkout.billingInfo': 'Faktureringsoplysninger',
  'checkout.paymentInfo': 'Betalingsoplysninger',
  'checkout.firstName': 'Fornavn',
  'checkout.lastName': 'Efternavn',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adresse',
  'checkout.city': 'By',
  'checkout.country': 'Land',
  'checkout.postalCode': 'Postnummer',
  'checkout.cardNumber': 'Kortnummer',
  'checkout.expiryDate': 'Udløbsdato',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Samme som leveringsadresse',
  'customer.orders': 'Ordrer',
  'customer.messages': 'Beskeder',
  'customer.returns': 'Returneringer',
  'customer.orderHistory': 'Ordrehistorik',
  'customer.noOrders': 'Ingen ordrer endnu',
  'customer.orderNo': 'Ordre #',
  'customer.orderDate': 'Dato',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Vis detaljer',
  'customer.backToOrders': 'Tilbage til ordrer',
  'customer.orderDetail': 'Ordredetaljer',
  'customer.requestReturn': 'Anmod om returnering',
  'customer.returnReason': 'Årsag til returnering',
  'customer.returnDescription': 'Yderligere detaljer (valgfrit)',
  'customer.submitReturn': 'Send returanmodning',
  'customer.returnSuccess': 'Din returanmodning er blevet sendt.',
  'customer.returnPending': 'En repræsentant vil gennemgå den snart.',
  'customer.conversations': 'Samtaler',
  'customer.noMessages': 'Ingen samtaler endnu',
  'customer.send': 'Send',
  'customer.returnStatus.pending': 'Afventer',
  'customer.returnStatus.approved': 'Godkendt',
  'customer.returnStatus.rejected': 'Afvist',
  'customer.returnStatus.processing': 'Behandles',
  'customer.returnId': 'Retur-ID',
  'customer.orderId': 'Ordre-ID',
  'customer.reason': 'Årsag',
  'customer.description': 'Beskrivelse',
  'customer.noReturns': 'Ingen returneringer indsendt endnu',
  'customer.noReturnsHint': 'Hvis du skal returnere en vare, gå til dine ordredetaljer og klik på "Anmod om returnering".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'Mine annoncer',
  'vendor.orders': 'Ordrer',
  'vendor.addListing': 'Tilføj annonce',
  'vendor.bulkImport': 'Masseimport',
  'vendor.revenue': 'Omsætning',
  'vendor.totalOrders': 'Ordrer',
  'vendor.totalListings': 'Annoncer',
  'vendor.totalViews': 'Visninger',
  'vendor.recentOrders': 'Seneste ordrer',
  'vendor.noOrders': 'Ingen ordrer endnu',
  'vendor.editListing': 'Rediger',
  'vendor.deleteListing': 'Slet',
  'vendor.priceLabel': 'Pris ({symbol}) *',
  'vendor.importCSV': 'Importer CSV-annoncer',
  'vendor.downloadTemplate': 'Download CSV-skabelon',
  'vendor.chooseFile': 'Vælg CSV-fil',
  'vendor.startImport': 'Start import',
  'vendor.instructions': 'Sådan importerer du',
  'vendor.previewData': 'Forhåndsvisning (første 5 rækker)',
  'vendor.importResults': 'Importresultater',
  'vendor.listingsCreated': 'annoncer oprettet',
  'vendor.errors': 'Fejl',
  'vendor.noFile': 'Ingen fil valgt',
  'vendor.requiredColumns': 'Upload en CSV-fil med følgende kolonner. Kun titel og pris er påkrævet.',
  'admin.users': 'Brugere',
  'admin.sellers': 'Sælgere',
  'admin.listings': 'Annoncer',
  'admin.orders': 'Ordrer',
  'admin.approve': 'Godkend',
  'admin.suspend': 'Suspender',
  'admin.delete': 'Slet',
  'admin.totalUsers': 'Antal brugere',
  'admin.totalSellers': 'Antal sælgere',
  'admin.totalListings': 'Antal annoncer',
  'admin.totalOrders': 'Antal ordrer',
  'admin.pendingSellers': 'Afventende sælgere',
  'admin.email': 'E-mail',
  'admin.name': 'Navn',
  'admin.role': 'Rolle',
  'admin.status': 'Status',
  'admin.actions': 'Handlinger',
  'admin.company': 'Virksomhed',
  'admin.rating': 'Bedømmelse',
  'admin.sales': 'Salg',
  'admin.title': 'Titel',
  'admin.price': 'Pris',
  'admin.category': 'Kategori',
  'admin.orderNo': 'Ordre #',
  'admin.buyer': 'Køber',
  'admin.date': 'Dato',
  'admin.total': 'Total',
  'home.heroTitle': "Webshop med brugte bildele · 4,2 M+ dele",
  'home.heroSubtitle': "Find originale og eftermarkedsdele til alle europæiske køretøjer. Levering til EU, Storbritannien og Norge.",
  'home.searchHero': 'Søg efter delnummer, mærke eller nøgleord',
  'home.featuredParts': 'Udvalgte dele',
  'home.viewAll': 'Se alle dele',
  'home.freeShipping': "Levering EU, Storbritannien & Norge",
  'home.freeShippingDesc': "Levering til EU, Storbritannien & Norge",
  'home.returns': '14 dages retur',
  'home.returnsDesc': 'Problemfri returpolitik',
  'home.securePayment': 'Sikker betaling',
  'home.securePaymentDesc': 'SSL-krypterede transaktioner',
  'home.qualityParts': 'Kvalitetsdele',
  'home.qualityPartsDesc': "Originale dele fra producenten",
  'home.whyChoose': 'Hvorfor vælge zivu.eu?',
  'home.trustedSellers': "Pasform kontrolleret",
  'home.trustedSellersDesc': "Hver del fotograferes og pasformskontrolleres før publicering",
  'makes.title': 'Bilmærker',
  'makes.subtitle': 'Gennemse dele efter køretøjsproducent',
  'makes.searchPlaceholder': 'Søg mærker...',
  'makes.popular': 'Populære mærker',
  'makeDetail.subtitle': 'Gennemse modeller og find dele',
  'makeDetail.selectModel': 'Vælg model',
  'makeDetail.selectYear': 'Vælg år',
  'footer.tagline': "Webshop med brugte og renoverede bildele. Levering til EU, Storbritannien og Norge.",
  'footer.shop': 'Butik',
  'footer.allParts': 'Alle dele',
  'footer.engineParts': 'Motordele',
  'footer.bodyParts': 'Karrossedele',
  'footer.electrical': 'Elektriske',
  'footer.refurbished': 'Renoverede',
  'footer.information': 'Information',
  'footer.aboutUs': 'Om os',
  'footer.deliveryInfo': 'Leveringsinfo',
  'footer.returnsRefunds': 'Returneringer og refusioner',
  'footer.paymentMethods': 'Betalingsmetoder',
  'footer.contactUs': 'Kontakt os',
  'footer.support': 'Support',
  'footer.helpCenter': 'Hjælpecenter',
  'footer.shippingInfo': 'Forsendelsesinfo',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garanti',
  'footer.sellers': 'Sælgere',
  'footer.sellOnZivu': 'Sælg på zivu.eu',
  'footer.sellerPortal': 'Sælgerportal',
  'footer.sellerTerms': 'Sælgervilkår',
  'footer.privacy': 'Privatliv',
  'footer.terms': 'Vilkår',
  'footer.euMarketplace': "EU · UK · Norge",
};

const fi = {
  'nav.home': 'Etusivu',
  'nav.allParts': 'Kaikki osat',
  'nav.cart': 'Ostoskori',
  'nav.myAccount': 'Oma tili',
  'nav.myOrders': 'Omat tilaukset',
  'nav.sellerPortal': 'Myyjäportaali',
  'nav.adminPanel': 'Hallintapaneeli',
  'nav.login': 'Kirjaudu',
  'nav.register': 'Rekisteröidy',
  'nav.logout': 'Kirjaudu ulos',
  'nav.makes': 'Ajoneuvomerkit',
  'header.freeShipping': "Nopea toimitus EU:hun, Isoon-Britanniaan ja Norjaan",
  'header.returns': '14 päivän palautus',
  'header.light': 'Vaalea',
  'header.dark': 'Tumma',
  'header.searchPlaceholder': 'Hae osanumerolla, OEM-koodilla tai avainsanalla...',
  'header.searchMobile': 'Hae osia...',
  'search.partsFound': '{count} osaa löytyi',
  'search.sortBy': 'Järjestä',
  'search.relevance': 'Osuvuus',
  'search.priceLowHigh': 'Hinta: halvimmasta kalleimpaan',
  'search.priceHighLow': 'Hinta: kalleimmasta halvimpaan',
  'search.newest': 'Uusimmat',
  'search.priceRange': 'Hintahaarukka',
  'search.make': 'Merkki',
  'search.model': 'Malli',
  'search.year': 'Vuosi',
  'search.category': 'Kategoria',
  'search.subcategory': 'Alakategoria',
  'search.condition': 'Kunto',
  'search.allMakes': 'Kaikki merkit',
  'search.allModels': 'Kaikki mallit',
  'search.allYears': 'Kaikki vuodet',
  'search.allCategories': 'Kaikki kategoriat',
  'search.allSubcategories': 'Kaikki alakategoriat',
  'search.allConditions': 'Kaikki kunnot',
  'search.clearFilters': 'Tyhjennä kaikki suodattimet',
  'search.noResults': 'Kriteereitäsi vastaavia osia ei löytynyt',
  'search.noResultsHint': 'Kokeile laajentaa hakua tai säätää suodattimia',
  'search.addToCart': 'Lisää koriin',
  'product.addToCart': 'Lisää koriin',
  'product.freeShipping': "Toimitus EU:hun, Isoon-Britanniaan ja Norjaan",
  'product.reviews': 'Arvostelut',
  'product.writeReview': 'Kirjoita arvostelu',
  'product.signInReview': 'Kirjaudu kirjoittaaksesi arvostelun',
  'product.noReviews': 'Ei arvosteluja vielä. Ole ensimmäinen!',
  'product.seller': 'Myyjä',
  'product.condition': 'Kunto',
  'product.oemCodes': 'OEM-koodit',
  'product.inStock': 'Varastossa ({qty} saatavilla)',
  'product.outOfStock': 'Loppunut',
  'product.reviewTitle': 'Otsikko',
  'product.reviewContent': 'Arvostelu',
  'product.submitReview': 'Lähetä arvostelu',
  'product.avgRating': 'Keskiarvo',
  'product.ratingDist': 'Arvostelut jakauma',
  'cart.title': 'Ostoskori',
  'cart.empty': 'Ostoskorisi on tyhjä',
  'cart.emptyHint': 'Selaa autonosia',
  'cart.subtotal': 'Välisumma',
  'cart.shipping': 'Toimitus',
  'cart.total': 'Yhteensä',
  'cart.checkout': 'Siirry kassalle',
  'cart.each': 'kpl',
  'cart.continueShopping': 'Jatka ostoksia',
  'cart.freeShipping': 'Toimitus lasketaan kassalla',
  'checkout.orderSummary': 'Tilauksen yhteenveto',
  'checkout.subtotal': 'Välisumma',
  'checkout.shipping': 'Toimitus',
  'checkout.total': 'Yhteensä',
  'checkout.placeOrder': 'Tee tilaus',
  'checkout.processing': 'Käsitellään...',
  'checkout.shippingInfo': 'Toimitusosoite',
  'checkout.billingInfo': 'Laskutusosoite',
  'checkout.paymentInfo': 'Maksutiedot',
  'checkout.firstName': 'Etunimi',
  'checkout.lastName': 'Sukunimi',
  'checkout.email': 'Sähköposti',
  'checkout.address': 'Osoite',
  'checkout.city': 'Kaupunki',
  'checkout.country': 'Maa',
  'checkout.postalCode': 'Postinumero',
  'checkout.cardNumber': 'Korttinumero',
  'checkout.expiryDate': 'Voimassaoloaika',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Sama kuin toimitusosoite',
  'customer.orders': 'Tilaukset',
  'customer.messages': 'Viestit',
  'customer.returns': 'Palautukset',
  'customer.orderHistory': 'Tilaushistoria',
  'customer.noOrders': 'Ei tilauksia vielä',
  'customer.orderNo': 'Tilaus #',
  'customer.orderDate': 'Päivämäärä',
  'customer.orderStatus': 'Tila',
  'customer.orderTotal': 'Yhteensä',
  'customer.viewDetails': 'Näytä tiedot',
  'customer.backToOrders': 'Takaisin tilauksiin',
  'customer.orderDetail': 'Tilauksen tiedot',
  'customer.requestReturn': 'Pyydä palautusta',
  'customer.returnReason': 'Palautuksen syy',
  'customer.returnDescription': 'Lisätiedot (valinnainen)',
  'customer.submitReturn': 'Lähetä palautuspyyntö',
  'customer.returnSuccess': 'Palautuspyyntösi on lähetetty.',
  'customer.returnPending': 'Edustaja tarkistaa sen pian.',
  'customer.conversations': 'Keskustelut',
  'customer.noMessages': 'Ei keskusteluja vielä',
  'customer.send': 'Lähetä',
  'customer.returnStatus.pending': 'Odottaa',
  'customer.returnStatus.approved': 'Hyväksytty',
  'customer.returnStatus.rejected': 'Hylätty',
  'customer.returnStatus.processing': 'Käsitellään',
  'customer.returnId': 'Palautus-ID',
  'customer.orderId': 'Tilaus-ID',
  'customer.reason': 'Syy',
  'customer.description': 'Kuvaus',
  'customer.noReturns': 'Ei palautuksia vielä',
  'customer.noReturnsHint': 'Jos haluat palauttaa tuotteen, siirry tilauksesi tietoihin ja klikkaa "Pyydä palautusta".',
  'vendor.dashboard': 'Hallintapaneeli',
  'vendor.myListings': 'Omat ilmoitukset',
  'vendor.orders': 'Tilaukset',
  'vendor.addListing': 'Lisää ilmoitus',
  'vendor.bulkImport': 'Massatuonti',
  'vendor.revenue': 'Tulot',
  'vendor.totalOrders': 'Tilaukset',
  'vendor.totalListings': 'Ilmoitukset',
  'vendor.totalViews': 'Näyttökerrat',
  'vendor.recentOrders': 'Viimeisimmät tilaukset',
  'vendor.noOrders': 'Ei tilauksia vielä',
  'vendor.editListing': 'Muokkaa',
  'vendor.deleteListing': 'Poista',
  'vendor.priceLabel': 'Hinta ({symbol}) *',
  'vendor.importCSV': 'Tuo CSV-ilmoitukset',
  'vendor.downloadTemplate': 'Lataa CSV-malli',
  'vendor.chooseFile': 'Valitse CSV-tiedosto',
  'vendor.startImport': 'Aloita tuonti',
  'vendor.instructions': 'Tuontiohjeet',
  'vendor.previewData': 'Esikatselu (5 ensimmäistä riviä)',
  'vendor.importResults': 'Tuonnin tulokset',
  'vendor.listingsCreated': 'ilmoitusta luotu',
  'vendor.errors': 'Virheet',
  'vendor.noFile': 'Ei tiedostoa valittu',
  'vendor.requiredColumns': 'Lataa CSV-tiedosto seuraavilla sarakkeilla. Vain otsikko ja hinta vaaditaan.',
  'admin.users': 'Käyttäjät',
  'admin.sellers': 'Myyjät',
  'admin.listings': 'Ilmoitukset',
  'admin.orders': 'Tilaukset',
  'admin.approve': 'Hyväksy',
  'admin.suspend': 'Keskeytä',
  'admin.delete': 'Poista',
  'admin.totalUsers': 'Käyttäjiä yhteensä',
  'admin.totalSellers': 'Myyjiä yhteensä',
  'admin.totalListings': 'Ilmoituksia yhteensä',
  'admin.totalOrders': 'Tilauksia yhteensä',
  'admin.pendingSellers': 'Odottavat myyjät',
  'admin.email': 'Sähköposti',
  'admin.name': 'Nimi',
  'admin.role': 'Rooli',
  'admin.status': 'Tila',
  'admin.actions': 'Toiminnot',
  'admin.company': 'Yritys',
  'admin.rating': 'Arvosana',
  'admin.sales': 'Myynti',
  'admin.title': 'Otsikko',
  'admin.price': 'Hinta',
  'admin.category': 'Kategoria',
  'admin.orderNo': 'Tilaus #',
  'admin.buyer': 'Ostaja',
  'admin.date': 'Päivämäärä',
  'admin.total': 'Yhteensä',
  'home.heroTitle': "Käytettyjen autonosien verkkokauppa · 4,2 M+ osaa",
  'home.heroSubtitle': "Löydä alkuperäisiä ja jälkimarkkinaosia kaikille eurooppalaisille ajoneuvoille. Toimitus EU:hun, Isoon-Britanniaan ja Norjaan.",
  'home.searchHero': 'Hae osanumerolla, merkillä tai avainsanalla',
  'home.featuredParts': 'Esitellyt osat',
  'home.viewAll': 'Näytä kaikki osat',
  'home.freeShipping': "Toimitus EU, Iso-Britannia & Norja",
  'home.freeShippingDesc': "Toimitus EU:hun, Britanniaan ja Norjaan",
  'home.returns': '14 päivän palautus',
  'home.returnsDesc': 'Vaivaton palautuskäytäntö',
  'home.securePayment': 'Turvallinen maksu',
  'home.securePaymentDesc': 'SSL-salatut tapahtumat',
  'home.qualityParts': 'Laadukkaat osat',
  'home.qualityPartsDesc': "Valmistajan alkuperäisosat",
  'home.whyChoose': 'Miksi valita zivu.eu?',
  'home.trustedSellers': "Yhteensopivuus tarkistettu",
  'home.trustedSellersDesc': "Jokainen osa valokuvataan ja yhteensopivuus tarkistetaan ennen julkaisua",
  'makes.title': 'Ajoneuvomerkit',
  'makes.subtitle': 'Selaa osia ajoneuvovalmistajan mukaan',
  'makes.searchPlaceholder': 'Hae merkkejä...',
  'makes.popular': 'Suositut merkit',
  'makeDetail.subtitle': 'Selaa malleja ja löydä osia',
  'makeDetail.selectModel': 'Valitse malli',
  'makeDetail.selectYear': 'Valitse vuosi',
  'footer.tagline': "Verkkokauppa käytetyille ja kunnostetuille autonosille. Toimitus EU:hun, Isoon-Britanniaan ja Norjaan.",
  'footer.shop': 'Kauppa',
  'footer.allParts': 'Kaikki osat',
  'footer.engineParts': 'Moottoriosat',
  'footer.bodyParts': 'Koriosat',
  'footer.electrical': 'Sähköosat',
  'footer.refurbished': 'Kunnostetut',
  'footer.information': 'Tiedot',
  'footer.aboutUs': 'Meistä',
  'footer.deliveryInfo': 'Toimitustiedot',
  'footer.returnsRefunds': 'Palautukset ja hyvitykset',
  'footer.paymentMethods': 'Maksutavat',
  'footer.contactUs': 'Ota yhteyttä',
  'footer.support': 'Tuki',
  'footer.helpCenter': 'Tukikeskus',
  'footer.shippingInfo': 'Lähetystiedot',
  'footer.faq': 'UKK',
  'footer.warranty': 'Takuu',
  'footer.sellers': 'Myyjät',
  'footer.sellOnZivu': 'Myy zivu.eu:ssa',
  'footer.sellerPortal': 'Myyjäportaali',
  'footer.sellerTerms': 'Myyjäehdot',
  'footer.privacy': 'Tietosuoja',
  'footer.terms': 'Ehdot',
  'footer.euMarketplace': "EU · UK · Norja",
};

const no = {
  'nav.home': 'Hjem',
  'nav.allParts': 'Alle deler',
  'nav.cart': 'Handlekurv',
  'nav.myAccount': 'Min konto',
  'nav.myOrders': 'Mine bestillinger',
  'nav.sellerPortal': 'Selgerportal',
  'nav.adminPanel': 'Adminpanel',
  'nav.login': 'Logg inn',
  'nav.register': 'Registrer',
  'nav.logout': 'Logg ut',
  'nav.makes': 'Bilmerker',
  'header.freeShipping': "Rask levering til EU, Storbritannia og Norge",
  'header.returns': '14 dagers retur',
  'header.light': 'Lys',
  'header.dark': 'Mørk',
  'header.searchPlaceholder': 'Søk etter delenummer, OEM-kode eller nøkkelord...',
  'header.searchMobile': 'Søk deler...',
  'search.partsFound': '{count} deler funnet',
  'search.sortBy': 'Sorter etter',
  'search.relevance': 'Relevans',
  'search.priceLowHigh': 'Pris: Lavest til høyest',
  'search.priceHighLow': 'Pris: Høyest til lavest',
  'search.newest': 'Nyeste',
  'search.priceRange': 'Prisintervall',
  'search.make': 'Merke',
  'search.model': 'Modell',
  'search.year': 'År',
  'search.category': 'Kategori',
  'search.subcategory': 'Underkategori',
  'search.condition': 'Stand',
  'search.allMakes': 'Alle merker',
  'search.allModels': 'Alle modeller',
  'search.allYears': 'Alle år',
  'search.allCategories': 'Alle kategorier',
  'search.allSubcategories': 'Alle underkategorier',
  'search.allConditions': 'Alle stander',
  'search.clearFilters': 'Tøm alle filtre',
  'search.noResults': 'Ingen deler funnet som matcher kriteriene dine',
  'search.noResultsHint': 'Prøv å utvide søket eller juster filtrene',
  'search.addToCart': 'Legg i kurv',
  'product.addToCart': 'Legg i kurv',
  'product.freeShipping': "Frakt til EU, Storbritannia og Norge",
  'product.reviews': 'Anmeldelser',
  'product.writeReview': 'Skriv anmeldelse',
  'product.signInReview': 'Logg inn for å skrive en anmeldelse',
  'product.noReviews': 'Ingen anmeldelser ennå. Bli den første!',
  'product.seller': 'Selger',
  'product.condition': 'Stand',
  'product.oemCodes': 'OEM-koder',
  'product.inStock': 'På lager ({qty} tilgjengelige)',
  'product.outOfStock': 'Ikke på lager',
  'product.reviewTitle': 'Tittel',
  'product.reviewContent': 'Anmeldelse',
  'product.submitReview': 'Send anmeldelse',
  'product.avgRating': 'Gjennomsnittlig vurdering',
  'product.ratingDist': 'Vurderingsfordeling',
  'cart.title': 'Handlekurv',
  'cart.empty': 'Handlekurven din er tom',
  'cart.emptyHint': 'Bla gjennom vårt utvalg av bildeler',
  'cart.subtotal': 'Delsum',
  'cart.shipping': 'Frakt',
  'cart.total': 'Total',
  'cart.checkout': 'Gå til kassen',
  'cart.each': 'stk',
  'cart.continueShopping': 'Fortsett å handle',
  'cart.freeShipping': 'Levering beregnes i kassen',
  'checkout.orderSummary': 'Bestillingsoversikt',
  'checkout.subtotal': 'Delsum',
  'checkout.shipping': 'Frakt',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Legg inn bestilling',
  'checkout.processing': 'Behandler...',
  'checkout.shippingInfo': 'Leveringsinformasjon',
  'checkout.billingInfo': 'Faktureringsinformasjon',
  'checkout.paymentInfo': 'Betalingsinformasjon',
  'checkout.firstName': 'Fornavn',
  'checkout.lastName': 'Etternavn',
  'checkout.email': 'E-post',
  'checkout.address': 'Adresse',
  'checkout.city': 'By',
  'checkout.country': 'Land',
  'checkout.postalCode': 'Postnummer',
  'checkout.cardNumber': 'Kortnummer',
  'checkout.expiryDate': 'Utløpsdato',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Samme som leveringsadresse',
  'customer.orders': 'Bestillinger',
  'customer.messages': 'Meldinger',
  'customer.returns': 'Returer',
  'customer.orderHistory': 'Bestillingshistorikk',
  'customer.noOrders': 'Ingen bestillinger ennå',
  'customer.orderNo': 'Bestilling #',
  'customer.orderDate': 'Dato',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Vis detaljer',
  'customer.backToOrders': 'Tilbake til bestillinger',
  'customer.orderDetail': 'Bestillingsdetaljer',
  'customer.requestReturn': 'Be om retur',
  'customer.returnReason': 'Årsak til retur',
  'customer.returnDescription': 'Ytterligere detaljer (valgfritt)',
  'customer.submitReturn': 'Send returforespørsel',
  'customer.returnSuccess': 'Returforespørselen din er sendt.',
  'customer.returnPending': 'En representant vil gjennomgå den snart.',
  'customer.conversations': 'Samtaler',
  'customer.noMessages': 'Ingen samtaler ennå',
  'customer.send': 'Send',
  'customer.returnStatus.pending': 'Venter',
  'customer.returnStatus.approved': 'Godkjent',
  'customer.returnStatus.rejected': 'Avvist',
  'customer.returnStatus.processing': 'Behandles',
  'customer.returnId': 'Retur-ID',
  'customer.orderId': 'Bestillings-ID',
  'customer.reason': 'Årsak',
  'customer.description': 'Beskrivelse',
  'customer.noReturns': 'Ingen returer innsendt ennå',
  'customer.noReturnsHint': 'Hvis du trenger å returnere en vare, gå til bestillingsdetaljene dine og klikk "Be om retur".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'Mine annonser',
  'vendor.orders': 'Bestillinger',
  'vendor.addListing': 'Legg til annonse',
  'vendor.bulkImport': 'Masseimport',
  'vendor.revenue': 'Inntekter',
  'vendor.totalOrders': 'Bestillinger',
  'vendor.totalListings': 'Annonser',
  'vendor.totalViews': 'Visninger',
  'vendor.recentOrders': 'Siste bestillinger',
  'vendor.noOrders': 'Ingen bestillinger ennå',
  'vendor.editListing': 'Rediger',
  'vendor.deleteListing': 'Slett',
  'vendor.priceLabel': 'Pris ({symbol}) *',
  'vendor.importCSV': 'Importer CSV-annonser',
  'vendor.downloadTemplate': 'Last ned CSV-mal',
  'vendor.chooseFile': 'Velg CSV-fil',
  'vendor.startImport': 'Start import',
  'vendor.instructions': 'Slik importerer du',
  'vendor.previewData': 'Forhåndsvisning (første 5 rader)',
  'vendor.importResults': 'Importresultater',
  'vendor.listingsCreated': 'annonser opprettet',
  'vendor.errors': 'Feil',
  'vendor.noFile': 'Ingen fil valgt',
  'vendor.requiredColumns': 'Last opp en CSV-fil med følgende kolonner. Bare tittel og pris er påkrevd.',
  'admin.users': 'Brukere',
  'admin.sellers': 'Selgere',
  'admin.listings': 'Annonser',
  'admin.orders': 'Bestillinger',
  'admin.approve': 'Godkjenn',
  'admin.suspend': 'Suspender',
  'admin.delete': 'Slett',
  'admin.totalUsers': 'Totalt antall brukere',
  'admin.totalSellers': 'Totalt antall selgere',
  'admin.totalListings': 'Totalt antall annonser',
  'admin.totalOrders': 'Totalt antall bestillinger',
  'admin.pendingSellers': 'Ventende selgere',
  'admin.email': 'E-post',
  'admin.name': 'Navn',
  'admin.role': 'Rolle',
  'admin.status': 'Status',
  'admin.actions': 'Handlinger',
  'admin.company': 'Bedrift',
  'admin.rating': 'Vurdering',
  'admin.sales': 'Salg',
  'admin.title': 'Tittel',
  'admin.price': 'Pris',
  'admin.category': 'Kategori',
  'admin.orderNo': 'Bestilling #',
  'admin.buyer': 'Kjøper',
  'admin.date': 'Dato',
  'admin.total': 'Total',
  'home.heroTitle': "Nettbutikk for brukte bildeler · 4,2 M+ deler",
  'home.heroSubtitle': "Finn originale og ettermarkedsdeler til alle europeiske kjøretøy. Levering til EU, Storbritannia og Norge.",
  'home.searchHero': 'Søk etter delenummer, merke eller nøkkelord',
  'home.featuredParts': 'Utvalgte deler',
  'home.viewAll': 'Se alle deler',
  'home.freeShipping': "Levering EU, Storbritannia og Norge",
  'home.freeShippingDesc': "Levering til EU, Storbritannia og Norge",
  'home.returns': '14 dagers retur',
  'home.returnsDesc': 'Problemfri returpolitikk',
  'home.securePayment': 'Sikker betaling',
  'home.securePaymentDesc': 'SSL-krypterte transaksjoner',
  'home.qualityParts': 'Kvalitetsdeler',
  'home.qualityPartsDesc': "Originaldeler fra produsenten",
  'home.whyChoose': 'Hvorfor velge zivu.eu?',
  'home.trustedSellers': "Passform kontrollert",
  'home.trustedSellersDesc': "Hver del fotograferes og passformkontrolleres før publisering",
  'makes.title': 'Bilmerker',
  'makes.subtitle': 'Bla gjennom deler etter kjøretøyprodusent',
  'makes.searchPlaceholder': 'Søk merker...',
  'makes.popular': 'Populære merker',
  'makeDetail.subtitle': 'Bla gjennom modeller og finn deler',
  'makeDetail.selectModel': 'Velg modell',
  'makeDetail.selectYear': 'Velg år',
  'footer.tagline': "Nettbutikk for brukte og renoverte bildeler. Levering til EU, Storbritannia og Norge.",
  'footer.shop': 'Butikk',
  'footer.allParts': 'Alle deler',
  'footer.engineParts': 'Motordeler',
  'footer.bodyParts': 'Karosserideler',
  'footer.electrical': 'Elektriske',
  'footer.refurbished': 'Renoverte',
  'footer.information': 'Informasjon',
  'footer.aboutUs': 'Om oss',
  'footer.deliveryInfo': 'Leveringsinformasjon',
  'footer.returnsRefunds': 'Returer og refusjoner',
  'footer.paymentMethods': 'Betalingsmetoder',
  'footer.contactUs': 'Kontakt oss',
  'footer.support': 'Support',
  'footer.helpCenter': 'Hjelpesenter',
  'footer.shippingInfo': 'Fraktinformasjon',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garanti',
  'footer.sellers': 'Selgere',
  'footer.sellOnZivu': 'Selg på zivu.eu',
  'footer.sellerPortal': 'Selgerportal',
  'footer.sellerTerms': 'Selgervilkår',
  'footer.privacy': 'Personvern',
  'footer.terms': 'Vilkår',
  'footer.euMarketplace': "EU · UK · Norge",
};

const nl = {
  'nav.home': 'Home',
  'nav.allParts': 'Alle onderdelen',
  'nav.cart': 'Winkelwagen',
  'nav.myAccount': 'Mijn account',
  'nav.myOrders': 'Mijn bestellingen',
  'nav.sellerPortal': 'Verkopersportaal',
  'nav.adminPanel': 'Beheerderspaneel',
  'nav.login': 'Inloggen',
  'nav.register': 'Registreren',
  'nav.logout': 'Uitloggen',
  'nav.makes': 'Voertuigmerken',
  'header.freeShipping': "Snelle levering naar de EU, het VK & Noorwegen",
  'header.returns': '14 dagen retour',
  'header.light': 'Licht',
  'header.dark': 'Donker',
  'header.searchPlaceholder': 'Zoek op onderdeelnummer, OEM-code of trefwoord...',
  'header.searchMobile': 'Zoek onderdelen...',
  'search.partsFound': '{count} onderdelen gevonden',
  'search.sortBy': 'Sorteren op',
  'search.relevance': 'Relevantie',
  'search.priceLowHigh': 'Prijs: Laag naar hoog',
  'search.priceHighLow': 'Prijs: Hoog naar laag',
  'search.newest': 'Nieuwste',
  'search.priceRange': 'Prijsklasse',
  'search.make': 'Merk',
  'search.model': 'Model',
  'search.year': 'Jaar',
  'search.category': 'Categorie',
  'search.subcategory': 'Subcategorie',
  'search.condition': 'Staat',
  'search.allMakes': 'Alle merken',
  'search.allModels': 'Alle modellen',
  'search.allYears': 'Alle jaren',
  'search.allCategories': 'Alle categorieën',
  'search.allSubcategories': 'Alle subcategorieën',
  'search.allConditions': 'Alle staten',
  'search.clearFilters': 'Alle filters wissen',
  'search.noResults': 'Geen onderdelen gevonden die overeenkomen met uw criteria',
  'search.noResultsHint': 'Probeer uw zoekopdracht te verbreden of filters aan te passen',
  'search.addToCart': 'In winkelwagen',
  'product.addToCart': 'In winkelwagen',
  'product.freeShipping': "Verzending naar de EU, het VK & Noorwegen",
  'product.reviews': 'Beoordelingen',
  'product.writeReview': 'Schrijf beoordeling',
  'product.signInReview': 'Log in om een beoordeling te schrijven',
  'product.noReviews': 'Nog geen beoordelingen. Wees de eerste!',
  'product.seller': 'Verkoper',
  'product.condition': 'Staat',
  'product.oemCodes': 'OEM-codes',
  'product.inStock': 'Op voorraad ({qty} beschikbaar)',
  'product.outOfStock': 'Niet op voorraad',
  'product.reviewTitle': 'Titel',
  'product.reviewContent': 'Beoordeling',
  'product.submitReview': 'Beoordeling verzenden',
  'product.avgRating': 'Gemiddelde beoordeling',
  'product.ratingDist': 'Beoordelingsverdeling',
  'cart.title': 'Winkelwagen',
  'cart.empty': 'Uw winkelwagen is leeg',
  'cart.emptyHint': 'Blader door ons assortiment auto-onderdelen',
  'cart.subtotal': 'Subtotaal',
  'cart.shipping': 'Verzending',
  'cart.total': 'Totaal',
  'cart.checkout': 'Naar de kassa',
  'cart.each': 'per stuk',
  'cart.continueShopping': 'Doorgaan met winkelen',
  'cart.freeShipping': 'Levering wordt berekend bij de kassa',
  'checkout.orderSummary': 'Besteloverzicht',
  'checkout.subtotal': 'Subtotaal',
  'checkout.shipping': 'Verzending',
  'checkout.total': 'Totaal',
  'checkout.placeOrder': 'Bestelling plaatsen',
  'checkout.processing': 'Verwerken...',
  'checkout.shippingInfo': 'Bezorgadres',
  'checkout.billingInfo': 'Factuuradres',
  'checkout.paymentInfo': 'Betalingsgegevens',
  'checkout.firstName': 'Voornaam',
  'checkout.lastName': 'Achternaam',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adres',
  'checkout.city': 'Stad',
  'checkout.country': 'Land',
  'checkout.postalCode': 'Postcode',
  'checkout.cardNumber': 'Kaartnummer',
  'checkout.expiryDate': 'Vervaldatum',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Zelfde als bezorgadres',
  'customer.orders': 'Bestellingen',
  'customer.messages': 'Berichten',
  'customer.returns': 'Retouren',
  'customer.orderHistory': 'Bestelgeschiedenis',
  'customer.noOrders': 'Nog geen bestellingen',
  'customer.orderNo': 'Bestelling #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Totaal',
  'customer.viewDetails': 'Details bekijken',
  'customer.backToOrders': 'Terug naar bestellingen',
  'customer.orderDetail': 'Besteldetails',
  'customer.requestReturn': 'Retour aanvragen',
  'customer.returnReason': 'Reden voor retour',
  'customer.returnDescription': 'Aanvullende details (optioneel)',
  'customer.submitReturn': 'Retourverzoek indienen',
  'customer.returnSuccess': 'Uw retourverzoek is ingediend.',
  'customer.returnPending': 'Een medewerker zal het binnenkort beoordelen.',
  'customer.conversations': 'Gesprekken',
  'customer.noMessages': 'Nog geen gesprekken',
  'customer.send': 'Verzenden',
  'customer.returnStatus.pending': 'In afwachting',
  'customer.returnStatus.approved': 'Goedgekeurd',
  'customer.returnStatus.rejected': 'Afgewezen',
  'customer.returnStatus.processing': 'Verwerken',
  'customer.returnId': 'Retour-ID',
  'customer.orderId': 'Bestelling-ID',
  'customer.reason': 'Reden',
  'customer.description': 'Beschrijving',
  'customer.noReturns': 'Nog geen retouren ingediend',
  'customer.noReturnsHint': 'Als u een artikel wilt retourneren, ga naar uw besteldetails en klik op "Retour aanvragen".',
  'vendor.dashboard': 'Dashboard',
  'vendor.myListings': 'Mijn advertenties',
  'vendor.orders': 'Bestellingen',
  'vendor.addListing': 'Advertentie toevoegen',
  'vendor.bulkImport': 'Bulkimport',
  'vendor.revenue': 'Omzet',
  'vendor.totalOrders': 'Bestellingen',
  'vendor.totalListings': 'Advertenties',
  'vendor.totalViews': 'Weergaven',
  'vendor.recentOrders': 'Recente bestellingen',
  'vendor.noOrders': 'Nog geen bestellingen',
  'vendor.editListing': 'Bewerken',
  'vendor.deleteListing': 'Verwijderen',
  'vendor.priceLabel': 'Prijs ({symbol}) *',
  'vendor.importCSV': 'CSV-advertenties importeren',
  'vendor.downloadTemplate': 'CSV-sjabloon downloaden',
  'vendor.chooseFile': 'CSV-bestand kiezen',
  'vendor.startImport': 'Import starten',
  'vendor.instructions': 'Importinstructies',
  'vendor.previewData': 'Voorbeeld (eerste 5 rijen)',
  'vendor.importResults': 'Importresultaten',
  'vendor.listingsCreated': 'advertenties aangemaakt',
  'vendor.errors': 'Fouten',
  'vendor.noFile': 'Geen bestand geselecteerd',
  'vendor.requiredColumns': 'Upload een CSV-bestand met de volgende kolommen. Alleen titel en prijs zijn vereist.',
  'admin.users': 'Gebruikers',
  'admin.sellers': 'Verkopers',
  'admin.listings': 'Advertenties',
  'admin.orders': 'Bestellingen',
  'admin.approve': 'Goedkeuren',
  'admin.suspend': 'Opschorten',
  'admin.delete': 'Verwijderen',
  'admin.totalUsers': 'Totaal gebruikers',
  'admin.totalSellers': 'Totaal verkopers',
  'admin.totalListings': 'Totaal advertenties',
  'admin.totalOrders': 'Totaal bestellingen',
  'admin.pendingSellers': 'In behandeling',
  'admin.email': 'E-mail',
  'admin.name': 'Naam',
  'admin.role': 'Rol',
  'admin.status': 'Status',
  'admin.actions': 'Acties',
  'admin.company': 'Bedrijf',
  'admin.rating': 'Beoordeling',
  'admin.sales': 'Verkopen',
  'admin.title': 'Titel',
  'admin.price': 'Prijs',
  'admin.category': 'Categorie',
  'admin.orderNo': 'Bestelling #',
  'admin.buyer': 'Koper',
  'admin.date': 'Datum',
  'admin.total': 'Totaal',
  'home.heroTitle': "Webshop voor gebruikte auto-onderdelen · 4,2 mln+ onderdelen",
  'home.heroSubtitle': "Vind originele en aftermarket-onderdelen voor elk Europees voertuig. Levering naar de EU, het VK en Noorwegen.",
  'home.searchHero': 'Zoek op onderdeelnummer, merk of trefwoord',
  'home.featuredParts': 'Uitgelichte onderdelen',
  'home.viewAll': 'Alle onderdelen bekijken',
  'home.freeShipping': "Levering EU, VK & Noorwegen",
  'home.freeShippingDesc': "Levering naar EU, VK & Noorwegen",
  'home.returns': '14 dagen retour',
  'home.returnsDesc': 'Probleemloze retourpolitiek',
  'home.securePayment': 'Veilige betaling',
  'home.securePaymentDesc': 'SSL-versleutelde transacties',
  'home.qualityParts': 'Kwaliteitsonderdelen',
  'home.qualityPartsDesc': "Originele fabrieksonderdelen",
  'home.whyChoose': 'Waarom zivu.eu kiezen?',
  'home.trustedSellers': "Pasvorm gecontroleerd",
  'home.trustedSellersDesc': "Elk onderdeel wordt gefotografeerd en op pasvorm gecontroleerd vóór plaatsing",
  'makes.title': 'Voertuigmerken',
  'makes.subtitle': 'Blader door onderdelen per voertuigfabrikant',
  'makes.searchPlaceholder': 'Merken zoeken...',
  'makes.popular': 'Populaire merken',
  'makeDetail.subtitle': 'Blader door modellen en vind onderdelen',
  'makeDetail.selectModel': 'Model selecteren',
  'makeDetail.selectYear': 'Jaar selecteren',
  'footer.tagline': "Webshop voor gebruikte en gereviseerde auto-onderdelen. Verzending naar de EU, het VK en Noorwegen.",
  'footer.shop': 'Winkel',
  'footer.allParts': 'Alle onderdelen',
  'footer.engineParts': 'Motoronderdelen',
  'footer.bodyParts': 'Carrosserieonderdelen',
  'footer.electrical': 'Elektrisch',
  'footer.refurbished': 'Gereviseerd',
  'footer.information': 'Informatie',
  'footer.aboutUs': 'Over ons',
  'footer.deliveryInfo': 'Leveringsinformatie',
  'footer.returnsRefunds': 'Retouren en terugbetalingen',
  'footer.paymentMethods': 'Betaalmethoden',
  'footer.contactUs': 'Neem contact op',
  'footer.support': 'Support',
  'footer.helpCenter': 'Helpcentrum',
  'footer.shippingInfo': 'Verzendingsinformatie',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garantie',
  'footer.sellers': 'Verkopers',
  'footer.sellOnZivu': 'Verkoop op zivu.eu',
  'footer.sellerPortal': 'Verkopersportaal',
  'footer.sellerTerms': 'Verkoopvoorwaarden',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Voorwaarden',
  'footer.euMarketplace': "EU · VK · Noorwegen",
};

const pt = {
  'nav.home': 'Início',
  'nav.allParts': 'Todas as peças',
  'nav.cart': 'Carrinho',
  'nav.myAccount': 'Minha conta',
  'nav.myOrders': 'Meus pedidos',
  'nav.sellerPortal': 'Portal do vendedor',
  'nav.adminPanel': 'Painel admin',
  'nav.login': 'Entrar',
  'nav.register': 'Registar',
  'nav.logout': 'Sair',
  'nav.makes': 'Marcas de veículos',
  'header.freeShipping': "Entrega rápida à UE, Reino Unido e Noruega",
  'header.returns': 'Devoluções em 14 dias',
  'header.light': 'Claro',
  'header.dark': 'Escuro',
  'header.searchPlaceholder': 'Pesquisar por número de peça, código OEM ou palavra-chave...',
  'header.searchMobile': 'Pesquisar peças...',
  'search.partsFound': '{count} peças encontradas',
  'search.sortBy': 'Ordenar por',
  'search.relevance': 'Relevância',
  'search.priceLowHigh': 'Preço: Do mais baixo ao mais alto',
  'search.priceHighLow': 'Preço: Do mais alto ao mais baixo',
  'search.newest': 'Mais recente',
  'search.priceRange': 'Intervalo de preços',
  'search.make': 'Marca',
  'search.model': 'Modelo',
  'search.year': 'Ano',
  'search.category': 'Categoria',
  'search.subcategory': 'Subcategoria',
  'search.condition': 'Condição',
  'search.allMakes': 'Todas as marcas',
  'search.allModels': 'Todos os modelos',
  'search.allYears': 'Todos os anos',
  'search.allCategories': 'Todas as categorias',
  'search.allSubcategories': 'Todas as subcategorias',
  'search.allConditions': 'Todas as condições',
  'search.clearFilters': 'Limpar todos os filtros',
  'search.noResults': 'Nenhuma peça encontrada correspondendo aos seus critérios',
  'search.noResultsHint': 'Tente ampliar a sua pesquisa ou ajustar os filtros',
  'search.addToCart': 'Adicionar ao carrinho',
  'product.addToCart': 'Adicionar ao carrinho',
  'product.freeShipping': "Envio para a UE, Reino Unido e Noruega",
  'product.reviews': 'Avaliações',
  'product.writeReview': 'Escrever avaliação',
  'product.signInReview': 'Inicie sessão para escrever uma avaliação',
  'product.noReviews': 'Sem avaliações ainda. Seja o primeiro!',
  'product.seller': 'Vendedor',
  'product.condition': 'Condição',
  'product.oemCodes': 'Códigos OEM',
  'product.inStock': 'Em stock ({qty} disponível)',
  'product.outOfStock': 'Sem stock',
  'product.reviewTitle': 'Título',
  'product.reviewContent': 'Avaliação',
  'product.submitReview': 'Enviar avaliação',
  'product.avgRating': 'Avaliação média',
  'product.ratingDist': 'Distribuição de avaliações',
  'cart.title': 'Carrinho de compras',
  'cart.empty': 'O seu carrinho está vazio',
  'cart.emptyHint': 'Explore a nossa seleção de peças auto',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Envio',
  'cart.total': 'Total',
  'cart.checkout': 'Proceder ao pagamento',
  'cart.each': 'por unidade',
  'cart.continueShopping': 'Continuar a comprar',
  'cart.freeShipping': 'Entrega calculada no pagamento',
  'checkout.orderSummary': 'Resumo do pedido',
  'checkout.subtotal': 'Subtotal',
  'checkout.shipping': 'Envio',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Efetuar pedido',
  'checkout.processing': 'A processar...',
  'checkout.shippingInfo': 'Informações de envio',
  'checkout.billingInfo': 'Informações de faturação',
  'checkout.paymentInfo': 'Informações de pagamento',
  'checkout.firstName': 'Nome',
  'checkout.lastName': 'Apelido',
  'checkout.email': 'E-mail',
  'checkout.address': 'Morada',
  'checkout.city': 'Cidade',
  'checkout.country': 'País',
  'checkout.postalCode': 'Código postal',
  'checkout.cardNumber': 'Número do cartão',
  'checkout.expiryDate': 'Data de validade',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Igual ao endereço de envio',
  'customer.orders': 'Pedidos',
  'customer.messages': 'Mensagens',
  'customer.returns': 'Devoluções',
  'customer.orderHistory': 'Histórico de pedidos',
  'customer.noOrders': 'Sem pedidos ainda',
  'customer.orderNo': 'Pedido #',
  'customer.orderDate': 'Data',
  'customer.orderStatus': 'Estado',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Ver detalhes',
  'customer.backToOrders': 'Voltar aos pedidos',
  'customer.orderDetail': 'Detalhes do pedido',
  'customer.requestReturn': 'Solicitar devolução',
  'customer.returnReason': 'Motivo da devolução',
  'customer.returnDescription': 'Detalhes adicionais (opcional)',
  'customer.submitReturn': 'Enviar pedido de devolução',
  'customer.returnSuccess': 'O seu pedido de devolução foi enviado com sucesso.',
  'customer.returnPending': 'Um representante irá analisá-lo em breve.',
  'customer.conversations': 'Conversas',
  'customer.noMessages': 'Sem conversas ainda',
  'customer.send': 'Enviar',
  'customer.returnStatus.pending': 'Pendente',
  'customer.returnStatus.approved': 'Aprovado',
  'customer.returnStatus.rejected': 'Rejeitado',
  'customer.returnStatus.processing': 'Em processamento',
  'customer.returnId': 'ID de devolução',
  'customer.orderId': 'ID do pedido',
  'customer.reason': 'Motivo',
  'customer.description': 'Descrição',
  'customer.noReturns': 'Sem devoluções submetidas ainda',
  'customer.noReturnsHint': 'Se precisar de devolver um artigo, vá aos detalhes do seu pedido e clique em "Solicitar devolução".',
  'vendor.dashboard': 'Painel',
  'vendor.myListings': 'Os meus anúncios',
  'vendor.orders': 'Pedidos',
  'vendor.addListing': 'Adicionar anúncio',
  'vendor.bulkImport': 'Importação em massa',
  'vendor.revenue': 'Receita',
  'vendor.totalOrders': 'Pedidos',
  'vendor.totalListings': 'Anúncios',
  'vendor.totalViews': 'Visualizações',
  'vendor.recentOrders': 'Pedidos recentes',
  'vendor.noOrders': 'Sem pedidos ainda',
  'vendor.editListing': 'Editar',
  'vendor.deleteListing': 'Eliminar',
  'vendor.priceLabel': 'Preço ({symbol}) *',
  'vendor.importCSV': 'Importar anúncios CSV',
  'vendor.downloadTemplate': 'Descarregar modelo CSV',
  'vendor.chooseFile': 'Escolher ficheiro CSV',
  'vendor.startImport': 'Iniciar importação',
  'vendor.instructions': 'Como importar',
  'vendor.previewData': 'Pré-visualização (primeiras 5 linhas)',
  'vendor.importResults': 'Resultados da importação',
  'vendor.listingsCreated': 'anúncios criados',
  'vendor.errors': 'Erros',
  'vendor.noFile': 'Nenhum ficheiro selecionado',
  'vendor.requiredColumns': 'Carregue um ficheiro CSV com as seguintes colunas. Apenas título e preço são obrigatórios.',
  'admin.users': 'Utilizadores',
  'admin.sellers': 'Vendedores',
  'admin.listings': 'Anúncios',
  'admin.orders': 'Pedidos',
  'admin.approve': 'Aprovar',
  'admin.suspend': 'Suspender',
  'admin.delete': 'Eliminar',
  'admin.totalUsers': 'Total de utilizadores',
  'admin.totalSellers': 'Total de vendedores',
  'admin.totalListings': 'Total de anúncios',
  'admin.totalOrders': 'Total de pedidos',
  'admin.pendingSellers': 'Vendedores pendentes',
  'admin.email': 'E-mail',
  'admin.name': 'Nome',
  'admin.role': 'Função',
  'admin.status': 'Estado',
  'admin.actions': 'Ações',
  'admin.company': 'Empresa',
  'admin.rating': 'Avaliação',
  'admin.sales': 'Vendas',
  'admin.title': 'Título',
  'admin.price': 'Preço',
  'admin.category': 'Categoria',
  'admin.orderNo': 'Pedido #',
  'admin.buyer': 'Comprador',
  'admin.date': 'Data',
  'admin.total': 'Total',
  'home.heroTitle': "Loja online de peças auto usadas · 4,2 M+ peças",
  'home.heroSubtitle': "Encontre peças originais e de substituição para qualquer veículo europeu. Entrega para a UE, Reino Unido e Noruega.",
  'home.searchHero': 'Pesquisar por número de peça, marca ou palavra-chave',
  'home.featuredParts': 'Peças em destaque',
  'home.viewAll': 'Ver todas as peças',
  'home.freeShipping': "Entrega UE, Reino Unido e Noruega",
  'home.freeShippingDesc': "Entrega para a UE, Reino Unido e Noruega",
  'home.returns': 'Devoluções em 14 dias',
  'home.returnsDesc': 'Política de devoluções sem complicações',
  'home.securePayment': 'Pagamento seguro',
  'home.securePaymentDesc': 'Transações encriptadas SSL',
  'home.qualityParts': 'Peças de qualidade',
  'home.qualityPartsDesc': "Peças originais do fabricante",
  'home.whyChoose': 'Porquê escolher zivu.eu?',
  'home.trustedSellers': "Compatibilidade verificada",
  'home.trustedSellersDesc': "Cada peça é fotografada e a compatibilidade verificada antes da publicação",
  'makes.title': 'Marcas de veículos',
  'makes.subtitle': 'Pesquisar peças por fabricante de veículos',
  'makes.searchPlaceholder': 'Pesquisar marcas...',
  'makes.popular': 'Marcas populares',
  'makeDetail.subtitle': 'Pesquisar modelos e encontrar peças',
  'makeDetail.selectModel': 'Selecionar modelo',
  'makeDetail.selectYear': 'Selecionar ano',
  'footer.tagline': "Loja online de peças auto usadas e recondicionadas. Envio para a UE, Reino Unido e Noruega.",
  'footer.shop': 'Loja',
  'footer.allParts': 'Todas as peças',
  'footer.engineParts': 'Peças de motor',
  'footer.bodyParts': 'Peças de carroçaria',
  'footer.electrical': 'Elétrico',
  'footer.refurbished': 'Recondicionado',
  'footer.information': 'Informação',
  'footer.aboutUs': 'Sobre nós',
  'footer.deliveryInfo': 'Info de entrega',
  'footer.returnsRefunds': 'Devoluções e reembolsos',
  'footer.paymentMethods': 'Métodos de pagamento',
  'footer.contactUs': 'Contacte-nos',
  'footer.support': 'Suporte',
  'footer.helpCenter': 'Centro de ajuda',
  'footer.shippingInfo': 'Info de envio',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garantia',
  'footer.sellers': 'Vendedores',
  'footer.sellOnZivu': 'Vender na zivu.eu',
  'footer.sellerPortal': 'Portal do vendedor',
  'footer.sellerTerms': 'Termos do vendedor',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.euMarketplace': "UE · RU · Noruega",
};

const ro = {
  'nav.home': 'Acasă',
  'nav.allParts': 'Toate piesele',
  'nav.cart': 'Coș',
  'nav.myAccount': 'Contul meu',
  'nav.myOrders': 'Comenzile mele',
  'nav.sellerPortal': 'Portal vânzător',
  'nav.adminPanel': 'Panou admin',
  'nav.login': 'Autentificare',
  'nav.register': 'Înregistrare',
  'nav.logout': 'Deconectare',
  'nav.makes': 'Mărci vehicule',
  'header.freeShipping': "Livrare rapidă în UE, Regatul Unit și Norvegia",
  'header.returns': 'Returnare în 14 zile',
  'header.light': 'Luminos',
  'header.dark': 'Întunecat',
  'header.searchPlaceholder': 'Caută după număr piesă, cod OEM sau cuvânt cheie...',
  'header.searchMobile': 'Caută piese...',
  'search.partsFound': '{count} piese găsite',
  'search.sortBy': 'Sortare',
  'search.relevance': 'Relevanță',
  'search.priceLowHigh': 'Preț: Mic la mare',
  'search.priceHighLow': 'Preț: Mare la mic',
  'search.newest': 'Cele mai noi',
  'search.priceRange': 'Interval preț',
  'search.make': 'Marcă',
  'search.model': 'Model',
  'search.year': 'An',
  'search.category': 'Categorie',
  'search.subcategory': 'Subcategorie',
  'search.condition': 'Stare',
  'search.allMakes': 'Toate mărcile',
  'search.allModels': 'Toate modelele',
  'search.allYears': 'Toți anii',
  'search.allCategories': 'Toate categoriile',
  'search.allSubcategories': 'Toate subcategoriile',
  'search.allConditions': 'Toate stările',
  'search.clearFilters': 'Șterge toate filtrele',
  'search.noResults': 'Nu s-au găsit piese care să corespundă criteriilor tale',
  'search.noResultsHint': 'Încearcă să lărgești căutarea sau să ajustezi filtrele',
  'search.addToCart': 'Adaugă în coș',
  'product.addToCart': 'Adaugă în coș',
  'product.freeShipping': "Expediere în UE, Regatul Unit și Norvegia",
  'product.reviews': 'Recenzii',
  'product.writeReview': 'Scrie recenzie',
  'product.signInReview': 'Autentifică-te pentru a scrie o recenzie',
  'product.noReviews': 'Fără recenzii deocamdată. Fii primul!',
  'product.seller': 'Vânzător',
  'product.condition': 'Stare',
  'product.oemCodes': 'Coduri OEM',
  'product.inStock': 'În stoc ({qty} disponibil)',
  'product.outOfStock': 'Stoc epuizat',
  'product.reviewTitle': 'Titlu',
  'product.reviewContent': 'Recenzie',
  'product.submitReview': 'Trimite recenzie',
  'product.avgRating': 'Rating mediu',
  'product.ratingDist': 'Distribuție rating',
  'cart.title': 'Coș de cumpărături',
  'cart.empty': 'Coșul tău este gol',
  'cart.emptyHint': 'Răsfoiește selecția noastră de piese auto',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Livrare',
  'cart.total': 'Total',
  'cart.checkout': 'Finalizare comandă',
  'cart.each': 'bucată',
  'cart.continueShopping': 'Continuă cumpărăturile',
  'cart.freeShipping': 'Livrarea se calculează la checkout',
  'checkout.orderSummary': 'Sumar comandă',
  'checkout.subtotal': 'Subtotal',
  'checkout.shipping': 'Livrare',
  'checkout.total': 'Total',
  'checkout.placeOrder': 'Plasează comanda',
  'checkout.processing': 'Se procesează...',
  'checkout.shippingInfo': 'Informații livrare',
  'checkout.billingInfo': 'Informații facturare',
  'checkout.paymentInfo': 'Informații plată',
  'checkout.firstName': 'Prenume',
  'checkout.lastName': 'Nume',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adresă',
  'checkout.city': 'Oraș',
  'checkout.country': 'Țară',
  'checkout.postalCode': 'Cod poștal',
  'checkout.cardNumber': 'Număr card',
  'checkout.expiryDate': 'Data expirării',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Același cu adresa de livrare',
  'customer.orders': 'Comenzi',
  'customer.messages': 'Mesaje',
  'customer.returns': 'Returnări',
  'customer.orderHistory': 'Istoric comenzi',
  'customer.noOrders': 'Fără comenzi deocamdată',
  'customer.orderNo': 'Comanda #',
  'customer.orderDate': 'Dată',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Total',
  'customer.viewDetails': 'Vezi detalii',
  'customer.backToOrders': 'Înapoi la comenzi',
  'customer.orderDetail': 'Detalii comandă',
  'customer.requestReturn': 'Solicită returnare',
  'customer.returnReason': 'Motivul returnării',
  'customer.returnDescription': 'Detalii suplimentare (opțional)',
  'customer.submitReturn': 'Trimite cerere returnare',
  'customer.returnSuccess': 'Cererea ta de returnare a fost trimisă cu succes.',
  'customer.returnPending': 'Un reprezentant o va examina în curând.',
  'customer.conversations': 'Conversații',
  'customer.noMessages': 'Fără conversații deocamdată',
  'customer.send': 'Trimite',
  'customer.returnStatus.pending': 'În așteptare',
  'customer.returnStatus.approved': 'Aprobat',
  'customer.returnStatus.rejected': 'Respins',
  'customer.returnStatus.processing': 'În procesare',
  'customer.returnId': 'ID returnare',
  'customer.orderId': 'ID comandă',
  'customer.reason': 'Motiv',
  'customer.description': 'Descriere',
  'customer.noReturns': 'Fără returnări trimise deocamdată',
  'customer.noReturnsHint': 'Dacă trebuie să returnezi un articol, mergi la detaliile comenzii și apasă "Solicită returnare".',
  'vendor.dashboard': 'Panou de control',
  'vendor.myListings': 'Anunțurile mele',
  'vendor.orders': 'Comenzi',
  'vendor.addListing': 'Adaugă anunț',
  'vendor.bulkImport': 'Import în masă',
  'vendor.revenue': 'Venituri',
  'vendor.totalOrders': 'Comenzi',
  'vendor.totalListings': 'Anunțuri',
  'vendor.totalViews': 'Vizualizări',
  'vendor.recentOrders': 'Comenzi recente',
  'vendor.noOrders': 'Fără comenzi deocamdată',
  'vendor.editListing': 'Editează',
  'vendor.deleteListing': 'Șterge',
  'vendor.priceLabel': 'Preț ({symbol}) *',
  'vendor.importCSV': 'Importă anunțuri CSV',
  'vendor.downloadTemplate': 'Descarcă șablon CSV',
  'vendor.chooseFile': 'Alege fișier CSV',
  'vendor.startImport': 'Începe importul',
  'vendor.instructions': 'Cum să imporți',
  'vendor.previewData': 'Previzualizare (primele 5 rânduri)',
  'vendor.importResults': 'Rezultate import',
  'vendor.listingsCreated': 'anunțuri create',
  'vendor.errors': 'Erori',
  'vendor.noFile': 'Niciun fișier selectat',
  'vendor.requiredColumns': 'Încarcă un fișier CSV cu următoarele coloane. Doar titlul și prețul sunt obligatorii.',
  'admin.users': 'Utilizatori',
  'admin.sellers': 'Vânzători',
  'admin.listings': 'Anunțuri',
  'admin.orders': 'Comenzi',
  'admin.approve': 'Aprobă',
  'admin.suspend': 'Suspendă',
  'admin.delete': 'Șterge',
  'admin.totalUsers': 'Total utilizatori',
  'admin.totalSellers': 'Total vânzători',
  'admin.totalListings': 'Total anunțuri',
  'admin.totalOrders': 'Total comenzi',
  'admin.pendingSellers': 'Vânzători în așteptare',
  'admin.email': 'E-mail',
  'admin.name': 'Nume',
  'admin.role': 'Rol',
  'admin.status': 'Status',
  'admin.actions': 'Acțiuni',
  'admin.company': 'Companie',
  'admin.rating': 'Rating',
  'admin.sales': 'Vânzări',
  'admin.title': 'Titlu',
  'admin.price': 'Preț',
  'admin.category': 'Categorie',
  'admin.orderNo': 'Comanda #',
  'admin.buyer': 'Cumpărător',
  'admin.date': 'Dată',
  'admin.total': 'Total',
  'home.heroTitle': "Magazin online de piese auto second-hand · 4,2 M+ piese",
  'home.heroSubtitle': "Găsește piese originale și aftermarket pentru orice vehicul european. Livrare în UE, Regatul Unit și Norvegia.",
  'home.searchHero': 'Caută după număr piesă, marcă sau cuvânt cheie',
  'home.featuredParts': 'Piese recomandate',
  'home.viewAll': 'Vezi toate piesele',
  'home.freeShipping': "Livrare UE, Regatul Unit și Norvegia",
  'home.freeShippingDesc': "Livrare în UE, Regatul Unit și Norvegia",
  'home.returns': 'Returnare în 14 zile',
  'home.returnsDesc': 'Politică de returnare fără probleme',
  'home.securePayment': 'Plată sigură',
  'home.securePaymentDesc': 'Tranzacții criptate SSL',
  'home.qualityParts': 'Piese de calitate',
  'home.qualityPartsDesc': "Piese originale de la producător",
  'home.whyChoose': 'De ce să alegi zivu.eu?',
  'home.trustedSellers': "Compatibilitate verificată",
  'home.trustedSellersDesc': "Fiecare piesă este fotografiată și compatibilitatea verificată înainte de publicare",
  'makes.title': 'Mărci vehicule',
  'makes.subtitle': 'Răsfoiește piese după producătorul vehiculului',
  'makes.searchPlaceholder': 'Caută mărci...',
  'makes.popular': 'Mărci populare',
  'makeDetail.subtitle': 'Răsfoiește modele și găsește piese',
  'makeDetail.selectModel': 'Selectează model',
  'makeDetail.selectYear': 'Selectează an',
  'footer.tagline': "Magazin online de piese auto second-hand și recondiționate. Livrare în UE, Regatul Unit și Norvegia.",
  'footer.shop': 'Magazin',
  'footer.allParts': 'Toate piesele',
  'footer.engineParts': 'Piese motor',
  'footer.bodyParts': 'Piese caroserie',
  'footer.electrical': 'Electrice',
  'footer.refurbished': 'Reconditionate',
  'footer.information': 'Informații',
  'footer.aboutUs': 'Despre noi',
  'footer.deliveryInfo': 'Info livrare',
  'footer.returnsRefunds': 'Returnări și rambursări',
  'footer.paymentMethods': 'Metode de plată',
  'footer.contactUs': 'Contactează-ne',
  'footer.support': 'Suport',
  'footer.helpCenter': 'Centru de ajutor',
  'footer.shippingInfo': 'Info expediere',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garanție',
  'footer.sellers': 'Vânzători',
  'footer.sellOnZivu': 'Vinde pe zivu.eu',
  'footer.sellerPortal': 'Portal vânzător',
  'footer.sellerTerms': 'Termeni vânzător',
  'footer.privacy': 'Confidențialitate',
  'footer.terms': 'Termeni',
  'footer.euMarketplace': "UE · RU · Norvegia",
};

const cs = {
  'nav.home': 'Domů',
  'nav.allParts': 'Všechny díly',
  'nav.cart': 'Košík',
  'nav.myAccount': 'Můj účet',
  'nav.myOrders': 'Moje objednávky',
  'nav.sellerPortal': 'Portál prodejce',
  'nav.adminPanel': 'Administrace',
  'nav.login': 'Přihlásit se',
  'nav.register': 'Registrovat',
  'nav.logout': 'Odhlásit se',
  'nav.makes': 'Značky vozidel',
  'header.freeShipping': "Rychlé doručení do EU, Velké Británie a Norska",
  'header.returns': '14denní vrácení',
  'header.light': 'Světlý',
  'header.dark': 'Tmavý',
  'header.searchPlaceholder': 'Hledat podle čísla dílu, OEM kódu nebo klíčového slova...',
  'header.searchMobile': 'Hledat díly...',
  'search.partsFound': 'Nalezeno {count} dílů',
  'search.sortBy': 'Řadit podle',
  'search.relevance': 'Relevance',
  'search.priceLowHigh': 'Cena: od nejnižší',
  'search.priceHighLow': 'Cena: od nejvyšší',
  'search.newest': 'Nejnovější',
  'search.priceRange': 'Cenové rozmezí',
  'search.make': 'Značka',
  'search.model': 'Model',
  'search.year': 'Rok',
  'search.category': 'Kategorie',
  'search.subcategory': 'Podkategorie',
  'search.condition': 'Stav',
  'search.allMakes': 'Všechny značky',
  'search.allModels': 'Všechny modely',
  'search.allYears': 'Všechny roky',
  'search.allCategories': 'Všechny kategorie',
  'search.allSubcategories': 'Všechny podkategorie',
  'search.allConditions': 'Všechny stavy',
  'search.clearFilters': 'Vymazat všechny filtry',
  'search.noResults': 'Žádné díly neodpovídají vašim kritériím',
  'search.noResultsHint': 'Zkuste rozšířit vyhledávání nebo upravit filtry',
  'search.addToCart': 'Přidat do košíku',
  'product.addToCart': 'Přidat do košíku',
  'product.freeShipping': "Doručení do EU, Velké Británie a Norska",
  'product.reviews': 'Recenze',
  'product.writeReview': 'Napsat recenzi',
  'product.signInReview': 'Přihlaste se pro napsání recenze',
  'product.noReviews': 'Zatím žádné recenze. Buďte první!',
  'product.seller': 'Prodejce',
  'product.condition': 'Stav',
  'product.oemCodes': 'OEM kódy',
  'product.inStock': 'Skladem ({qty} dostupných)',
  'product.outOfStock': 'Vyprodáno',
  'product.reviewTitle': 'Nadpis',
  'product.reviewContent': 'Recenze',
  'product.submitReview': 'Odeslat recenzi',
  'product.avgRating': 'Průměrné hodnocení',
  'product.ratingDist': 'Rozdělení hodnocení',
  'cart.title': 'Nákupní košík',
  'cart.empty': 'Váš košík je prázdný',
  'cart.emptyHint': 'Prohlédněte si naši nabídku autodílů',
  'cart.subtotal': 'Mezisoučet',
  'cart.shipping': 'Doprava',
  'cart.total': 'Celkem',
  'cart.checkout': 'Přejít k pokladně',
  'cart.each': 'ks',
  'cart.continueShopping': 'Pokračovat v nakupování',
  'cart.freeShipping': 'Doprava se vypočítá při platbě',
  'checkout.orderSummary': 'Shrnutí objednávky',
  'checkout.subtotal': 'Mezisoučet',
  'checkout.shipping': 'Doprava',
  'checkout.total': 'Celkem',
  'checkout.placeOrder': 'Objednat',
  'checkout.processing': 'Zpracovává se...',
  'checkout.shippingInfo': 'Doručovací adresa',
  'checkout.billingInfo': 'Fakturační adresa',
  'checkout.paymentInfo': 'Platební údaje',
  'checkout.firstName': 'Jméno',
  'checkout.lastName': 'Příjmení',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adresa',
  'checkout.city': 'Město',
  'checkout.country': 'Země',
  'checkout.postalCode': 'PSČ',
  'checkout.cardNumber': 'Číslo karty',
  'checkout.expiryDate': 'Datum vypršení',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Stejná jako doručovací adresa',
  'customer.orders': 'Objednávky',
  'customer.messages': 'Zprávy',
  'customer.returns': 'Vrácení',
  'customer.orderHistory': 'Historie objednávek',
  'customer.noOrders': 'Zatím žádné objednávky',
  'customer.orderNo': 'Objednávka #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Stav',
  'customer.orderTotal': 'Celkem',
  'customer.viewDetails': 'Zobrazit detaily',
  'customer.backToOrders': 'Zpět na objednávky',
  'customer.orderDetail': 'Detaily objednávky',
  'customer.requestReturn': 'Požádat o vrácení',
  'customer.returnReason': 'Důvod vrácení',
  'customer.returnDescription': 'Další podrobnosti (nepovinné)',
  'customer.submitReturn': 'Odeslat žádost o vrácení',
  'customer.returnSuccess': 'Vaše žádost o vrácení byla úspěšně odeslána.',
  'customer.returnPending': 'Zástupce ji brzy zkontroluje.',
  'customer.conversations': 'Konverzace',
  'customer.noMessages': 'Zatím žádné konverzace',
  'customer.send': 'Odeslat',
  'customer.returnStatus.pending': 'Čeká',
  'customer.returnStatus.approved': 'Schváleno',
  'customer.returnStatus.rejected': 'Zamítnuto',
  'customer.returnStatus.processing': 'Zpracovává se',
  'customer.returnId': 'ID vrácení',
  'customer.orderId': 'ID objednávky',
  'customer.reason': 'Důvod',
  'customer.description': 'Popis',
  'customer.noReturns': 'Zatím žádná vrácení',
  'customer.noReturnsHint': 'Chcete-li vrátit zboží, přejděte na detaily objednávky a klikněte na "Požádat o vrácení".',
  'vendor.dashboard': 'Přehled',
  'vendor.myListings': 'Moje inzeráty',
  'vendor.orders': 'Objednávky',
  'vendor.addListing': 'Přidat inzerát',
  'vendor.bulkImport': 'Hromadný import',
  'vendor.revenue': 'Tržby',
  'vendor.totalOrders': 'Objednávky',
  'vendor.totalListings': 'Inzeráty',
  'vendor.totalViews': 'Zobrazení',
  'vendor.recentOrders': 'Poslední objednávky',
  'vendor.noOrders': 'Zatím žádné objednávky',
  'vendor.editListing': 'Upravit',
  'vendor.deleteListing': 'Smazat',
  'vendor.priceLabel': 'Cena ({symbol}) *',
  'vendor.importCSV': 'Importovat CSV inzeráty',
  'vendor.downloadTemplate': 'Stáhnout CSV šablonu',
  'vendor.chooseFile': 'Vybrat CSV soubor',
  'vendor.startImport': 'Spustit import',
  'vendor.instructions': 'Jak importovat',
  'vendor.previewData': 'Náhled (prvních 5 řádků)',
  'vendor.importResults': 'Výsledky importu',
  'vendor.listingsCreated': 'inzerátů vytvořeno',
  'vendor.errors': 'Chyby',
  'vendor.noFile': 'Žádný soubor nevybrán',
  'vendor.requiredColumns': 'Nahrajte CSV soubor s těmito sloupci. Pouze název a cena jsou povinné.',
  'admin.users': 'Uživatelé',
  'admin.sellers': 'Prodejci',
  'admin.listings': 'Inzeráty',
  'admin.orders': 'Objednávky',
  'admin.approve': 'Schválit',
  'admin.suspend': 'Pozastavit',
  'admin.delete': 'Smazat',
  'admin.totalUsers': 'Celkem uživatelů',
  'admin.totalSellers': 'Celkem prodejců',
  'admin.totalListings': 'Celkem inzerátů',
  'admin.totalOrders': 'Celkem objednávek',
  'admin.pendingSellers': 'Čekající prodejci',
  'admin.email': 'E-mail',
  'admin.name': 'Jméno',
  'admin.role': 'Role',
  'admin.status': 'Stav',
  'admin.actions': 'Akce',
  'admin.company': 'Společnost',
  'admin.rating': 'Hodnocení',
  'admin.sales': 'Prodeje',
  'admin.title': 'Název',
  'admin.price': 'Cena',
  'admin.category': 'Kategorie',
  'admin.orderNo': 'Objednávka #',
  'admin.buyer': 'Kupující',
  'admin.date': 'Datum',
  'admin.total': 'Celkem',
  'home.heroTitle': "E-shop s použitými autodíly · 4,2 mil.+ dílů",
  'home.heroSubtitle': "Najděte originální a náhradní díly pro jakékoli evropské vozidlo. Doručení do EU, Velké Británie a Norska.",
  'home.searchHero': 'Hledat číslo dílu, značku nebo klíčové slovo',
  'home.featuredParts': 'Doporučené díly',
  'home.viewAll': 'Zobrazit všechny díly',
  'home.freeShipping': "Doručení EU, Velká Británie a Norsko",
  'home.freeShippingDesc': "Doručení do EU, Velké Británie a Norska",
  'home.returns': 'Vrácení do 14 dnů',
  'home.returnsDesc': 'Jednoduché vrácení bez problémů',
  'home.securePayment': 'Bezpečná platba',
  'home.securePaymentDesc': 'SSL šifrované transakce',
  'home.qualityParts': 'Kvalitní díly',
  'home.qualityPartsDesc': "Originální díly výrobce",
  'home.whyChoose': 'Proč vybrat zivu.eu?',
  'home.trustedSellers': "Ověřená kompatibilita",
  'home.trustedSellersDesc': "Každý díl je před zveřejněním vyfotografován a ověřena jeho kompatibilita",
  'makes.title': 'Značky vozidel',
  'makes.subtitle': 'Procházet díly podle výrobce vozidla',
  'makes.searchPlaceholder': 'Hledat značky...',
  'makes.popular': 'Populární značky',
  'makeDetail.subtitle': 'Procházet modely a najít díly',
  'makeDetail.selectModel': 'Vybrat model',
  'makeDetail.selectYear': 'Vybrat rok',
  'footer.tagline': "E-shop s použitými a repasovanými autodíly. Doručení do EU, Velké Británie a Norska.",
  'footer.shop': 'Obchod',
  'footer.allParts': 'Všechny díly',
  'footer.engineParts': 'Díly motoru',
  'footer.bodyParts': 'Díly karoserie',
  'footer.electrical': 'Elektro',
  'footer.refurbished': 'Repasované',
  'footer.information': 'Informace',
  'footer.aboutUs': 'O nás',
  'footer.deliveryInfo': 'Info o doručení',
  'footer.returnsRefunds': 'Vrácení a refundace',
  'footer.paymentMethods': 'Způsoby platby',
  'footer.contactUs': 'Kontaktujte nás',
  'footer.support': 'Podpora',
  'footer.helpCenter': 'Centrum nápovědy',
  'footer.shippingInfo': 'Info o dopravě',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Záruka',
  'footer.sellers': 'Prodejci',
  'footer.sellOnZivu': 'Prodávat na zivu.eu',
  'footer.sellerPortal': 'Portál prodejce',
  'footer.sellerTerms': 'Podmínky prodejce',
  'footer.privacy': 'Soukromí',
  'footer.terms': 'Podmínky',
  'footer.euMarketplace': "EU · UK · Norsko",
};

const hu = {
  'nav.home': 'Főoldal',
  'nav.allParts': 'Összes alkatrész',
  'nav.cart': 'Kosár',
  'nav.myAccount': 'Fiókom',
  'nav.myOrders': 'Rendeléseim',
  'nav.sellerPortal': 'Eladói portál',
  'nav.adminPanel': 'Admin panel',
  'nav.login': 'Bejelentkezés',
  'nav.register': 'Regisztráció',
  'nav.logout': 'Kijelentkezés',
  'nav.makes': 'Járműmárkák',
  'header.freeShipping': "Gyors szállítás az EU-ba, az Egyesült Királyságba és Norvégiába",
  'header.returns': '14 napos visszaküldés',
  'header.light': 'Világos',
  'header.dark': 'Sötét',
  'header.searchPlaceholder': 'Keresés alkatrészszám, OEM kód vagy kulcsszó alapján...',
  'header.searchMobile': 'Alkatrészek keresése...',
  'search.partsFound': '{count} alkatrész található',
  'search.sortBy': 'Rendezés',
  'search.relevance': 'Relevancia',
  'search.priceLowHigh': 'Ár: Alacsonyabbtól magasabbig',
  'search.priceHighLow': 'Ár: Magasabbtól alacsonyabbig',
  'search.newest': 'Legújabb',
  'search.priceRange': 'Ártartomány',
  'search.make': 'Márka',
  'search.model': 'Modell',
  'search.year': 'Év',
  'search.category': 'Kategória',
  'search.subcategory': 'Alkategória',
  'search.condition': 'Állapot',
  'search.allMakes': 'Összes márka',
  'search.allModels': 'Összes modell',
  'search.allYears': 'Összes év',
  'search.allCategories': 'Összes kategória',
  'search.allSubcategories': 'Összes alkategória',
  'search.allConditions': 'Összes állapot',
  'search.clearFilters': 'Összes szűrő törlése',
  'search.noResults': 'Nem találtunk a keresési feltételeknek megfelelő alkatrészt',
  'search.noResultsHint': 'Próbálja bővíteni a keresést vagy módosítani a szűrőket',
  'search.addToCart': 'Kosárba',
  'product.addToCart': 'Kosárba',
  'product.freeShipping': "Szállítás az EU-ba, az Egyesült Királyságba és Norvégiába",
  'product.reviews': 'Vélemények',
  'product.writeReview': 'Vélemény írása',
  'product.signInReview': 'Jelentkezzen be vélemény írásához',
  'product.noReviews': 'Még nincs vélemény. Legyen Ön az első!',
  'product.seller': 'Eladó',
  'product.condition': 'Állapot',
  'product.oemCodes': 'OEM kódok',
  'product.inStock': 'Raktáron ({qty} elérhető)',
  'product.outOfStock': 'Elfogyott',
  'product.reviewTitle': 'Cím',
  'product.reviewContent': 'Vélemény',
  'product.submitReview': 'Vélemény beküldése',
  'product.avgRating': 'Átlagos értékelés',
  'product.ratingDist': 'Értékelések eloszlása',
  'cart.title': 'Bevásárlókosár',
  'cart.empty': 'A kosara üres',
  'cart.emptyHint': 'Böngésszen autóalkatrész-kínálatunkban',
  'cart.subtotal': 'Részösszeg',
  'cart.shipping': 'Szállítás',
  'cart.total': 'Összesen',
  'cart.checkout': 'Pénztár',
  'cart.each': 'db',
  'cart.continueShopping': 'Vásárlás folytatása',
  'cart.freeShipping': 'Szállítási díj a pénztárnál kerül kiszámításra',
  'checkout.orderSummary': 'Rendelés összefoglalója',
  'checkout.subtotal': 'Részösszeg',
  'checkout.shipping': 'Szállítás',
  'checkout.total': 'Összesen',
  'checkout.placeOrder': 'Rendelés leadása',
  'checkout.processing': 'Feldolgozás...',
  'checkout.shippingInfo': 'Szállítási cím',
  'checkout.billingInfo': 'Számlázási cím',
  'checkout.paymentInfo': 'Fizetési adatok',
  'checkout.firstName': 'Keresztnév',
  'checkout.lastName': 'Vezetéknév',
  'checkout.email': 'E-mail',
  'checkout.address': 'Cím',
  'checkout.city': 'Város',
  'checkout.country': 'Ország',
  'checkout.postalCode': 'Irányítószám',
  'checkout.cardNumber': 'Kártyaszám',
  'checkout.expiryDate': 'Lejárati dátum',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Ugyanaz mint a szállítási cím',
  'customer.orders': 'Rendelések',
  'customer.messages': 'Üzenetek',
  'customer.returns': 'Visszaküldések',
  'customer.orderHistory': 'Rendelési előzmények',
  'customer.noOrders': 'Még nincs rendelés',
  'customer.orderNo': 'Rendelés #',
  'customer.orderDate': 'Dátum',
  'customer.orderStatus': 'Státusz',
  'customer.orderTotal': 'Összesen',
  'customer.viewDetails': 'Részletek megtekintése',
  'customer.backToOrders': 'Vissza a rendelésekhez',
  'customer.orderDetail': 'Rendelés részletei',
  'customer.requestReturn': 'Visszaküldés kérése',
  'customer.returnReason': 'Visszaküldés oka',
  'customer.returnDescription': 'További részletek (opcionális)',
  'customer.submitReturn': 'Visszaküldési kérelem beküldése',
  'customer.returnSuccess': 'Visszaküldési kérelme sikeresen beérkezett.',
  'customer.returnPending': 'Egy munkatárs hamarosan megvizsgálja.',
  'customer.conversations': 'Beszélgetések',
  'customer.noMessages': 'Még nincs beszélgetés',
  'customer.send': 'Küldés',
  'customer.returnStatus.pending': 'Függőben',
  'customer.returnStatus.approved': 'Jóváhagyva',
  'customer.returnStatus.rejected': 'Elutasítva',
  'customer.returnStatus.processing': 'Feldolgozás alatt',
  'customer.returnId': 'Visszaküldés azonosítója',
  'customer.orderId': 'Rendelés azonosítója',
  'customer.reason': 'Ok',
  'customer.description': 'Leírás',
  'customer.noReturns': 'Még nincs beküldött visszaküldés',
  'customer.noReturnsHint': 'Ha vissza kell küldenie egy terméket, lépjen a rendelés részleteire és kattintson a "Visszaküldés kérése" gombra.',
  'vendor.dashboard': 'Irányítópult',
  'vendor.myListings': 'Hirdetéseim',
  'vendor.orders': 'Rendelések',
  'vendor.addListing': 'Hirdetés hozzáadása',
  'vendor.bulkImport': 'Tömeges import',
  'vendor.revenue': 'Bevétel',
  'vendor.totalOrders': 'Rendelések',
  'vendor.totalListings': 'Hirdetések',
  'vendor.totalViews': 'Megtekintések',
  'vendor.recentOrders': 'Legutóbbi rendelések',
  'vendor.noOrders': 'Még nincs rendelés',
  'vendor.editListing': 'Szerkesztés',
  'vendor.deleteListing': 'Törlés',
  'vendor.priceLabel': 'Ár ({symbol}) *',
  'vendor.importCSV': 'CSV hirdetések importálása',
  'vendor.downloadTemplate': 'CSV sablon letöltése',
  'vendor.chooseFile': 'CSV fájl kiválasztása',
  'vendor.startImport': 'Import indítása',
  'vendor.instructions': 'Importálási útmutató',
  'vendor.previewData': 'Előnézet (első 5 sor)',
  'vendor.importResults': 'Import eredmények',
  'vendor.listingsCreated': 'hirdetés létrehozva',
  'vendor.errors': 'Hibák',
  'vendor.noFile': 'Nincs kiválasztott fájl',
  'vendor.requiredColumns': 'Töltsön fel egy CSV fájlt a következő oszlopokkal. Csak a cím és az ár kötelező.',
  'admin.users': 'Felhasználók',
  'admin.sellers': 'Eladók',
  'admin.listings': 'Hirdetések',
  'admin.orders': 'Rendelések',
  'admin.approve': 'Jóváhagyás',
  'admin.suspend': 'Felfüggesztés',
  'admin.delete': 'Törlés',
  'admin.totalUsers': 'Összes felhasználó',
  'admin.totalSellers': 'Összes eladó',
  'admin.totalListings': 'Összes hirdetés',
  'admin.totalOrders': 'Összes rendelés',
  'admin.pendingSellers': 'Függőben lévő eladók',
  'admin.email': 'E-mail',
  'admin.name': 'Név',
  'admin.role': 'Szerepkör',
  'admin.status': 'Státusz',
  'admin.actions': 'Műveletek',
  'admin.company': 'Vállalat',
  'admin.rating': 'Értékelés',
  'admin.sales': 'Értékesítés',
  'admin.title': 'Cím',
  'admin.price': 'Ár',
  'admin.category': 'Kategória',
  'admin.orderNo': 'Rendelés #',
  'admin.buyer': 'Vevő',
  'admin.date': 'Dátum',
  'admin.total': 'Összesen',
  'home.heroTitle': "Használt autóalkatrész webáruház · 4,2 M+ alkatrész",
  'home.heroSubtitle': "Eredeti és utángyártott alkatrészek minden európai járműhöz. Kézbesítés az EU-ba, az Egyesült Királyságba és Norvégiába.",
  'home.searchHero': 'Keresés alkatrészszám, márka vagy kulcsszó alapján',
  'home.featuredParts': 'Kiemelt alkatrészek',
  'home.viewAll': 'Összes alkatrész megtekintése',
  'home.freeShipping': "Szállítás EU, Egyesült Királyság és Norvégia",
  'home.freeShippingDesc': "Kézbesítés az EU-ba, az Egyesült Királyságba és Norvégiába",
  'home.returns': '14 napos visszaküldés',
  'home.returnsDesc': 'Problémamentes visszaküldési politika',
  'home.securePayment': 'Biztonságos fizetés',
  'home.securePaymentDesc': 'SSL titkosított tranzakciók',
  'home.qualityParts': 'Minőségi alkatrészek',
  'home.qualityPartsDesc': "Eredeti gyári alkatrészek",
  'home.whyChoose': 'Miért válassza a zivu.eu-t?',
  'home.trustedSellers': "Ellenőrzött illeszkedés",
  'home.trustedSellersDesc': "Minden alkatrészt lefotózunk és ellenőrizzük az illeszkedést a feltöltés előtt",
  'makes.title': 'Járműmárkák',
  'makes.subtitle': 'Alkatrészek böngészése járműgyártó szerint',
  'makes.searchPlaceholder': 'Márkák keresése...',
  'makes.popular': 'Népszerű márkák',
  'makeDetail.subtitle': 'Modellek böngészése és alkatrészek keresése',
  'makeDetail.selectModel': 'Modell kiválasztása',
  'makeDetail.selectYear': 'Év kiválasztása',
  'footer.tagline': "Webáruház használt és felújított autóalkatrészekhez. Szállítás az EU-ba, az Egyesült Királyságba és Norvégiába.",
  'footer.shop': 'Bolt',
  'footer.allParts': 'Összes alkatrész',
  'footer.engineParts': 'Motor alkatrészek',
  'footer.bodyParts': 'Karosszéria alkatrészek',
  'footer.electrical': 'Elektromos',
  'footer.refurbished': 'Felújított',
  'footer.information': 'Információ',
  'footer.aboutUs': 'Rólunk',
  'footer.deliveryInfo': 'Szállítási információ',
  'footer.returnsRefunds': 'Visszaküldések és visszatérítések',
  'footer.paymentMethods': 'Fizetési módok',
  'footer.contactUs': 'Kapcsolatfelvétel',
  'footer.support': 'Támogatás',
  'footer.helpCenter': 'Súgóközpont',
  'footer.shippingInfo': 'Szállítási információ',
  'footer.faq': 'GYIK',
  'footer.warranty': 'Garancia',
  'footer.sellers': 'Eladók',
  'footer.sellOnZivu': 'Eladás a zivu.eu-n',
  'footer.sellerPortal': 'Eladói portál',
  'footer.sellerTerms': 'Eladói feltételek',
  'footer.privacy': 'Adatvédelem',
  'footer.terms': 'Feltételek',
  'footer.euMarketplace': "EU · UK · Norvégia",
};

const bg = {
  'nav.home': 'Начало',
  'nav.allParts': 'Всички части',
  'nav.cart': 'Кошница',
  'nav.myAccount': 'Моят акаунт',
  'nav.myOrders': 'Моите поръчки',
  'nav.sellerPortal': 'Портал на продавача',
  'nav.adminPanel': 'Администраторски панел',
  'nav.login': 'Вход',
  'nav.register': 'Регистрация',
  'nav.logout': 'Изход',
  'nav.makes': 'Марки автомобили',
  'header.freeShipping': "Бърза доставка до ЕС, Обединеното кралство и Норвегия",
  'header.returns': '14-дневно връщане',
  'header.light': 'Светъл',
  'header.dark': 'Тъмен',
  'header.searchPlaceholder': 'Търсене по номер на части, OEM код или ключова дума...',
  'header.searchMobile': 'Търсене на части...',
  'search.partsFound': 'Намерени {count} части',
  'search.sortBy': 'Сортиране',
  'search.relevance': 'Уместност',
  'search.priceLowHigh': 'Цена: Ниска към висока',
  'search.priceHighLow': 'Цена: Висока към ниска',
  'search.newest': 'Най-нови',
  'search.priceRange': 'Ценови диапазон',
  'search.make': 'Марка',
  'search.model': 'Модел',
  'search.year': 'Година',
  'search.category': 'Категория',
  'search.subcategory': 'Подкатегория',
  'search.condition': 'Състояние',
  'search.allMakes': 'Всички марки',
  'search.allModels': 'Всички модели',
  'search.allYears': 'Всички години',
  'search.allCategories': 'Всички категории',
  'search.allSubcategories': 'Всички подкатегории',
  'search.allConditions': 'Всички състояния',
  'search.clearFilters': 'Изчистване на всички филтри',
  'search.noResults': 'Не са намерени части, отговарящи на вашите критерии',
  'search.noResultsHint': 'Опитайте да разширите търсенето или да коригирате филтрите',
  'search.addToCart': 'Добави в кошницата',
  'product.addToCart': 'Добави в кошницата',
  'product.freeShipping': "Доставка до ЕС, Обединеното кралство и Норвегия",
  'product.reviews': 'Отзиви',
  'product.writeReview': 'Напишете отзив',
  'product.signInReview': 'Влезте, за да напишете отзив',
  'product.noReviews': 'Все още няма отзиви. Бъдете първи!',
  'product.seller': 'Продавач',
  'product.condition': 'Състояние',
  'product.oemCodes': 'OEM кодове',
  'product.inStock': 'В наличност ({qty} налични)',
  'product.outOfStock': 'Изчерпано',
  'product.reviewTitle': 'Заглавие',
  'product.reviewContent': 'Отзив',
  'product.submitReview': 'Изпрати отзив',
  'product.avgRating': 'Средна оценка',
  'product.ratingDist': 'Разпределение на оценките',
  'cart.title': 'Пазарска кошница',
  'cart.empty': 'Вашата кошница е празна',
  'cart.emptyHint': 'Разгледайте нашия избор от авточасти',
  'cart.subtotal': 'Междинна сума',
  'cart.shipping': 'Доставка',
  'cart.total': 'Общо',
  'cart.checkout': 'Към каса',
  'cart.each': 'бр.',
  'cart.continueShopping': 'Продължи пазаруването',
  'cart.freeShipping': 'Доставката се изчислява при плащане',
  'checkout.orderSummary': 'Обобщение на поръчката',
  'checkout.subtotal': 'Междинна сума',
  'checkout.shipping': 'Доставка',
  'checkout.total': 'Общо',
  'checkout.placeOrder': 'Направи поръчка',
  'checkout.processing': 'Обработване...',
  'checkout.shippingInfo': 'Адрес за доставка',
  'checkout.billingInfo': 'Адрес за фактуриране',
  'checkout.paymentInfo': 'Данни за плащане',
  'checkout.firstName': 'Собствено име',
  'checkout.lastName': 'Фамилия',
  'checkout.email': 'Имейл',
  'checkout.address': 'Адрес',
  'checkout.city': 'Град',
  'checkout.country': 'Държава',
  'checkout.postalCode': 'Пощенски код',
  'checkout.cardNumber': 'Номер на карта',
  'checkout.expiryDate': 'Дата на изтичане',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Същото като адреса за доставка',
  'customer.orders': 'Поръчки',
  'customer.messages': 'Съобщения',
  'customer.returns': 'Върнати стоки',
  'customer.orderHistory': 'История на поръчките',
  'customer.noOrders': 'Все още няма поръчки',
  'customer.orderNo': 'Поръчка #',
  'customer.orderDate': 'Дата',
  'customer.orderStatus': 'Статус',
  'customer.orderTotal': 'Общо',
  'customer.viewDetails': 'Виж детайли',
  'customer.backToOrders': 'Обратно към поръчките',
  'customer.orderDetail': 'Детайли на поръчката',
  'customer.requestReturn': 'Искане за връщане',
  'customer.returnReason': 'Причина за връщане',
  'customer.returnDescription': 'Допълнителни детайли (незадължително)',
  'customer.submitReturn': 'Изпрати заявка за връщане',
  'customer.returnSuccess': 'Вашата заявка за връщане е изпратена успешно.',
  'customer.returnPending': 'Представител скоро ще я прегледа.',
  'customer.conversations': 'Разговори',
  'customer.noMessages': 'Все още няма разговори',
  'customer.send': 'Изпрати',
  'customer.returnStatus.pending': 'Изчакване',
  'customer.returnStatus.approved': 'Одобрено',
  'customer.returnStatus.rejected': 'Отказано',
  'customer.returnStatus.processing': 'Обработване',
  'customer.returnId': 'ИД на връщане',
  'customer.orderId': 'ИД на поръчка',
  'customer.reason': 'Причина',
  'customer.description': 'Описание',
  'customer.noReturns': 'Все още няма изпратени връщания',
  'customer.noReturnsHint': 'Ако трябва да върнете артикул, отидете в детайлите на поръчката и кликнете "Искане за връщане".',
  'vendor.dashboard': 'Табло',
  'vendor.myListings': 'Моите обяви',
  'vendor.orders': 'Поръчки',
  'vendor.addListing': 'Добави обява',
  'vendor.bulkImport': 'Масов импорт',
  'vendor.revenue': 'Приходи',
  'vendor.totalOrders': 'Поръчки',
  'vendor.totalListings': 'Обяви',
  'vendor.totalViews': 'Прегледи',
  'vendor.recentOrders': 'Последни поръчки',
  'vendor.noOrders': 'Все още няма поръчки',
  'vendor.editListing': 'Редактирай',
  'vendor.deleteListing': 'Изтрий',
  'vendor.priceLabel': 'Цена ({symbol}) *',
  'vendor.importCSV': 'Импортиране на CSV обяви',
  'vendor.downloadTemplate': 'Изтегли CSV шаблон',
  'vendor.chooseFile': 'Избери CSV файл',
  'vendor.startImport': 'Стартирай импорт',
  'vendor.instructions': 'Как да импортирате',
  'vendor.previewData': 'Преглед (първите 5 реда)',
  'vendor.importResults': 'Резултати от импорта',
  'vendor.listingsCreated': 'обяви създадени',
  'vendor.errors': 'Грешки',
  'vendor.noFile': 'Няма избран файл',
  'vendor.requiredColumns': 'Качете CSV файл със следните колони. Само заглавие и цена са задължителни.',
  'admin.users': 'Потребители',
  'admin.sellers': 'Продавачи',
  'admin.listings': 'Обяви',
  'admin.orders': 'Поръчки',
  'admin.approve': 'Одобри',
  'admin.suspend': 'Спри',
  'admin.delete': 'Изтрий',
  'admin.totalUsers': 'Общо потребители',
  'admin.totalSellers': 'Общо продавачи',
  'admin.totalListings': 'Общо обяви',
  'admin.totalOrders': 'Общо поръчки',
  'admin.pendingSellers': 'Чакащи продавачи',
  'admin.email': 'Имейл',
  'admin.name': 'Ime',
  'admin.role': 'Роля',
  'admin.status': 'Статус',
  'admin.actions': 'Действия',
  'admin.company': 'Компания',
  'admin.rating': 'Оценка',
  'admin.sales': 'Продажби',
  'admin.title': 'Заглавие',
  'admin.price': 'Цена',
  'admin.category': 'Категория',
  'admin.orderNo': 'Поръчка #',
  'admin.buyer': 'Купувач',
  'admin.date': 'Дата',
  'admin.total': 'Общо',
  'home.heroTitle': "Онлайн магазин за употребявани авточасти · 4,2 млн.+ части",
  'home.heroSubtitle': "Намерете оригинални и алтернативни части за всяко европейско превозно средство. Доставка до ЕС, Обединеното кралство и Норвегия.",
  'home.searchHero': 'Търсене по номер на части, марка или ключова дума',
  'home.featuredParts': 'Препоръчани части',
  'home.viewAll': 'Виж всички части',
  'home.freeShipping': "Доставка ЕС, Обединеното кралство и Норвегия",
  'home.freeShippingDesc': "Доставка до ЕС, Обединеното кралство и Норвегия",
  'home.returns': '14-дневно връщане',
  'home.returnsDesc': 'Безпроблемна политика за връщане',
  'home.securePayment': 'Сигурно плащане',
  'home.securePaymentDesc': 'SSL криптирани транзакции',
  'home.qualityParts': 'Качествени части',
  'home.qualityPartsDesc': "Оригинални части от производителя",
  'home.whyChoose': 'Защо да изберете zivu.eu?',
  'home.trustedSellers': "Проверена съвместимост",
  'home.trustedSellersDesc': "Всяка част се снима и съвместимостта се проверява преди публикуване",
  'makes.title': 'Марки автомобили',
  'makes.subtitle': 'Разглеждане на части по производител на превозно средство',
  'makes.searchPlaceholder': 'Търси марки...',
  'makes.popular': 'Популярни марки',
  'makeDetail.subtitle': 'Разглеждане на модели и намиране на части',
  'makeDetail.selectModel': 'Избери модел',
  'makeDetail.selectYear': 'Избери година',
  'footer.tagline': "Онлайн магазин за употребявани и рециклирани авточасти. Доставка до ЕС, Обединеното кралство и Норвегия.",
  'footer.shop': 'Магазин',
  'footer.allParts': 'Всички части',
  'footer.engineParts': 'Части за двигател',
  'footer.bodyParts': 'Части за каросерия',
  'footer.electrical': 'Електрически',
  'footer.refurbished': 'Рециклирани',
  'footer.information': 'Информация',
  'footer.aboutUs': 'За нас',
  'footer.deliveryInfo': 'Информация за доставка',
  'footer.returnsRefunds': 'Връщания и възстановявания',
  'footer.paymentMethods': 'Методи на плащане',
  'footer.contactUs': 'Свържете се с нас',
  'footer.support': 'Поддръжка',
  'footer.helpCenter': 'Помощен център',
  'footer.shippingInfo': 'Информация за изпращане',
  'footer.faq': 'ЧЗВ',
  'footer.warranty': 'Гаранция',
  'footer.sellers': 'Продавачи',
  'footer.sellOnZivu': 'Продавайте в zivu.eu',
  'footer.sellerPortal': 'Портал на продавача',
  'footer.sellerTerms': 'Условия за продавача',
  'footer.privacy': 'Поверителност',
  'footer.terms': 'Условия',
  'footer.euMarketplace': "ЕС · Великобритания · Норвегия",
};

const hr = {
  'nav.home': 'Početna',
  'nav.allParts': 'Svi dijelovi',
  'nav.cart': 'Košarica',
  'nav.myAccount': 'Moj račun',
  'nav.myOrders': 'Moje narudžbe',
  'nav.sellerPortal': 'Portal prodavatelja',
  'nav.adminPanel': 'Admin panel',
  'nav.login': 'Prijava',
  'nav.register': 'Registracija',
  'nav.logout': 'Odjava',
  'nav.makes': 'Marke vozila',
  'header.freeShipping': "Brza dostava u EU, Ujedinjeno Kraljevstvo i Norvešku",
  'header.returns': '14-dnevni povrat',
  'header.light': 'Svjetlo',
  'header.dark': 'Tamno',
  'header.searchPlaceholder': 'Pretraži po broju dijela, OEM kodu ili ključnoj riječi...',
  'header.searchMobile': 'Pretraži dijelove...',
  'search.partsFound': '{count} dijelova pronađeno',
  'search.sortBy': 'Sortiraj po',
  'search.relevance': 'Relevantnost',
  'search.priceLowHigh': 'Cijena: Od najniže',
  'search.priceHighLow': 'Cijena: Od najviše',
  'search.newest': 'Najnovije',
  'search.priceRange': 'Raspon cijena',
  'search.make': 'Marka',
  'search.model': 'Model',
  'search.year': 'Godina',
  'search.category': 'Kategorija',
  'search.subcategory': 'Potkategorija',
  'search.condition': 'Stanje',
  'search.allMakes': 'Sve marke',
  'search.allModels': 'Svi modeli',
  'search.allYears': 'Sve godine',
  'search.allCategories': 'Sve kategorije',
  'search.allSubcategories': 'Sve potkategorije',
  'search.allConditions': 'Sva stanja',
  'search.clearFilters': 'Obriši sve filtre',
  'search.noResults': 'Nisu pronađeni dijelovi koji odgovaraju vašim kriterijima',
  'search.noResultsHint': 'Pokušajte proširiti pretragu ili prilagoditi filtre',
  'search.addToCart': 'Dodaj u košaricu',
  'product.addToCart': 'Dodaj u košaricu',
  'product.freeShipping': "Dostava u EU, Ujedinjeno Kraljevstvo i Norvešku",
  'product.reviews': 'Recenzije',
  'product.writeReview': 'Napiši recenziju',
  'product.signInReview': 'Prijavite se za pisanje recenzije',
  'product.noReviews': 'Još nema recenzija. Budite prvi!',
  'product.seller': 'Prodavatelj',
  'product.condition': 'Stanje',
  'product.oemCodes': 'OEM kodovi',
  'product.inStock': 'Na zalihi ({qty} dostupno)',
  'product.outOfStock': 'Nema na zalihi',
  'product.reviewTitle': 'Naslov',
  'product.reviewContent': 'Recenzija',
  'product.submitReview': 'Pošalji recenziju',
  'product.avgRating': 'Prosječna ocjena',
  'product.ratingDist': 'Raspodjela ocjena',
  'cart.title': 'Košarica',
  'cart.empty': 'Vaša košarica je prazna',
  'cart.emptyHint': 'Pregledajte naš izbor automobilskih dijelova',
  'cart.subtotal': 'Međuzbir',
  'cart.shipping': 'Dostava',
  'cart.total': 'Ukupno',
  'cart.checkout': 'Na blagajnu',
  'cart.each': 'kom',
  'cart.continueShopping': 'Nastavi kupovinu',
  'cart.freeShipping': 'Dostava se izračunava pri plaćanju',
  'checkout.orderSummary': 'Sažetak narudžbe',
  'checkout.subtotal': 'Međuzbir',
  'checkout.shipping': 'Dostava',
  'checkout.total': 'Ukupno',
  'checkout.placeOrder': 'Naruči',
  'checkout.processing': 'Obrađuje se...',
  'checkout.shippingInfo': 'Adresa dostave',
  'checkout.billingInfo': 'Adresa naplate',
  'checkout.paymentInfo': 'Podaci o plaćanju',
  'checkout.firstName': 'Ime',
  'checkout.lastName': 'Prezime',
  'checkout.email': 'E-pošta',
  'checkout.address': 'Adresa',
  'checkout.city': 'Grad',
  'checkout.country': 'Zemlja',
  'checkout.postalCode': 'Poštanski broj',
  'checkout.cardNumber': 'Broj kartice',
  'checkout.expiryDate': 'Datum isteka',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Isto kao adresa dostave',
  'customer.orders': 'Narudžbe',
  'customer.messages': 'Poruke',
  'customer.returns': 'Povrati',
  'customer.orderHistory': 'Povijest narudžbi',
  'customer.noOrders': 'Još nema narudžbi',
  'customer.orderNo': 'Narudžba #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Ukupno',
  'customer.viewDetails': 'Pogledaj detalje',
  'customer.backToOrders': 'Natrag na narudžbe',
  'customer.orderDetail': 'Detalji narudžbe',
  'customer.requestReturn': 'Zahtjev za povrat',
  'customer.returnReason': 'Razlog povrata',
  'customer.returnDescription': 'Dodatni detalji (neobavezno)',
  'customer.submitReturn': 'Pošalji zahtjev za povrat',
  'customer.returnSuccess': 'Vaš zahtjev za povrat je uspješno poslan.',
  'customer.returnPending': 'Predstavnik će ga uskoro pregledati.',
  'customer.conversations': 'Razgovori',
  'customer.noMessages': 'Još nema razgovora',
  'customer.send': 'Pošalji',
  'customer.returnStatus.pending': 'Na čekanju',
  'customer.returnStatus.approved': 'Odobreno',
  'customer.returnStatus.rejected': 'Odbijeno',
  'customer.returnStatus.processing': 'Obrađuje se',
  'customer.returnId': 'ID povrata',
  'customer.orderId': 'ID narudžbe',
  'customer.reason': 'Razlog',
  'customer.description': 'Opis',
  'customer.noReturns': 'Još nema povrata',
  'customer.noReturnsHint': 'Ako trebate vratiti artikl, idite na detalje narudžbe i kliknite "Zahtjev za povrat".',
  'vendor.dashboard': 'Nadzorna ploča',
  'vendor.myListings': 'Moji oglasi',
  'vendor.orders': 'Narudžbe',
  'vendor.addListing': 'Dodaj oglas',
  'vendor.bulkImport': 'Masovni uvoz',
  'vendor.revenue': 'Prihodi',
  'vendor.totalOrders': 'Narudžbe',
  'vendor.totalListings': 'Oglasi',
  'vendor.totalViews': 'Pregledi',
  'vendor.recentOrders': 'Nedavne narudžbe',
  'vendor.noOrders': 'Još nema narudžbi',
  'vendor.editListing': 'Uredi',
  'vendor.deleteListing': 'Obriši',
  'vendor.priceLabel': 'Cijena ({symbol}) *',
  'vendor.importCSV': 'Uvezi CSV oglase',
  'vendor.downloadTemplate': 'Preuzmi CSV predložak',
  'vendor.chooseFile': 'Odaberi CSV datoteku',
  'vendor.startImport': 'Pokreni uvoz',
  'vendor.instructions': 'Kako uvesti',
  'vendor.previewData': 'Pregled (prvih 5 redaka)',
  'vendor.importResults': 'Rezultati uvoza',
  'vendor.listingsCreated': 'oglasa stvoreno',
  'vendor.errors': 'Greške',
  'vendor.noFile': 'Nije odabrana datoteka',
  'vendor.requiredColumns': 'Učitajte CSV datoteku s ovim stupcima. Samo naslov i cijena su obvezni.',
  'admin.users': 'Korisnici',
  'admin.sellers': 'Prodavatelji',
  'admin.listings': 'Oglasi',
  'admin.orders': 'Narudžbe',
  'admin.approve': 'Odobri',
  'admin.suspend': 'Suspendiraj',
  'admin.delete': 'Obriši',
  'admin.totalUsers': 'Ukupno korisnika',
  'admin.totalSellers': 'Ukupno prodavatelja',
  'admin.totalListings': 'Ukupno oglasa',
  'admin.totalOrders': 'Ukupno narudžbi',
  'admin.pendingSellers': 'Prodavatelji na čekanju',
  'admin.email': 'E-pošta',
  'admin.name': 'Ime',
  'admin.role': 'Uloga',
  'admin.status': 'Status',
  'admin.actions': 'Radnje',
  'admin.company': 'Tvrtka',
  'admin.rating': 'Ocjena',
  'admin.sales': 'Prodaja',
  'admin.title': 'Naslov',
  'admin.price': 'Cijena',
  'admin.category': 'Kategorija',
  'admin.orderNo': 'Narudžba #',
  'admin.buyer': 'Kupac',
  'admin.date': 'Datum',
  'admin.total': 'Ukupno',
  'home.heroTitle': "Web trgovina rabljenih auto dijelova · 4,2 mil.+ dijelova",
  'home.heroSubtitle': "Pronađite originalne i zamjenske dijelove za sva europska vozila. Dostava u EU, Ujedinjeno Kraljevstvo i Norvešku.",
  'home.searchHero': 'Traži po broju dijela, marki ili ključnoj riječi',
  'home.featuredParts': 'Istaknuti dijelovi',
  'home.viewAll': 'Vidi sve dijelove',
  'home.freeShipping': "Dostava EU, Ujedinjeno Kraljevstvo i Norveška",
  'home.freeShippingDesc': "Dostava u EU, Ujedinjeno Kraljevstvo i Norvešku",
  'home.returns': '14-dnevni povrat',
  'home.returnsDesc': 'Bezbrižna politika povrata',
  'home.securePayment': 'Sigurno plaćanje',
  'home.securePaymentDesc': 'SSL kriptirane transakcije',
  'home.qualityParts': 'Kvalitetni dijelovi',
  'home.qualityPartsDesc': "Originalni dijelovi proizvođača",
  'home.whyChoose': 'Zašto odabrati zivu.eu?',
  'home.trustedSellers': "Provjerena kompatibilnost",
  'home.trustedSellersDesc': "Svaki dio fotografiran i provjerene kompatibilnosti prije objave",
  'makes.title': 'Marke vozila',
  'makes.subtitle': 'Pretraži dijelove po proizvođaču vozila',
  'makes.searchPlaceholder': 'Traži marke...',
  'makes.popular': 'Popularne marke',
  'makeDetail.subtitle': 'Pretraži modele i pronađi dijelove',
  'makeDetail.selectModel': 'Odaberi model',
  'makeDetail.selectYear': 'Odaberi godinu',
  'footer.tagline': "Web trgovina za rabljene i obnovljene automobilske dijelove. Dostava u EU, Ujedinjeno Kraljevstvo i Norvešku.",
  'footer.shop': 'Trgovina',
  'footer.allParts': 'Svi dijelovi',
  'footer.engineParts': 'Dijelovi motora',
  'footer.bodyParts': 'Dijelovi karoserije',
  'footer.electrical': 'Električni',
  'footer.refurbished': 'Obnovljeni',
  'footer.information': 'Informacije',
  'footer.aboutUs': 'O nama',
  'footer.deliveryInfo': 'Info o dostavi',
  'footer.returnsRefunds': 'Povrati i povrati novca',
  'footer.paymentMethods': 'Načini plaćanja',
  'footer.contactUs': 'Kontaktirajte nas',
  'footer.support': 'Podrška',
  'footer.helpCenter': 'Centar za pomoć',
  'footer.shippingInfo': 'Info o slanju',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Jamstvo',
  'footer.sellers': 'Prodavatelji',
  'footer.sellOnZivu': 'Prodajte na zivu.eu',
  'footer.sellerPortal': 'Portal prodavatelja',
  'footer.sellerTerms': 'Uvjeti prodavatelja',
  'footer.privacy': 'Privatnost',
  'footer.terms': 'Uvjeti',
  'footer.euMarketplace': "EU · UK · Norveška",
};

const sk = {
  'nav.home': 'Domov',
  'nav.allParts': 'Všetky diely',
  'nav.cart': 'Košík',
  'nav.myAccount': 'Môj účet',
  'nav.myOrders': 'Moje objednávky',
  'nav.sellerPortal': 'Portál predajcu',
  'nav.adminPanel': 'Administrácia',
  'nav.login': 'Prihlásiť sa',
  'nav.register': 'Registrovať',
  'nav.logout': 'Odhlásiť sa',
  'nav.makes': 'Značky vozidiel',
  'header.freeShipping': "Rýchle doručenie do EÚ, Veľkej Británie a Nórska",
  'header.returns': '14-dňové vrátenie',
  'header.light': 'Svetlý',
  'header.dark': 'Tmavý',
  'header.searchPlaceholder': 'Hľadať podľa čísla dielu, OEM kódu alebo kľúčového slova...',
  'header.searchMobile': 'Hľadať diely...',
  'search.partsFound': 'Nájdených {count} dielov',
  'search.sortBy': 'Zoradiť podľa',
  'search.relevance': 'Relevancia',
  'search.priceLowHigh': 'Cena: Od najnižšej',
  'search.priceHighLow': 'Cena: Od najvyššej',
  'search.newest': 'Najnovšie',
  'search.priceRange': 'Cenové rozpätie',
  'search.make': 'Značka',
  'search.model': 'Model',
  'search.year': 'Rok',
  'search.category': 'Kategória',
  'search.subcategory': 'Podkategória',
  'search.condition': 'Stav',
  'search.allMakes': 'Všetky značky',
  'search.allModels': 'Všetky modely',
  'search.allYears': 'Všetky roky',
  'search.allCategories': 'Všetky kategórie',
  'search.allSubcategories': 'Všetky podkategórie',
  'search.allConditions': 'Všetky stavy',
  'search.clearFilters': 'Vymazať všetky filtre',
  'search.noResults': 'Žiadne diely nezodpovedajú vašim kritériám',
  'search.noResultsHint': 'Skúste rozšíriť vyhľadávanie alebo upraviť filtre',
  'search.addToCart': 'Pridať do košíka',
  'product.addToCart': 'Pridať do košíka',
  'product.freeShipping': "Doručenie do EÚ, Veľkej Británie a Nórska",
  'product.reviews': 'Recenzie',
  'product.writeReview': 'Napísať recenziu',
  'product.signInReview': 'Prihláste sa pre napísanie recenzie',
  'product.noReviews': 'Zatiaľ žiadne recenzie. Buďte prvý!',
  'product.seller': 'Predajca',
  'product.condition': 'Stav',
  'product.oemCodes': 'OEM kódy',
  'product.inStock': 'Skladom ({qty} dostupných)',
  'product.outOfStock': 'Vypredané',
  'product.reviewTitle': 'Nadpis',
  'product.reviewContent': 'Recenzia',
  'product.submitReview': 'Odoslať recenziu',
  'product.avgRating': 'Priemerné hodnotenie',
  'product.ratingDist': 'Rozdelenie hodnotení',
  'cart.title': 'Nákupný košík',
  'cart.empty': 'Váš košík je prázdny',
  'cart.emptyHint': 'Prezrite si naše náhradné diely',
  'cart.subtotal': 'Medzisúčet',
  'cart.shipping': 'Doprava',
  'cart.total': 'Celkom',
  'cart.checkout': 'Prejsť k pokladni',
  'cart.each': 'ks',
  'cart.continueShopping': 'Pokračovať v nakupovaní',
  'cart.freeShipping': 'Doprava sa vypočíta pri platbe',
  'checkout.orderSummary': 'Zhrnutie objednávky',
  'checkout.subtotal': 'Medzisúčet',
  'checkout.shipping': 'Doprava',
  'checkout.total': 'Celkom',
  'checkout.placeOrder': 'Objednať',
  'checkout.processing': 'Spracováva sa...',
  'checkout.shippingInfo': 'Doručovacia adresa',
  'checkout.billingInfo': 'Fakturačná adresa',
  'checkout.paymentInfo': 'Platobné údaje',
  'checkout.firstName': 'Meno',
  'checkout.lastName': 'Priezvisko',
  'checkout.email': 'E-mail',
  'checkout.address': 'Adresa',
  'checkout.city': 'Mesto',
  'checkout.country': 'Krajina',
  'checkout.postalCode': 'PSČ',
  'checkout.cardNumber': 'Číslo karty',
  'checkout.expiryDate': 'Dátum expirácie',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Rovnaká ako doručovacia adresa',
  'customer.orders': 'Objednávky',
  'customer.messages': 'Správy',
  'customer.returns': 'Vrátenia',
  'customer.orderHistory': 'História objednávok',
  'customer.noOrders': 'Zatiaľ žiadne objednávky',
  'customer.orderNo': 'Objednávka #',
  'customer.orderDate': 'Dátum',
  'customer.orderStatus': 'Stav',
  'customer.orderTotal': 'Celkom',
  'customer.viewDetails': 'Zobraziť detaily',
  'customer.backToOrders': 'Späť na objednávky',
  'customer.orderDetail': 'Detaily objednávky',
  'customer.requestReturn': 'Požiadať o vrátenie',
  'customer.returnReason': 'Dôvod vrátenia',
  'customer.returnDescription': 'Ďalšie podrobnosti (nepovinné)',
  'customer.submitReturn': 'Odoslať žiadosť o vrátenie',
  'customer.returnSuccess': 'Vaša žiadosť o vrátenie bola úspešne odoslaná.',
  'customer.returnPending': 'Zástupca ju čoskoro skontroluje.',
  'customer.conversations': 'Konverzácie',
  'customer.noMessages': 'Zatiaľ žiadne konverzácie',
  'customer.send': 'Odoslať',
  'customer.returnStatus.pending': 'Čaká',
  'customer.returnStatus.approved': 'Schválené',
  'customer.returnStatus.rejected': 'Zamietnuté',
  'customer.returnStatus.processing': 'Spracováva sa',
  'customer.returnId': 'ID vrátenia',
  'customer.orderId': 'ID objednávky',
  'customer.reason': 'Dôvod',
  'customer.description': 'Popis',
  'customer.noReturns': 'Zatiaľ žiadne vrátenia',
  'customer.noReturnsHint': 'Ak chcete vrátiť tovar, prejdite na detaily objednávky a kliknite na "Požiadať o vrátenie".',
  'vendor.dashboard': 'Prehľad',
  'vendor.myListings': 'Moje inzeráty',
  'vendor.orders': 'Objednávky',
  'vendor.addListing': 'Pridať inzerát',
  'vendor.bulkImport': 'Hromadný import',
  'vendor.revenue': 'Tržby',
  'vendor.totalOrders': 'Objednávky',
  'vendor.totalListings': 'Inzeráty',
  'vendor.totalViews': 'Zobrazenia',
  'vendor.recentOrders': 'Posledné objednávky',
  'vendor.noOrders': 'Zatiaľ žiadne objednávky',
  'vendor.editListing': 'Upraviť',
  'vendor.deleteListing': 'Zmazať',
  'vendor.priceLabel': 'Cena ({symbol}) *',
  'vendor.importCSV': 'Importovať CSV inzeráty',
  'vendor.downloadTemplate': 'Stiahnuť CSV šablónu',
  'vendor.chooseFile': 'Vybrať CSV súbor',
  'vendor.startImport': 'Spustiť import',
  'vendor.instructions': 'Ako importovať',
  'vendor.previewData': 'Náhľad (prvých 5 riadkov)',
  'vendor.importResults': 'Výsledky importu',
  'vendor.listingsCreated': 'inzerátov vytvorených',
  'vendor.errors': 'Chyby',
  'vendor.noFile': 'Žiadny súbor nevybraný',
  'vendor.requiredColumns': 'Nahrajte CSV súbor s týmito stĺpcami. Iba názov a cena sú povinné.',
  'admin.users': 'Používatelia',
  'admin.sellers': 'Predajcovia',
  'admin.listings': 'Inzeráty',
  'admin.orders': 'Objednávky',
  'admin.approve': 'Schváliť',
  'admin.suspend': 'Pozastaviť',
  'admin.delete': 'Zmazať',
  'admin.totalUsers': 'Celkom používateľov',
  'admin.totalSellers': 'Celkom predajcov',
  'admin.totalListings': 'Celkom inzerátov',
  'admin.totalOrders': 'Celkom objednávok',
  'admin.pendingSellers': 'Čakajúci predajcovia',
  'admin.email': 'E-mail',
  'admin.name': 'Meno',
  'admin.role': 'Rola',
  'admin.status': 'Stav',
  'admin.actions': 'Akcie',
  'admin.company': 'Spoločnosť',
  'admin.rating': 'Hodnotenie',
  'admin.sales': 'Predaje',
  'admin.title': 'Názov',
  'admin.price': 'Cena',
  'admin.category': 'Kategória',
  'admin.orderNo': 'Objednávka #',
  'admin.buyer': 'Kupujúci',
  'admin.date': 'Dátum',
  'admin.total': 'Celkom',
  'home.heroTitle': "E-shop s použitými autodielmi · 4,2 mil.+ dielov",
  'home.heroSubtitle': "Nájdite originálne a náhradné diely pre akékoľvek európske vozidlo. Doručenie do EÚ, Veľkej Británie a Nórska.",
  'home.searchHero': 'Hľadať číslo dielu, značku alebo kľúčové slovo',
  'home.featuredParts': 'Odporúčané diely',
  'home.viewAll': 'Zobraziť všetky diely',
  'home.freeShipping': "Doručenie EÚ, Veľká Británia a Nórsko",
  'home.freeShippingDesc': "Doručenie do EÚ, Veľkej Británie a Nórska",
  'home.returns': 'Vrátenie do 14 dní',
  'home.returnsDesc': 'Jednoduché vrátenie bez problémov',
  'home.securePayment': 'Bezpečná platba',
  'home.securePaymentDesc': 'SSL šifrované transakcie',
  'home.qualityParts': 'Kvalitné diely',
  'home.qualityPartsDesc': "Originálne diely výrobcu",
  'home.whyChoose': 'Prečo vybrať zivu.eu?',
  'home.trustedSellers': "Overená kompatibilita",
  'home.trustedSellersDesc': "Každý diel je pred zverejnením odfotený a overená jeho kompatibilita",
  'makes.title': 'Značky vozidiel',
  'makes.subtitle': 'Prechádzať diely podľa výrobcu vozidla',
  'makes.searchPlaceholder': 'Hľadať značky...',
  'makes.popular': 'Populárne značky',
  'makeDetail.subtitle': 'Prechádzať modely a nájsť diely',
  'makeDetail.selectModel': 'Vybrať model',
  'makeDetail.selectYear': 'Vybrať rok',
  'footer.tagline': "E-shop s použitými a repasovanými autodielmi. Doručenie do EÚ, Veľkej Británie a Nórska.",
  'footer.shop': 'Obchod',
  'footer.allParts': 'Všetky diely',
  'footer.engineParts': 'Diely motora',
  'footer.bodyParts': 'Diely karosérie',
  'footer.electrical': 'Elektro',
  'footer.refurbished': 'Repasované',
  'footer.information': 'Informácie',
  'footer.aboutUs': 'O nás',
  'footer.deliveryInfo': 'Info o doručení',
  'footer.returnsRefunds': 'Vrátenia a refundácie',
  'footer.paymentMethods': 'Spôsoby platby',
  'footer.contactUs': 'Kontaktujte nás',
  'footer.support': 'Podpora',
  'footer.helpCenter': 'Centrum nápovedy',
  'footer.shippingInfo': 'Info o doprave',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Záruka',
  'footer.sellers': 'Predajcovia',
  'footer.sellOnZivu': 'Predávať na zivu.eu',
  'footer.sellerPortal': 'Portál predajcu',
  'footer.sellerTerms': 'Podmienky predajcu',
  'footer.privacy': 'Súkromie',
  'footer.terms': 'Podmienky',
  'footer.euMarketplace': "EÚ · UK · Nórsko",
};

const sl = {
  'nav.home': 'Domov',
  'nav.allParts': 'Vsi deli',
  'nav.cart': 'Košarica',
  'nav.myAccount': 'Moj račun',
  'nav.myOrders': 'Moja naročila',
  'nav.sellerPortal': 'Portal prodajalca',
  'nav.adminPanel': 'Admin panel',
  'nav.login': 'Prijava',
  'nav.register': 'Registracija',
  'nav.logout': 'Odjava',
  'nav.makes': 'Znamke vozil',
  'header.freeShipping': "Hitra dostava v EU, Združeno kraljestvo in Norveško",
  'header.returns': '14-dnevna vrnitev',
  'header.light': 'Svetlo',
  'header.dark': 'Temno',
  'header.searchPlaceholder': 'Iskanje po številki dela, OEM kodi ali ključni besedi...',
  'header.searchMobile': 'Iskanje delov...',
  'search.partsFound': '{count} delov najdenih',
  'search.sortBy': 'Razvrsti po',
  'search.relevance': 'Ustreznost',
  'search.priceLowHigh': 'Cena: Od najnižje',
  'search.priceHighLow': 'Cena: Od najvišje',
  'search.newest': 'Najnovejše',
  'search.priceRange': 'Cenovni razpon',
  'search.make': 'Znamka',
  'search.model': 'Model',
  'search.year': 'Leto',
  'search.category': 'Kategorija',
  'search.subcategory': 'Podkategorija',
  'search.condition': 'Stanje',
  'search.allMakes': 'Vse znamke',
  'search.allModels': 'Vsi modeli',
  'search.allYears': 'Vsa leta',
  'search.allCategories': 'Vse kategorije',
  'search.allSubcategories': 'Vse podkategorije',
  'search.allConditions': 'Vsa stanja',
  'search.clearFilters': 'Počisti vse filtre',
  'search.noResults': 'Ni bilo najdenih delov, ki ustrezajo vašim merilom',
  'search.noResultsHint': 'Poskusite razširiti iskanje ali prilagoditi filtre',
  'search.addToCart': 'Dodaj v košarico',
  'product.addToCart': 'Dodaj v košarico',
  'product.freeShipping': "Dostava v EU, Združeno kraljestvo in Norveško",
  'product.reviews': 'Ocene',
  'product.writeReview': 'Napišite oceno',
  'product.signInReview': 'Prijavite se za pisanje ocene',
  'product.noReviews': 'Še ni ocen. Bodite prvi!',
  'product.seller': 'Prodajalec',
  'product.condition': 'Stanje',
  'product.oemCodes': 'OEM kode',
  'product.inStock': 'Na zalogi ({qty} na voljo)',
  'product.outOfStock': 'Ni na zalogi',
  'product.reviewTitle': 'Naslov',
  'product.reviewContent': 'Ocena',
  'product.submitReview': 'Pošlji oceno',
  'product.avgRating': 'Povprečna ocena',
  'product.ratingDist': 'Porazdelitev ocen',
  'cart.title': 'Košarica',
  'cart.empty': 'Vaša košarica je prazna',
  'cart.emptyHint': 'Preglejte našo ponudbo avtomobilskih delov',
  'cart.subtotal': 'Vmesna vsota',
  'cart.shipping': 'Dostava',
  'cart.total': 'Skupaj',
  'cart.checkout': 'Na blagajno',
  'cart.each': 'kos',
  'cart.continueShopping': 'Nadaljuj nakupovanje',
  'cart.freeShipping': 'Dostava se izračuna pri plačilu',
  'checkout.orderSummary': 'Povzetek naročila',
  'checkout.subtotal': 'Vmesna vsota',
  'checkout.shipping': 'Dostava',
  'checkout.total': 'Skupaj',
  'checkout.placeOrder': 'Naroči',
  'checkout.processing': 'Obdelava...',
  'checkout.shippingInfo': 'Naslov dostave',
  'checkout.billingInfo': 'Naslov za račun',
  'checkout.paymentInfo': 'Podatki o plačilu',
  'checkout.firstName': 'Ime',
  'checkout.lastName': 'Priimek',
  'checkout.email': 'E-pošta',
  'checkout.address': 'Naslov',
  'checkout.city': 'Mesto',
  'checkout.country': 'Država',
  'checkout.postalCode': 'Poštna številka',
  'checkout.cardNumber': 'Številka kartice',
  'checkout.expiryDate': 'Datum poteka',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Enako kot naslov dostave',
  'customer.orders': 'Naročila',
  'customer.messages': 'Sporočila',
  'customer.returns': 'Vračila',
  'customer.orderHistory': 'Zgodovina naročil',
  'customer.noOrders': 'Še ni naročil',
  'customer.orderNo': 'Naročilo #',
  'customer.orderDate': 'Datum',
  'customer.orderStatus': 'Status',
  'customer.orderTotal': 'Skupaj',
  'customer.viewDetails': 'Poglej podrobnosti',
  'customer.backToOrders': 'Nazaj na naročila',
  'customer.orderDetail': 'Podrobnosti naročila',
  'customer.requestReturn': 'Zahteva za vračilo',
  'customer.returnReason': 'Razlog za vračilo',
  'customer.returnDescription': 'Dodatne podrobnosti (neobvezno)',
  'customer.submitReturn': 'Pošlji zahtevo za vračilo',
  'customer.returnSuccess': 'Vaša zahteva za vračilo je bila uspešno poslana.',
  'customer.returnPending': 'Predstavnik jo bo kmalu pregledal.',
  'customer.conversations': 'Pogovori',
  'customer.noMessages': 'Še ni pogovorov',
  'customer.send': 'Pošlji',
  'customer.returnStatus.pending': 'V čakanju',
  'customer.returnStatus.approved': 'Odobreno',
  'customer.returnStatus.rejected': 'Zavrnjeno',
  'customer.returnStatus.processing': 'Obdelava',
  'customer.returnId': 'ID vračila',
  'customer.orderId': 'ID naročila',
  'customer.reason': 'Razlog',
  'customer.description': 'Opis',
  'customer.noReturns': 'Še ni vračil',
  'customer.noReturnsHint': 'Če želite vrniti artikel, pojdite na podrobnosti naročila in kliknite "Zahteva za vračilo".',
  'vendor.dashboard': 'Nadzorna plošča',
  'vendor.myListings': 'Moji oglasi',
  'vendor.orders': 'Naročila',
  'vendor.addListing': 'Dodaj oglas',
  'vendor.bulkImport': 'Množičen uvoz',
  'vendor.revenue': 'Prihodki',
  'vendor.totalOrders': 'Naročila',
  'vendor.totalListings': 'Oglasi',
  'vendor.totalViews': 'Ogledi',
  'vendor.recentOrders': 'Nedavna naročila',
  'vendor.noOrders': 'Še ni naročil',
  'vendor.editListing': 'Uredi',
  'vendor.deleteListing': 'Izbriši',
  'vendor.priceLabel': 'Cena ({symbol}) *',
  'vendor.importCSV': 'Uvozi CSV oglase',
  'vendor.downloadTemplate': 'Prenesi CSV predlogo',
  'vendor.chooseFile': 'Izberi CSV datoteko',
  'vendor.startImport': 'Začni uvoz',
  'vendor.instructions': 'Kako uvoziti',
  'vendor.previewData': 'Predogled (prvih 5 vrstic)',
  'vendor.importResults': 'Rezultati uvoza',
  'vendor.listingsCreated': 'oglasov ustvarjenih',
  'vendor.errors': 'Napake',
  'vendor.noFile': 'Ni izbrane datoteke',
  'vendor.requiredColumns': 'Naložite CSV datoteko s temi stolpci. Obvezna sta le naziv in cena.',
  'admin.users': 'Uporabniki',
  'admin.sellers': 'Prodajalci',
  'admin.listings': 'Oglasi',
  'admin.orders': 'Naročila',
  'admin.approve': 'Odobri',
  'admin.suspend': 'Suspendiraj',
  'admin.delete': 'Izbriši',
  'admin.totalUsers': 'Skupaj uporabnikov',
  'admin.totalSellers': 'Skupaj prodajalcev',
  'admin.totalListings': 'Skupaj oglasov',
  'admin.totalOrders': 'Skupaj naročil',
  'admin.pendingSellers': 'Prodajalci v čakanju',
  'admin.email': 'E-pošta',
  'admin.name': 'Ime',
  'admin.role': 'Vloga',
  'admin.status': 'Status',
  'admin.actions': 'Dejanja',
  'admin.company': 'Podjetje',
  'admin.rating': 'Ocena',
  'admin.sales': 'Prodaja',
  'admin.title': 'Naslov',
  'admin.price': 'Cena',
  'admin.category': 'Kategorija',
  'admin.orderNo': 'Naročilo #',
  'admin.buyer': 'Kupec',
  'admin.date': 'Datum',
  'admin.total': 'Skupaj',
  'home.heroTitle': "Spletna trgovina z rabljenimi avtodeli · 4,2 mio.+ delov",
  'home.heroSubtitle': "Poiščite originalne in nadomestne dele za vsa evropska vozila. Dostava v EU, Združeno kraljestvo in Norveško.",
  'home.searchHero': 'Iskanje po številki dela, znamki ali ključni besedi',
  'home.featuredParts': 'Izpostavljeni deli',
  'home.viewAll': 'Oglej vse dele',
  'home.freeShipping': "Dostava EU, Združeno kraljestvo in Norveška",
  'home.freeShippingDesc': "Dostava v EU, Združeno kraljestvo in Norveško",
  'home.returns': '14-dnevna vrnitev',
  'home.returnsDesc': 'Enostavna politika vračil',
  'home.securePayment': 'Varno plačilo',
  'home.securePaymentDesc': 'SSL šifrirane transakcije',
  'home.qualityParts': 'Kakovostni deli',
  'home.qualityPartsDesc': "Originalni deli proizvajalca",
  'home.whyChoose': 'Zakaj izbrati zivu.eu?',
  'home.trustedSellers': "Preverjena združljivost",
  'home.trustedSellersDesc': "Vsak del je pred objavo fotografiran in preverjena združljivost",
  'makes.title': 'Znamke vozil',
  'makes.subtitle': 'Pregleduj dele po proizvajalcu vozila',
  'makes.searchPlaceholder': 'Išči znamke...',
  'makes.popular': 'Priljubljene znamke',
  'makeDetail.subtitle': 'Pregleduj modele in najdi dele',
  'makeDetail.selectModel': 'Izberi model',
  'makeDetail.selectYear': 'Izberi leto',
  'footer.tagline': "Spletna trgovina za rabljene in obnovljene avtomobilske dele. Dostava v EU, Združeno kraljestvo in Norveško.",
  'footer.shop': 'Trgovina',
  'footer.allParts': 'Vsi deli',
  'footer.engineParts': 'Deli motorja',
  'footer.bodyParts': 'Karoserijski deli',
  'footer.electrical': 'Električni',
  'footer.refurbished': 'Obnovljeni',
  'footer.information': 'Informacije',
  'footer.aboutUs': 'O nas',
  'footer.deliveryInfo': 'Info o dostavi',
  'footer.returnsRefunds': 'Vračila in povračila',
  'footer.paymentMethods': 'Načini plačila',
  'footer.contactUs': 'Kontaktirajte nas',
  'footer.support': 'Podpora',
  'footer.helpCenter': 'Center za pomoč',
  'footer.shippingInfo': 'Info o pošiljanju',
  'footer.faq': 'FAQ',
  'footer.warranty': 'Garancija',
  'footer.sellers': 'Prodajalci',
  'footer.sellOnZivu': 'Prodajajte na zivu.eu',
  'footer.sellerPortal': 'Portal prodajalca',
  'footer.sellerTerms': 'Pogoji prodajalca',
  'footer.privacy': 'Zasebnost',
  'footer.terms': 'Pogoji',
  'footer.euMarketplace': "EU · UK · Norveška",
};

const el = {
  'nav.home': 'Αρχική',
  'nav.allParts': 'Όλα τα ανταλλακτικά',
  'nav.cart': 'Καλάθι',
  'nav.myAccount': 'Ο λογαριασμός μου',
  'nav.myOrders': 'Οι παραγγελίες μου',
  'nav.sellerPortal': 'Πύλη πωλητή',
  'nav.adminPanel': 'Πίνακας διαχείρισης',
  'nav.login': 'Σύνδεση',
  'nav.register': 'Εγγραφή',
  'nav.logout': 'Αποσύνδεση',
  'nav.makes': 'Μάρκες οχημάτων',
  'header.freeShipping': "Γρήγορη παράδοση σε ΕΕ, Ηνωμένο Βασίλειο & Νορβηγία",
  'header.returns': 'Επιστροφές 14 ημερών',
  'header.light': 'Ανοιχτό',
  'header.dark': 'Σκοτεινό',
  'header.searchPlaceholder': 'Αναζήτηση κατά αριθμό εξαρτήματος, κωδικό OEM ή λέξη-κλειδί...',
  'header.searchMobile': 'Αναζήτηση ανταλλακτικών...',
  'search.partsFound': '{count} ανταλλακτικά βρέθηκαν',
  'search.sortBy': 'Ταξινόμηση κατά',
  'search.relevance': 'Συνάφεια',
  'search.priceLowHigh': 'Τιμή: Από χαμηλή σε υψηλή',
  'search.priceHighLow': 'Τιμή: Από υψηλή σε χαμηλή',
  'search.newest': 'Νεότερα',
  'search.priceRange': 'Εύρος τιμών',
  'search.make': 'Μάρκα',
  'search.model': 'Μοντέλο',
  'search.year': 'Έτος',
  'search.category': 'Κατηγορία',
  'search.subcategory': 'Υποκατηγορία',
  'search.condition': 'Κατάσταση',
  'search.allMakes': 'Όλες οι μάρκες',
  'search.allModels': 'Όλα τα μοντέλα',
  'search.allYears': 'Όλα τα έτη',
  'search.allCategories': 'Όλες οι κατηγορίες',
  'search.allSubcategories': 'Όλες οι υποκατηγορίες',
  'search.allConditions': 'Όλες οι καταστάσεις',
  'search.clearFilters': 'Εκκαθάριση όλων των φίλτρων',
  'search.noResults': 'Δεν βρέθηκαν ανταλλακτικά που να ταιριάζουν με τα κριτήριά σας',
  'search.noResultsHint': 'Δοκιμάστε να διευρύνετε την αναζήτηση ή να προσαρμόσετε τα φίλτρα',
  'search.addToCart': 'Προσθήκη στο καλάθι',
  'product.addToCart': 'Προσθήκη στο καλάθι',
  'product.freeShipping': "Αποστολή σε ΕΕ, Ηνωμένο Βασίλειο & Νορβηγία",
  'product.reviews': 'Κριτικές',
  'product.writeReview': 'Γράψτε κριτική',
  'product.signInReview': 'Συνδεθείτε για να γράψετε κριτική',
  'product.noReviews': 'Δεν υπάρχουν ακόμη κριτικές. Γίνετε ο πρώτος!',
  'product.seller': 'Πωλητής',
  'product.condition': 'Κατάσταση',
  'product.oemCodes': 'Κωδικοί OEM',
  'product.inStock': 'Σε απόθεμα ({qty} διαθέσιμα)',
  'product.outOfStock': 'Εξαντλημένο',
  'product.reviewTitle': 'Τίτλος',
  'product.reviewContent': 'Κριτική',
  'product.submitReview': 'Υποβολή κριτικής',
  'product.avgRating': 'Μέση βαθμολογία',
  'product.ratingDist': 'Κατανομή βαθμολογιών',
  'cart.title': 'Καλάθι αγορών',
  'cart.empty': 'Το καλάθι σας είναι άδειο',
  'cart.emptyHint': 'Περιηγηθείτε στη συλλογή ανταλλακτικών αυτοκινήτων',
  'cart.subtotal': 'Μερικό σύνολο',
  'cart.shipping': 'Αποστολή',
  'cart.total': 'Σύνολο',
  'cart.checkout': 'Ολοκλήρωση αγοράς',
  'cart.each': 'τεμάχιο',
  'cart.continueShopping': 'Συνέχεια αγορών',
  'cart.freeShipping': 'Η αποστολή υπολογίζεται στο ταμείο',
  'checkout.orderSummary': 'Σύνοψη παραγγελίας',
  'checkout.subtotal': 'Μερικό σύνολο',
  'checkout.shipping': 'Αποστολή',
  'checkout.total': 'Σύνολο',
  'checkout.placeOrder': 'Υποβολή παραγγελίας',
  'checkout.processing': 'Επεξεργασία...',
  'checkout.shippingInfo': 'Στοιχεία αποστολής',
  'checkout.billingInfo': 'Στοιχεία χρέωσης',
  'checkout.paymentInfo': 'Στοιχεία πληρωμής',
  'checkout.firstName': 'Όνομα',
  'checkout.lastName': 'Επώνυμο',
  'checkout.email': 'Email',
  'checkout.address': 'Διεύθυνση',
  'checkout.city': 'Πόλη',
  'checkout.country': 'Χώρα',
  'checkout.postalCode': 'Ταχυδρομικός κώδικας',
  'checkout.cardNumber': 'Αριθμός κάρτας',
  'checkout.expiryDate': 'Ημερομηνία λήξης',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Ίδιο με τη διεύθυνση αποστολής',
  'customer.orders': 'Παραγγελίες',
  'customer.messages': 'Μηνύματα',
  'customer.returns': 'Επιστροφές',
  'customer.orderHistory': 'Ιστορικό παραγγελιών',
  'customer.noOrders': 'Δεν υπάρχουν παραγγελίες ακόμη',
  'customer.orderNo': 'Παραγγελία #',
  'customer.orderDate': 'Ημερομηνία',
  'customer.orderStatus': 'Κατάσταση',
  'customer.orderTotal': 'Σύνολο',
  'customer.viewDetails': 'Προβολή λεπτομερειών',
  'customer.backToOrders': 'Επιστροφή στις παραγγελίες',
  'customer.orderDetail': 'Λεπτομέρειες παραγγελίας',
  'customer.requestReturn': 'Αίτηση επιστροφής',
  'customer.returnReason': 'Λόγος επιστροφής',
  'customer.returnDescription': 'Πρόσθετες λεπτομέρειες (προαιρετικό)',
  'customer.submitReturn': 'Υποβολή αίτησης επιστροφής',
  'customer.returnSuccess': 'Η αίτηση επιστροφής σας υποβλήθηκε επιτυχώς.',
  'customer.returnPending': 'Εκπρόσωπος θα την εξετάσει σύντομα.',
  'customer.conversations': 'Συνομιλίες',
  'customer.noMessages': 'Δεν υπάρχουν συνομιλίες ακόμη',
  'customer.send': 'Αποστολή',
  'customer.returnStatus.pending': 'Σε εκκρεμότητα',
  'customer.returnStatus.approved': 'Εγκρίθηκε',
  'customer.returnStatus.rejected': 'Απορρίφθηκε',
  'customer.returnStatus.processing': 'Επεξεργασία',
  'customer.returnId': 'ID επιστροφής',
  'customer.orderId': 'ID παραγγελίας',
  'customer.reason': 'Λόγος',
  'customer.description': 'Περιγραφή',
  'customer.noReturns': 'Δεν υπάρχουν επιστροφές ακόμη',
  'customer.noReturnsHint': 'Αν θέλετε να επιστρέψετε ένα προϊόν, μεταβείτε στις λεπτομέρειες της παραγγελίας και κάντε κλικ στο "Αίτηση επιστροφής".',
  'vendor.dashboard': 'Πίνακας ελέγχου',
  'vendor.myListings': 'Οι αγγελίες μου',
  'vendor.orders': 'Παραγγελίες',
  'vendor.addListing': 'Προσθήκη αγγελίας',
  'vendor.bulkImport': 'Μαζική εισαγωγή',
  'vendor.revenue': 'Έσοδα',
  'vendor.totalOrders': 'Παραγγελίες',
  'vendor.totalListings': 'Αγγελίες',
  'vendor.totalViews': 'Προβολές',
  'vendor.recentOrders': 'Πρόσφατες παραγγελίες',
  'vendor.noOrders': 'Δεν υπάρχουν παραγγελίες ακόμη',
  'vendor.editListing': 'Επεξεργασία',
  'vendor.deleteListing': 'Διαγραφή',
  'vendor.priceLabel': 'Τιμή ({symbol}) *',
  'vendor.importCSV': 'Εισαγωγή αγγελιών CSV',
  'vendor.downloadTemplate': 'Λήψη προτύπου CSV',
  'vendor.chooseFile': 'Επιλογή αρχείου CSV',
  'vendor.startImport': 'Έναρξη εισαγωγής',
  'vendor.instructions': 'Οδηγίες εισαγωγής',
  'vendor.previewData': 'Προεπισκόπηση (πρώτες 5 γραμμές)',
  'vendor.importResults': 'Αποτελέσματα εισαγωγής',
  'vendor.listingsCreated': 'αγγελίες δημιουργήθηκαν',
  'vendor.errors': 'Σφάλματα',
  'vendor.noFile': 'Δεν έχει επιλεγεί αρχείο',
  'vendor.requiredColumns': 'Ανεβάστε ένα αρχείο CSV με τις παρακάτω στήλες. Μόνο ο τίτλος και η τιμή είναι υποχρεωτικά.',
  'admin.users': 'Χρήστες',
  'admin.sellers': 'Πωλητές',
  'admin.listings': 'Αγγελίες',
  'admin.orders': 'Παραγγελίες',
  'admin.approve': 'Έγκριση',
  'admin.suspend': 'Αναστολή',
  'admin.delete': 'Διαγραφή',
  'admin.totalUsers': 'Σύνολο χρηστών',
  'admin.totalSellers': 'Σύνολο πωλητών',
  'admin.totalListings': 'Σύνολο αγγελιών',
  'admin.totalOrders': 'Σύνολο παραγγελιών',
  'admin.pendingSellers': 'Εκκρεμείς πωλητές',
  'admin.email': 'Email',
  'admin.name': 'Όνομα',
  'admin.role': 'Ρόλος',
  'admin.status': 'Κατάσταση',
  'admin.actions': 'Ενέργειες',
  'admin.company': 'Εταιρεία',
  'admin.rating': 'Αξιολόγηση',
  'admin.sales': 'Πωλήσεις',
  'admin.title': 'Τίτλος',
  'admin.price': 'Τιμή',
  'admin.category': 'Κατηγορία',
  'admin.orderNo': 'Παραγγελία #',
  'admin.buyer': 'Αγοραστής',
  'admin.date': 'Ημερομηνία',
  'admin.total': 'Σύνολο',
  'home.heroTitle': "Ηλεκτρονικό κατάστημα μεταχειρισμένων ανταλλακτικών · 4,2 εκατ.+ ανταλλακτικά",
  'home.heroSubtitle': "Βρείτε γνήσια και aftermarket ανταλλακτικά για κάθε ευρωπαϊκό όχημα. Παράδοση σε ΕΕ, Ηνωμένο Βασίλειο και Νορβηγία.",
  'home.searchHero': 'Αναζήτηση κατά αριθμό εξαρτήματος, μάρκα ή λέξη-κλειδί',
  'home.featuredParts': 'Προτεινόμενα ανταλλακτικά',
  'home.viewAll': 'Προβολή όλων των ανταλλακτικών',
  'home.freeShipping': "Παράδοση ΕΕ, Ηνωμένο Βασίλειο & Νορβηγία",
  'home.freeShippingDesc': "Παράδοση σε ΕΕ, Ηνωμένο Βασίλειο και Νορβηγία",
  'home.returns': 'Επιστροφές 14 ημερών',
  'home.returnsDesc': 'Πολιτική επιστροφών χωρίς προβλήματα',
  'home.securePayment': 'Ασφαλής πληρωμή',
  'home.securePaymentDesc': 'Κρυπτογραφημένες συναλλαγές SSL',
  'home.qualityParts': 'Ανταλλακτικά ποιότητας',
  'home.qualityPartsDesc': "Γνήσια ανταλλακτικά κατασκευαστή",
  'home.whyChoose': 'Γιατί να επιλέξετε zivu.eu;',
  'home.trustedSellers': "Ελεγμένη συμβατότητα",
  'home.trustedSellersDesc': "Κάθε ανταλλακτικό φωτογραφίζεται και ελέγχεται η συμβατότητά του πριν την καταχώριση",
  'makes.title': 'Μάρκες οχημάτων',
  'makes.subtitle': 'Αναζήτηση ανταλλακτικών ανά κατασκευαστή οχήματος',
  'makes.searchPlaceholder': 'Αναζήτηση μαρκών...',
  'makes.popular': 'Δημοφιλείς μάρκες',
  'makeDetail.subtitle': 'Αναζήτηση μοντέλων και εύρεση ανταλλακτικών',
  'makeDetail.selectModel': 'Επιλογή μοντέλου',
  'makeDetail.selectYear': 'Επιλογή έτους',
  'footer.tagline': "Ηλεκτρονικό κατάστημα για μεταχειρισμένα και ανακατασκευασμένα ανταλλακτικά αυτοκινήτων. Αποστολή σε ΕΕ, Ηνωμένο Βασίλειο και Νορβηγία.",
  'footer.shop': 'Κατάστημα',
  'footer.allParts': 'Όλα τα ανταλλακτικά',
  'footer.engineParts': 'Ανταλλακτικά κινητήρα',
  'footer.bodyParts': 'Ανταλλακτικά αμαξώματος',
  'footer.electrical': 'Ηλεκτρικά',
  'footer.refurbished': 'Ανακατασκευασμένα',
  'footer.information': 'Πληροφορίες',
  'footer.aboutUs': 'Σχετικά με εμάς',
  'footer.deliveryInfo': 'Πληροφορίες παράδοσης',
  'footer.returnsRefunds': 'Επιστροφές και επιστροφές χρημάτων',
  'footer.paymentMethods': 'Μέθοδοι πληρωμής',
  'footer.contactUs': 'Επικοινωνία',
  'footer.support': 'Υποστήριξη',
  'footer.helpCenter': 'Κέντρο βοήθειας',
  'footer.shippingInfo': 'Πληροφορίες αποστολής',
  'footer.faq': 'Συχνές ερωτήσεις',
  'footer.warranty': 'Εγγύηση',
  'footer.sellers': 'Πωλητές',
  'footer.sellOnZivu': 'Πουλήστε στο zivu.eu',
  'footer.sellerPortal': 'Πύλη πωλητή',
  'footer.sellerTerms': 'Όροι πωλητή',
  'footer.privacy': 'Απόρρητο',
  'footer.terms': 'Όροι',
  'footer.euMarketplace': "ΕΕ · ΗΒ · Νορβηγία",
};

const lv = {
  'nav.home': 'Sākums',
  'nav.allParts': 'Visas detaļas',
  'nav.cart': 'Grozs',
  'nav.myAccount': 'Mans konts',
  'nav.myOrders': 'Mani pasūtījumi',
  'nav.sellerPortal': 'Pārdevēja portāls',
  'nav.adminPanel': 'Administrācijas panelis',
  'nav.login': 'Pieteikties',
  'nav.register': 'Reģistrēties',
  'nav.logout': 'Iziet',
  'nav.makes': 'Transportlīdzekļu markas',
  'header.freeShipping': "Ātra piegāde uz ES, Apvienoto Karalisti un Norvēģiju",
  'header.returns': '14 dienu atgriešana',
  'header.light': 'Gaišs',
  'header.dark': 'Tumšs',
  'header.searchPlaceholder': 'Meklēt pēc detaļas numura, OEM koda vai atslēgvārda...',
  'header.searchMobile': 'Meklēt detaļas...',
  'search.partsFound': 'Atrasto {count} detaļu',
  'search.sortBy': 'Kārtot pēc',
  'search.relevance': 'Atbilstība',
  'search.priceLowHigh': 'Cena: No zemākās',
  'search.priceHighLow': 'Cena: No augstākās',
  'search.newest': 'Jaunākie',
  'search.priceRange': 'Cenu diapazons',
  'search.make': 'Marka',
  'search.model': 'Modelis',
  'search.year': 'Gads',
  'search.category': 'Kategorija',
  'search.subcategory': 'Apakškategorija',
  'search.condition': 'Stāvoklis',
  'search.allMakes': 'Visas markas',
  'search.allModels': 'Visi modeļi',
  'search.allYears': 'Visi gadi',
  'search.allCategories': 'Visas kategorijas',
  'search.allSubcategories': 'Visas apakškategorijas',
  'search.allConditions': 'Visi stāvokļi',
  'search.clearFilters': 'Notīrīt visus filtrus',
  'search.noResults': 'Nav atrasta neviena detaļa, kas atbilstu jūsu kritērijiem',
  'search.noResultsHint': 'Mēģiniet paplašināt meklēšanu vai pielāgot filtrus',
  'search.addToCart': 'Pievienot grozam',
  'product.addToCart': 'Pievienot grozam',
  'product.freeShipping': "Piegāde uz ES, Apvienoto Karalisti un Norvēģiju",
  'product.reviews': 'Atsauksmes',
  'product.writeReview': 'Rakstīt atsauksmi',
  'product.signInReview': 'Piesakieties, lai rakstītu atsauksmi',
  'product.noReviews': 'Pagaidām nav atsauksmju. Esi pirmais!',
  'product.seller': 'Pārdevējs',
  'product.condition': 'Stāvoklis',
  'product.oemCodes': 'OEM kodi',
  'product.inStock': 'Noliktavā ({qty} pieejami)',
  'product.outOfStock': 'Nav noliktavā',
  'product.reviewTitle': 'Nosaukums',
  'product.reviewContent': 'Atsauksme',
  'product.submitReview': 'Iesniegt atsauksmi',
  'product.avgRating': 'Vidējais vērtējums',
  'product.ratingDist': 'Vērtējumu sadalījums',
  'cart.title': 'Iepirkumu grozs',
  'cart.empty': 'Jūsu grozs ir tukšs',
  'cart.emptyHint': 'Pārlūkojiet mūsu auto detaļu klāstu',
  'cart.subtotal': 'Starpsumma',
  'cart.shipping': 'Piegāde',
  'cart.total': 'Kopā',
  'cart.checkout': 'Uz kasi',
  'cart.each': 'gab.',
  'cart.continueShopping': 'Turpināt iepirkšanos',
  'cart.freeShipping': 'Piegāde tiek aprēķināta kasē',
  'checkout.orderSummary': 'Pasūtījuma kopsavilkums',
  'checkout.subtotal': 'Starpsumma',
  'checkout.shipping': 'Piegāde',
  'checkout.total': 'Kopā',
  'checkout.placeOrder': 'Veikt pasūtījumu',
  'checkout.processing': 'Apstrādā...',
  'checkout.shippingInfo': 'Piegādes adrese',
  'checkout.billingInfo': 'Norēķinu adrese',
  'checkout.paymentInfo': 'Maksājuma informācija',
  'checkout.firstName': 'Vārds',
  'checkout.lastName': 'Uzvārds',
  'checkout.email': 'E-pasts',
  'checkout.address': 'Adrese',
  'checkout.city': 'Pilsēta',
  'checkout.country': 'Valsts',
  'checkout.postalCode': 'Pasta indekss',
  'checkout.cardNumber': 'Kartes numurs',
  'checkout.expiryDate': 'Derīguma termiņš',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Tāda pati kā piegādes adrese',
  'customer.orders': 'Pasūtījumi',
  'customer.messages': 'Ziņojumi',
  'customer.returns': 'Atgriešana',
  'customer.orderHistory': 'Pasūtījumu vēsture',
  'customer.noOrders': 'Pagaidām nav pasūtījumu',
  'customer.orderNo': 'Pasūtījums #',
  'customer.orderDate': 'Datums',
  'customer.orderStatus': 'Statuss',
  'customer.orderTotal': 'Kopā',
  'customer.viewDetails': 'Skatīt detaļas',
  'customer.backToOrders': 'Atpakaļ uz pasūtījumiem',
  'customer.orderDetail': 'Pasūtījuma detaļas',
  'customer.requestReturn': 'Pieprasīt atgriešanu',
  'customer.returnReason': 'Atgriešanas iemesls',
  'customer.returnDescription': 'Papildu informācija (neobligāti)',
  'customer.submitReturn': 'Iesniegt atgriešanas pieprasījumu',
  'customer.returnSuccess': 'Jūsu atgriešanas pieprasījums ir veiksmīgi iesniegts.',
  'customer.returnPending': 'Pārstāvis to drīz pārskatīs.',
  'customer.conversations': 'Sarunas',
  'customer.noMessages': 'Pagaidām nav sarunu',
  'customer.send': 'Sūtīt',
  'customer.returnStatus.pending': 'Gaida',
  'customer.returnStatus.approved': 'Apstiprināts',
  'customer.returnStatus.rejected': 'Noraidīts',
  'customer.returnStatus.processing': 'Apstrādā',
  'customer.returnId': 'Atgriešanas ID',
  'customer.orderId': 'Pasūtījuma ID',
  'customer.reason': 'Iemesls',
  'customer.description': 'Apraksts',
  'customer.noReturns': 'Pagaidām nav iesniegtu atgriešanu',
  'customer.noReturnsHint': 'Ja vēlaties atgriezt preci, dodieties uz pasūtījuma detaļām un noklikšķiniet uz "Pieprasīt atgriešanu".',
  'vendor.dashboard': 'Vadības panelis',
  'vendor.myListings': 'Mani sludinājumi',
  'vendor.orders': 'Pasūtījumi',
  'vendor.addListing': 'Pievienot sludinājumu',
  'vendor.bulkImport': 'Lielapjoma imports',
  'vendor.revenue': 'Ieņēmumi',
  'vendor.totalOrders': 'Pasūtījumi',
  'vendor.totalListings': 'Sludinājumi',
  'vendor.totalViews': 'Skatījumi',
  'vendor.recentOrders': 'Nesenie pasūtījumi',
  'vendor.noOrders': 'Pagaidām nav pasūtījumu',
  'vendor.editListing': 'Rediģēt',
  'vendor.deleteListing': 'Dzēst',
  'vendor.priceLabel': 'Cena ({symbol}) *',
  'vendor.importCSV': 'Importēt CSV sludinājumus',
  'vendor.downloadTemplate': 'Lejupielādēt CSV veidni',
  'vendor.chooseFile': 'Izvēlēties CSV failu',
  'vendor.startImport': 'Sākt importu',
  'vendor.instructions': 'Kā importēt',
  'vendor.previewData': 'Priekšskatījums (pirmās 5 rindas)',
  'vendor.importResults': 'Importa rezultāti',
  'vendor.listingsCreated': 'sludinājumi izveidoti',
  'vendor.errors': 'Kļūdas',
  'vendor.noFile': 'Nav izvēlēta faila',
  'vendor.requiredColumns': 'Augšupielādējiet CSV failu ar šādām kolonnām. Obligāti ir tikai nosaukums un cena.',
  'admin.users': 'Lietotāji',
  'admin.sellers': 'Pārdevēji',
  'admin.listings': 'Sludinājumi',
  'admin.orders': 'Pasūtījumi',
  'admin.approve': 'Apstiprināt',
  'admin.suspend': 'Apturēt',
  'admin.delete': 'Dzēst',
  'admin.totalUsers': 'Kopā lietotāji',
  'admin.totalSellers': 'Kopā pārdevēji',
  'admin.totalListings': 'Kopā sludinājumi',
  'admin.totalOrders': 'Kopā pasūtījumi',
  'admin.pendingSellers': 'Gaidošie pārdevēji',
  'admin.email': 'E-pasts',
  'admin.name': 'Vārds',
  'admin.role': 'Loma',
  'admin.status': 'Statuss',
  'admin.actions': 'Darbības',
  'admin.company': 'Uzņēmums',
  'admin.rating': 'Vērtējums',
  'admin.sales': 'Pārdošana',
  'admin.title': 'Nosaukums',
  'admin.price': 'Cena',
  'admin.category': 'Kategorija',
  'admin.orderNo': 'Pasūtījums #',
  'admin.buyer': 'Pircējs',
  'admin.date': 'Datums',
  'admin.total': 'Kopā',
  'home.heroTitle': "Lietotu auto detaļu interneta veikals · 4,2 milj.+ detaļu",
  'home.heroSubtitle': "Atrodiet oriģinālās un pēctirgus detaļas jebkuram Eiropas transportlīdzeklim. Piegāde uz ES, Apvienoto Karalisti un Norvēģiju.",
  'home.searchHero': 'Meklēt pēc detaļas numura, markas vai atslēgvārda',
  'home.featuredParts': 'Ieteiktās detaļas',
  'home.viewAll': 'Skatīt visas detaļas',
  'home.freeShipping': "Piegāde ES, Apvienotā Karaliste un Norvēģija",
  'home.freeShippingDesc': "Piegāde uz ES, Apvienoto Karalisti un Norvēģiju",
  'home.returns': '14 dienu atgriešana',
  'home.returnsDesc': 'Vienkārša atgriešanas politika',
  'home.securePayment': 'Drošs maksājums',
  'home.securePaymentDesc': 'SSL šifrēti darījumi',
  'home.qualityParts': 'Kvalitatīvas detaļas',
  'home.qualityPartsDesc': "Oriģinālās ražotāja detaļas",
  'home.whyChoose': 'Kāpēc izvēlēties zivu.eu?',
  'home.trustedSellers': "Pārbaudīta saderība",
  'home.trustedSellersDesc': "Katra detaļa tiek nofotografēta un pārbaudīta tās saderība pirms publicēšanas",
  'makes.title': 'Transportlīdzekļu markas',
  'makes.subtitle': 'Pārlūkot detaļas pēc transportlīdzekļa ražotāja',
  'makes.searchPlaceholder': 'Meklēt markas...',
  'makes.popular': 'Populārās markas',
  'makeDetail.subtitle': 'Pārlūkot modeļus un atrast detaļas',
  'makeDetail.selectModel': 'Izvēlēties modeli',
  'makeDetail.selectYear': 'Izvēlēties gadu',
  'footer.tagline': "Interneta veikals lietotām un atjaunotām auto detaļām. Piegāde uz ES, Apvienoto Karalisti un Norvēģiju.",
  'footer.shop': 'Veikals',
  'footer.allParts': 'Visas detaļas',
  'footer.engineParts': 'Motora detaļas',
  'footer.bodyParts': 'Virsbūves detaļas',
  'footer.electrical': 'Elektriskie',
  'footer.refurbished': 'Atjaunotas',
  'footer.information': 'Informācija',
  'footer.aboutUs': 'Par mums',
  'footer.deliveryInfo': 'Piegādes informācija',
  'footer.returnsRefunds': 'Atgriešana un atmaksa',
  'footer.paymentMethods': 'Maksājumu metodes',
  'footer.contactUs': 'Sazinieties ar mums',
  'footer.support': 'Atbalsts',
  'footer.helpCenter': 'Palīdzības centrs',
  'footer.shippingInfo': 'Sūtīšanas informācija',
  'footer.faq': 'BUJ',
  'footer.warranty': 'Garantija',
  'footer.sellers': 'Pārdevēji',
  'footer.sellOnZivu': 'Pārdodiet zivu.eu',
  'footer.sellerPortal': 'Pārdevēja portāls',
  'footer.sellerTerms': 'Pārdevēja noteikumi',
  'footer.privacy': 'Privātums',
  'footer.terms': 'Noteikumi',
  'footer.euMarketplace': "ES · AK · Norvēģija",
  'login.welcomeBack': 'Sveiki, atkal!',
  'login.signInToContinue': 'Pierakstieties savā kontā, lai turpinātu',
  'login.emailLabel': 'E-pasts',
  'login.passwordLabel': 'Parole',
  'login.emailPh': 'tu@piemers.lv',
  'login.forgotPassword': 'Aizmirsi paroli?',
  'login.signingIn': 'Pierakstās…',
  'login.signInBtn': 'Pierakstīties',
  'login.orContinueWith': 'Vai turpiniet ar',
  'login.continueWithGoogle': 'Turpināt ar Google',
  'login.noAccount': 'Vēl nav konta?',
  'login.signUp': 'Reģistrēties',
  'register.title': 'Izveidot kontu',
  'register.subtitle': "Izveido kontu, lai iegādātos lietotas un atjaunotas auto detaļas",
  'register.firstName': 'Vārds',
  'register.lastName': 'Uzvārds',
  'register.emailLabel': 'E-pasts',
  'register.passwordLabel': 'Parole',
  'register.confirmPassword': 'Apstipriniet paroli',
  'register.creating': 'Konts tiek izveidots…',
  'register.createBtn': 'Izveidot kontu',
  'register.alreadyHave': 'Jau ir konts?',
  'register.signIn': 'Pierakstīties',
  'register.byCreating': 'Izveidojot kontu, jūs piekrītat mūsu',
  'customer.nav.overview': 'Pārskats',
  'customer.nav.myOrders': 'Mani pasūtījumi',
  'customer.nav.myGarage': 'Mans garāžas',
  'customer.nav.myReviews': 'Manas atsauksmes',
  'customer.nav.favorites': 'Favorīti',
  'customer.nav.messages': 'Ziņas',
  'customer.nav.returns': 'Atgriešanas',
  'customer.nav.addresses': 'Adreses',
  'customer.nav.settings': 'Iestatījumi',
  'customer.dashboardSubtitle': 'Pārvaldiet savus pasūtījumus un konta iestatījumus',
  'customer.recentOrders': 'Nesenie pasūtījumi',
  'customer.noOrdersYet': 'Vēl nav pasūtījumu',
  'customer.myOrdersTitle': 'Mani pasūtījumi',
  'customer.trackManage': 'Sekojiet un pārvaldiet savus pasūtījumus',
  'customer.browseParts': 'Pārlūkot detaļas',
  'customer.orderNotFound': 'Pasūtījums nav atrasts',
  'customer.cancelOrderTitle': 'Atcelt šo pasūtījumu?',
  'customer.cancelOrderDesc': 'Šo darbību nevar atsaukt. Maksājums tiks atmaksāts.',
  'customer.keepOrder': 'Saglabāt pasūtījumu',
  'customer.statusHistory': 'Statusa vēsture',
  'customer.orderItems': 'Pasūtījuma preces',
  'customer.discount': 'Atlaide',
  'customer.shippingAddressTitle': 'Piegādes adrese',
  'customer.billingAddressTitle': 'Rēķina adrese',
  'customer.needToReturn': 'Vajag atgriezt šo pasūtījumu?',
  'customer.returnRequestForm': 'Atgriešanas pieteikums',
  'customer.cancelBtn': 'Atcelt',
  'customer.returnSubmitted': 'Atgriešanas pieteikums iesniegts',
  'customer.returnReviewMsg': 'Mūsu komanda izskatīs jūsu pieteikumu un drīz sazināsies.',
  'customer.newMessageTitle': 'Jauna ziņa',
  'customer.sending': 'Sūta…',
  'customer.sendMessage': 'Sūtīt ziņu',
  'customer.messagesTitle': 'Ziņas',
  'customer.myFavoritesTitle': 'Mani favorīti',
  'customer.noFavoritesYet': 'Vēl nav favorītu',
  'customer.noTimelineData': 'Nav pieejamu hronoloģijas datu',
  'customer.returnsTitle': 'Atgriešanas',
  'customer.noReturnsYet': 'Vēl nav atgriešanu',
  'customer.myAddressesTitle': 'Manas adreses',
  'customer.noAddressesSaved': 'Nav saglabātu adrešu',
  'customer.defaultBadge': 'Noklusējums',
  'customer.businessAccount': 'Uzņēmuma konts',
  'customer.currentStatus': 'Pašreizējais statuss',
  'customer.companyAddress': 'Reģistrētā uzņēmuma adrese',
  'status.pending': 'Gaida',
  'status.confirmed': 'Apstiprināts',
  'status.paid': 'Apmaksāts',
  'status.processing': 'Apstrādes',
  'status.shipped': 'Nosūtīts',
  'status.delivered': 'Piegādāts',
  'status.completed': 'Pabeigts',
  'status.cancelled': 'Atcelts',
  'status.refunded': 'Atmaksāts',
  'status.returnRequested': 'Pieprasīta atgriešana',
  'status.returning': 'Atgriešanas procesā',
  'status.returned': 'Atgriezts',
  'status.returnRejected': 'Atgriešana noraidīta',
  'cart.itemsSubtotalLabel': 'Preču starpsumma',
  'cart.discountLabel': 'Atlaide',
  'cart.allPricesVat': 'Visas cenas ietver PVN',
  'cart.allPricesNet': 'Bez PVN — pircējs pats norēķinās par PVN (apgrieztā nodokļa procedūra)',
  'cart.secureCheckout': 'Drošs maksājums ar Stripe',
  'cart.orderSummary': 'Pasūtījuma kopsavilkums',
  'checkout.title': 'Norēķini',
  'checkout.buyerType': 'Pircēja tips',
  'checkout.private': 'Privātpersona',
  'checkout.privateSub': 'Personīgais pirkums',
  'checkout.company': 'Uzņēmums / Organizācija',
  'checkout.companySub': 'B2B ar PVN rēķinu',
  'checkout.companyDetails': 'Uzņēmuma informācija',
  'checkout.companyName': 'Uzņēmuma nosaukums',
  'checkout.companyNamePh': 'SIA Acme',
  'checkout.vatNumberLabel': 'PVN numurs (ieteicams)',
  'checkout.vatValidating': 'Pārbauda PVN numuru…',
  'checkout.streetPh': 'Iela un numurs',
  'checkout.shippingTitle': 'Piegāde',
  'checkout.standardDelivery': 'Standarta piegāde',
  'checkout.billingTitle': 'Rēķina adrese',
  'checkout.sameAsShipping': 'Tāda pati kā piegādes adrese',
  'checkout.secureCheckout': 'Drošs maksājums ar Stripe',
  'checkout.buyerProtection': "14 dienu atteikuma tiesības",
  'checkout.firstNamePh': 'Anna',
  'checkout.lastNamePh': 'Bērziņa',
  'checkout.processingBtn': 'Apstrādā…',
  'checkout.termsShort': 'Noteikumi',
  'checkout.privacyShort': 'Privātums',
  'checkout.detailsStep': 'Dati',
  'checkout.shippingBilling': 'Piegāde un norēķini',
  'checkout.paymentStep': 'Maksājums',
  'checkout.secureViaStripe': 'Drošs caur Stripe',
  'checkout.acceptTerms': 'Es piekrītu',
  'checkout.and': 'un',
  'register.firstNamePh': 'Jānis',
  'register.lastNamePh': 'Bērziņš',
  'register.termsLink': 'Lietošanas noteikumiem',
  'register.privacyLink': 'Privātuma politikai',
  'product.clickToZoom': 'Noklikšķiniet, lai palielinātu',
  'product.deliveryEstimate': 'Piegādes aprēķins',
  'product.selectCountry': 'Izvēlieties valsti',
  'product.inStockShort': 'Noliktavā',
  'product.outOfStockShort': 'Nav noliktavā',
  'product.askQuestion': 'Uzdot jautājumu',
  'product.askQuestionPh': 'Sveiki, man ir jautājums par šo detaļu. Vai tā ir saderīga ar manu automašīnu?',
  'product.soldBy': 'Pārdod',
  'product.yourReview': 'Jūsu atsauksme',
  'product.reviewTitlePh': 'Apkopojiet savu pieredzi',
  'product.reviewBodyPh': 'Dalieties pieredzē ar šo detaļu — atbilstība, kvalitāte, piegāde…',
  'product.noReviewsYet': 'Vēl nav atsauksmju.',
  'product.beFirstReview': 'Esiet pirmais, kas novērtē šo detaļu!',
  'product.notFound': 'Produkts nav atrasts',
  'product.browseAll': 'Pārlūkot visas detaļas',
  'product.qualityAssessment': 'Kvalitātes novērtējums',
  'product.aiAssessed': 'AI novērtējums pēc fotoattēliem',
  'product.aiDisclaimer': 'Automātisks vizuāls novērtējums — pārbaudiet pēc fotoattēliem.',
  'product.newSeller': 'Jauns pārdevējs',
  'product.description': 'Produkta apraksts',
  'product.keyFeatures': 'Galvenās īpašības',
  'product.compatibility': 'Saderība ar transportlīdzekli',
  'product.oemNumbersTitle': 'OEM numuri',
  'product.totalSales': 'Kopējie pārdošanas apjomi',
  'product.aboutSeller': 'Par pārdevēju',
  'product.moreFromSeller': 'Vairāk no šī pārdevēja',
  'product.youMayAlsoLike': 'Jums varētu patikt arī',
  'product.copyOem': 'Kopēt OEM kodu',
  'product.securePayment': 'Drošs maksājums',
  'product.newLabel': 'Jauns',
  'product.sellerInfoNa': 'Pārdevēja informācija nav pieejama',
  'home.heroBadge': '4,2 milj.+ detaļas pieejamas',
  'home.heroTitle1': 'Atrodi savu',
  'home.heroTitle2': 'auto detaļu',
  'home.heroPara': "Eiropas interneta veikals kvalitatīvām lietotām un atjaunotām auto detaļām. Meklē pēc OEM koda vai transportlīdzekļa modeļa.",
  'home.searchPlaceholder': 'Ievadiet OEM kodu vai detaļas numuru (piem., OEM-A123-4567)',
  'home.searchByVehicle': 'Meklēt pēc transportlīdzekļa',
  'home.searchByVehicleSub': 'Izvēlieties savu auto, lai atrastu saderīgas detaļas',
  'home.makeLabel': 'Marka',
  'home.modelLabel': 'Modelis',
  'home.generationLabel': 'Paaudze',
  'home.partNameLabel': 'Detaļas nosaukums',
  'home.selectMake': 'Izvēlieties marku',
  'home.selectModel': 'Izvēlieties modeli',
  'home.selectGeneration': 'Izvēlieties paaudzi',
  'home.partPlaceholder': 'piem., Bremžu uzlikas, Ģenerators…',
  'home.searchPartsBtn': 'Meklēt detaļas',
  'home.browseByCategoryTitle': 'Pārlūkot pēc kategorijas',
  'home.browseByCategorySub': 'Atrodiet detaļas pēc veida',
  'common.viewAll': 'Skatīt visu',
  'header.shipWithin': 'Sūtām 72 darba stundu laikā',
  'header.returns14': '14 dienu atgriešana',
  'header.deliveryEU': "Piegāde uz ES, Apvienoto Karalisti un Norvēģiju",
  'header.inclVat': 'Ar PVN',
  'header.exclVat': 'Bez PVN',
  'cat.air-conditioning-heating-system-radiators': 'Kondicionieris, apsilde un radiatori',
  'cat.body-body-parts-hook': 'Virsbūve un pārsegs',
  'cat.brake-system': 'Bremžu sistēma',
  'cat.cabin-interior': 'Salons',
  'cat.devices-switches-electronic-system': 'Elektrika un elektronika',
  'cat.door': 'Durvis',
  'cat.engine': 'Dzinējs',
  'cat.exterior-front-body-parts': 'Priekšējā virsbūve',
  'cat.exterior-rear-body-parts': 'Aizmugures virsbūve',
  'cat.front-axle': 'Priekšējais tilts',
  'cat.fuel-mixture-system': 'Degvielas sistēma',
  'cat.gas-exhaust-system': 'Izplūdes sistēma',
  'cat.gearbox-clutch-transmission': 'Kārba, sajūgs un transmisija',
  'cat.glass': 'Stikli',
  'cat.headlight-headlamp-washing-cleaning-system': 'Lukturi un mazgāšanas sistēma',
  'cat.lighting-system': 'Apgaismojums',
  'cat.other-parts': 'Citas detaļas',
  'cat.rear-axle': 'Aizmugures tilts',
  'cat.wheels-tires-caps': 'Riepas un diski',
};

const lt = {
  'nav.home': 'Pradžia',
  'nav.allParts': 'Visos dalys',
  'nav.cart': 'Krepšelis',
  'nav.myAccount': 'Mano paskyra',
  'nav.myOrders': 'Mano užsakymai',
  'nav.sellerPortal': 'Pardavėjo portalas',
  'nav.adminPanel': 'Administratoriaus skydelis',
  'nav.login': 'Prisijungti',
  'nav.register': 'Registruotis',
  'nav.logout': 'Atsijungti',
  'nav.makes': 'Transporto priemonių markės',
  'header.freeShipping': "Greitas pristatymas į ES, Jungtinę Karalystę ir Norvegiją",
  'header.returns': '14 dienų grąžinimas',
  'header.light': 'Šviesi',
  'header.dark': 'Tamsi',
  'header.searchPlaceholder': 'Ieškoti pagal dalies numerį, OEM kodą ar raktinį žodį...',
  'header.searchMobile': 'Ieškoti dalių...',
  'search.partsFound': 'Rasta {count} dalių',
  'search.sortBy': 'Rikiuoti pagal',
  'search.relevance': 'Aktualumas',
  'search.priceLowHigh': 'Kaina: Nuo mažiausios',
  'search.priceHighLow': 'Kaina: Nuo didžiausios',
  'search.newest': 'Naujausi',
  'search.priceRange': 'Kainų diapazonas',
  'search.make': 'Markė',
  'search.model': 'Modelis',
  'search.year': 'Metai',
  'search.category': 'Kategorija',
  'search.subcategory': 'Subkategorija',
  'search.condition': 'Būklė',
  'search.allMakes': 'Visos markės',
  'search.allModels': 'Visi modeliai',
  'search.allYears': 'Visi metai',
  'search.allCategories': 'Visos kategorijos',
  'search.allSubcategories': 'Visos subkategorijos',
  'search.allConditions': 'Visos būklės',
  'search.clearFilters': 'Išvalyti visus filtrus',
  'search.noResults': 'Nerasta dalių, atitinkančių jūsų kriterijus',
  'search.noResultsHint': 'Pabandykite išplėsti paiešką arba koreguoti filtrus',
  'search.addToCart': 'Pridėti į krepšelį',
  'product.addToCart': 'Pridėti į krepšelį',
  'product.freeShipping': "Pristatymas į ES, Jungtinę Karalystę ir Norvegiją",
  'product.reviews': 'Atsiliepimai',
  'product.writeReview': 'Parašyti atsiliepimą',
  'product.signInReview': 'Prisijunkite norėdami parašyti atsiliepimą',
  'product.noReviews': 'Kol kas nėra atsiliepimų. Būkite pirmas!',
  'product.seller': 'Pardavėjas',
  'product.condition': 'Būklė',
  'product.oemCodes': 'OEM kodai',
  'product.inStock': 'Sandėlyje ({qty} prieinami)',
  'product.outOfStock': 'Nėra sandėlyje',
  'product.reviewTitle': 'Pavadinimas',
  'product.reviewContent': 'Atsiliepimas',
  'product.submitReview': 'Pateikti atsiliepimą',
  'product.avgRating': 'Vidutinis įvertinimas',
  'product.ratingDist': 'Įvertinimų pasiskirstymas',
  'cart.title': 'Pirkinių krepšelis',
  'cart.empty': 'Jūsų krepšelis tuščias',
  'cart.emptyHint': 'Naršykite mūsų automobilių dalių asortimentą',
  'cart.subtotal': 'Tarpinė suma',
  'cart.shipping': 'Pristatymas',
  'cart.total': 'Iš viso',
  'cart.checkout': 'Į kasą',
  'cart.each': 'vnt.',
  'cart.continueShopping': 'Tęsti apsipirkimą',
  'cart.freeShipping': 'Pristatymas skaičiuojamas kasos punkte',
  'checkout.orderSummary': 'Užsakymo santrauka',
  'checkout.subtotal': 'Tarpinė suma',
  'checkout.shipping': 'Pristatymas',
  'checkout.total': 'Iš viso',
  'checkout.placeOrder': 'Pateikti užsakymą',
  'checkout.processing': 'Apdorojama...',
  'checkout.shippingInfo': 'Pristatymo adresas',
  'checkout.billingInfo': 'Sąskaitos adresas',
  'checkout.paymentInfo': 'Mokėjimo informacija',
  'checkout.firstName': 'Vardas',
  'checkout.lastName': 'Pavardė',
  'checkout.email': 'El. paštas',
  'checkout.address': 'Adresas',
  'checkout.city': 'Miestas',
  'checkout.country': 'Šalis',
  'checkout.postalCode': 'Pašto kodas',
  'checkout.cardNumber': 'Kortelės numeris',
  'checkout.expiryDate': 'Galiojimo data',
  'checkout.cvv': 'CVV',
  'checkout.sameAsBilling': 'Tas pats kaip pristatymo adresas',
  'customer.orders': 'Užsakymai',
  'customer.messages': 'Žinutės',
  'customer.returns': 'Grąžinimai',
  'customer.orderHistory': 'Užsakymų istorija',
  'customer.noOrders': 'Kol kas nėra užsakymų',
  'customer.orderNo': 'Užsakymas #',
  'customer.orderDate': 'Data',
  'customer.orderStatus': 'Statusas',
  'customer.orderTotal': 'Iš viso',
  'customer.viewDetails': 'Peržiūrėti detales',
  'customer.backToOrders': 'Grįžti į užsakymus',
  'customer.orderDetail': 'Užsakymo detalės',
  'customer.requestReturn': 'Prašyti grąžinimo',
  'customer.returnReason': 'Grąžinimo priežastis',
  'customer.returnDescription': 'Papildoma informacija (neprivaloma)',
  'customer.submitReturn': 'Pateikti grąžinimo prašymą',
  'customer.returnSuccess': 'Jūsų grąžinimo prašymas sėkmingai pateiktas.',
  'customer.returnPending': 'Atstovas jį netrukus peržiūrės.',
  'customer.conversations': 'Pokalbiai',
  'customer.noMessages': 'Kol kas nėra pokalbių',
  'customer.send': 'Siųsti',
  'customer.returnStatus.pending': 'Laukiama',
  'customer.returnStatus.approved': 'Patvirtinta',
  'customer.returnStatus.rejected': 'Atmesta',
  'customer.returnStatus.processing': 'Apdorojama',
  'customer.returnId': 'Grąžinimo ID',
  'customer.orderId': 'Užsakymo ID',
  'customer.reason': 'Priežastis',
  'customer.description': 'Aprašymas',
  'customer.noReturns': 'Kol kas nėra pateiktų grąžinimų',
  'customer.noReturnsHint': 'Jei norite grąžinti prekę, eikite į užsakymo detales ir spustelėkite "Prašyti grąžinimo".',
  'vendor.dashboard': 'Valdymo skydelis',
  'vendor.myListings': 'Mano skelbimai',
  'vendor.orders': 'Užsakymai',
  'vendor.addListing': 'Pridėti skelbimą',
  'vendor.bulkImport': 'Masinis importas',
  'vendor.revenue': 'Pajamos',
  'vendor.totalOrders': 'Užsakymai',
  'vendor.totalListings': 'Skelbimai',
  'vendor.totalViews': 'Peržiūros',
  'vendor.recentOrders': 'Naujausi užsakymai',
  'vendor.noOrders': 'Kol kas nėra užsakymų',
  'vendor.editListing': 'Redaguoti',
  'vendor.deleteListing': 'Ištrinti',
  'vendor.priceLabel': 'Kaina ({symbol}) *',
  'vendor.importCSV': 'Importuoti CSV skelbimus',
  'vendor.downloadTemplate': 'Atsisiųsti CSV šabloną',
  'vendor.chooseFile': 'Pasirinkti CSV failą',
  'vendor.startImport': 'Pradėti importą',
  'vendor.instructions': 'Kaip importuoti',
  'vendor.previewData': 'Peržiūra (pirmosios 5 eilutės)',
  'vendor.importResults': 'Importo rezultatai',
  'vendor.listingsCreated': 'skelbimų sukurta',
  'vendor.errors': 'Klaidos',
  'vendor.noFile': 'Nepasirinktas failas',
  'vendor.requiredColumns': 'Įkelkite CSV failą su šiais stulpeliais. Privalomi tik pavadinimas ir kaina.',
  'admin.users': 'Vartotojai',
  'admin.sellers': 'Pardavėjai',
  'admin.listings': 'Skelbimai',
  'admin.orders': 'Užsakymai',
  'admin.approve': 'Patvirtinti',
  'admin.suspend': 'Sustabdyti',
  'admin.delete': 'Ištrinti',
  'admin.totalUsers': 'Viso vartotojų',
  'admin.totalSellers': 'Viso pardavėjų',
  'admin.totalListings': 'Viso skelbimų',
  'admin.totalOrders': 'Viso užsakymų',
  'admin.pendingSellers': 'Laukiantys pardavėjai',
  'admin.email': 'El. paštas',
  'admin.name': 'Vardas',
  'admin.role': 'Vaidmuo',
  'admin.status': 'Statusas',
  'admin.actions': 'Veiksmai',
  'admin.company': 'Įmonė',
  'admin.rating': 'Įvertinimas',
  'admin.sales': 'Pardavimai',
  'admin.title': 'Pavadinimas',
  'admin.price': 'Kaina',
  'admin.category': 'Kategorija',
  'admin.orderNo': 'Užsakymas #',
  'admin.buyer': 'Pirkėjas',
  'admin.date': 'Data',
  'admin.total': 'Iš viso',
  'home.heroTitle': "Naudotų auto dalių internetinė parduotuvė · 4,2 mln.+ dalių",
  'home.heroSubtitle': "Raskite originalias ir pakaitines dalis bet kuriai Europos transporto priemonei. Pristatymas į ES, Jungtinę Karalystę ir Norvegiją.",
  'home.searchHero': 'Ieškoti pagal dalies numerį, markę ar raktinį žodį',
  'home.featuredParts': 'Rekomenduojamos dalys',
  'home.viewAll': 'Peržiūrėti visas dalis',
  'home.freeShipping': "Pristatymas ES, Jungtinė Karalystė ir Norvegija",
  'home.freeShippingDesc': "Pristatymas į ES, Jungtinę Karalystę ir Norvegiją",
  'home.returns': '14 dienų grąžinimas',
  'home.returnsDesc': 'Paprasta grąžinimo politika',
  'home.securePayment': 'Saugus mokėjimas',
  'home.securePaymentDesc': 'SSL užšifruoti sandoriai',
  'home.qualityParts': 'Kokybiškos dalys',
  'home.qualityPartsDesc': "Originalios gamintojo dalys",
  'home.whyChoose': 'Kodėl rinktis zivu.eu?',
  'home.trustedSellers': "Patikrintas suderinamumas",
  'home.trustedSellersDesc': "Kiekviena dalis nufotografuojama ir patikrinamas suderinamumas prieš skelbiant",
  'makes.title': 'Transporto priemonių markės',
  'makes.subtitle': 'Naršyti dalis pagal transporto priemonės gamintoją',
  'makes.searchPlaceholder': 'Ieškoti markių...',
  'makes.popular': 'Populiarios markės',
  'makeDetail.subtitle': 'Naršyti modelius ir rasti dalis',
  'makeDetail.selectModel': 'Pasirinkti modelį',
  'makeDetail.selectYear': 'Pasirinkti metus',
  'footer.tagline': "Internetinė parduotuvė naudotoms ir atnaujintoms automobilių dalims. Pristatymas į ES, Jungtinę Karalystę ir Norvegiją.",
  'footer.shop': 'Parduotuvė',
  'footer.allParts': 'Visos dalys',
  'footer.engineParts': 'Variklio dalys',
  'footer.bodyParts': 'Kėbulo dalys',
  'footer.electrical': 'Elektrinės',
  'footer.refurbished': 'Atnaujintos',
  'footer.information': 'Informacija',
  'footer.aboutUs': 'Apie mus',
  'footer.deliveryInfo': 'Pristatymo informacija',
  'footer.returnsRefunds': 'Grąžinimai ir kompensacijos',
  'footer.paymentMethods': 'Mokėjimo metodai',
  'footer.contactUs': 'Susisiekite su mumis',
  'footer.support': 'Palaikymas',
  'footer.helpCenter': 'Pagalbos centras',
  'footer.shippingInfo': 'Siuntimo informacija',
  'footer.faq': 'DUK',
  'footer.warranty': 'Garantija',
  'footer.sellers': 'Pardavėjai',
  'footer.sellOnZivu': 'Parduokite zivu.eu',
  'footer.sellerPortal': 'Pardavėjo portalas',
  'footer.sellerTerms': 'Pardavėjo sąlygos',
  'footer.privacy': 'Privatumas',
  'footer.terms': 'Sąlygos',
  'footer.euMarketplace': "ES · JK · Norvegija",
  'login.welcomeBack': 'Sveiki sugrįžę',
  'login.signInToContinue': 'Prisijunkite prie savo paskyros, kad tęstumėte',
  'login.emailLabel': 'El. paštas',
  'login.passwordLabel': 'Slaptažodis',
  'login.emailPh': 'jus@pavyzdys.lt',
  'login.forgotPassword': 'Pamiršote slaptažodį?',
  'login.signingIn': 'Prisijungiama…',
  'login.signInBtn': 'Prisijungti',
  'login.orContinueWith': 'Arba tęskite su',
  'login.continueWithGoogle': 'Tęsti su Google',
  'login.noAccount': 'Dar neturite paskyros?',
  'login.signUp': 'Registruotis',
  'register.title': 'Sukurti paskyrą',
  'register.subtitle': "Sukurkite paskyrą naudotoms ir atnaujintoms auto dalims pirkti",
  'register.firstName': 'Vardas',
  'register.lastName': 'Pavardė',
  'register.emailLabel': 'El. paštas',
  'register.passwordLabel': 'Slaptažodis',
  'register.confirmPassword': 'Patvirtinkite slaptažodį',
  'register.creating': 'Paskyra kuriama…',
  'register.createBtn': 'Sukurti paskyrą',
  'register.alreadyHave': 'Jau turite paskyrą?',
  'register.signIn': 'Prisijungti',
  'register.byCreating': 'Sukurdami paskyrą sutinkate su mūsų',
  'customer.nav.overview': 'Apžvalga',
  'customer.nav.myOrders': 'Mano užsakymai',
  'customer.nav.myGarage': 'Mano garažas',
  'customer.nav.myReviews': 'Mano atsiliepimai',
  'customer.nav.favorites': 'Mėgstami',
  'customer.nav.messages': 'Žinutės',
  'customer.nav.returns': 'Grąžinimai',
  'customer.nav.addresses': 'Adresai',
  'customer.nav.settings': 'Nustatymai',
  'customer.dashboardSubtitle': 'Tvarkykite savo užsakymus ir paskyros nustatymus',
  'customer.recentOrders': 'Naujausi užsakymai',
  'customer.noOrdersYet': 'Dar nėra užsakymų',
  'customer.myOrdersTitle': 'Mano užsakymai',
  'customer.trackManage': 'Sekite ir tvarkykite savo užsakymus',
  'customer.browseParts': 'Naršyti detales',
  'customer.orderNotFound': 'Užsakymas nerastas',
  'customer.cancelOrderTitle': 'Atšaukti šį užsakymą?',
  'customer.cancelOrderDesc': 'Šio veiksmo atšaukti negalima. Mokėjimas bus grąžintas.',
  'customer.keepOrder': 'Palikti užsakymą',
  'customer.statusHistory': 'Būsenų istorija',
  'customer.orderItems': 'Užsakymo prekės',
  'customer.discount': 'Nuolaida',
  'customer.shippingAddressTitle': 'Pristatymo adresas',
  'customer.billingAddressTitle': 'Sąskaitos adresas',
  'customer.needToReturn': 'Reikia grąžinti šį užsakymą?',
  'customer.returnRequestForm': 'Grąžinimo prašymo forma',
  'customer.cancelBtn': 'Atšaukti',
  'customer.returnSubmitted': 'Grąžinimo prašymas pateiktas',
  'customer.returnReviewMsg': 'Mūsų komanda peržiūrės jūsų prašymą ir greitai susisieks.',
  'customer.newMessageTitle': 'Nauja žinutė',
  'customer.sending': 'Siunčiama…',
  'customer.sendMessage': 'Siųsti žinutę',
  'customer.messagesTitle': 'Žinutės',
  'customer.myFavoritesTitle': 'Mano mėgstami',
  'customer.noFavoritesYet': 'Dar nėra mėgstamų',
  'customer.noTimelineData': 'Nėra laiko juostos duomenų',
  'customer.returnsTitle': 'Grąžinimai',
  'customer.noReturnsYet': 'Dar nėra grąžinimų',
  'customer.myAddressesTitle': 'Mano adresai',
  'customer.noAddressesSaved': 'Nėra išsaugotų adresų',
  'customer.defaultBadge': 'Numatytasis',
  'customer.businessAccount': 'Įmonės paskyra',
  'customer.currentStatus': 'Esama būsena',
  'customer.companyAddress': 'Registruotas įmonės adresas',
  'status.pending': 'Laukiama',
  'status.confirmed': 'Patvirtinta',
  'status.paid': 'Apmokėta',
  'status.processing': 'Apdorojama',
  'status.shipped': 'Išsiųsta',
  'status.delivered': 'Pristatyta',
  'status.completed': 'Užbaigta',
  'status.cancelled': 'Atšaukta',
  'status.refunded': 'Grąžinta',
  'status.returnRequested': 'Prašoma grąžinti',
  'status.returning': 'Grąžinama',
  'status.returned': 'Grąžinta',
  'status.returnRejected': 'Grąžinimas atmestas',
  'cart.itemsSubtotalLabel': 'Prekių suma',
  'cart.discountLabel': 'Nuolaida',
  'cart.allPricesVat': 'Visos kainos su PVM',
  'cart.allPricesNet': 'Be PVM — pirkėjas pats apskaičiuoja PVM (atvirkštinė PVM tvarka)',
  'cart.secureCheckout': 'Saugus mokėjimas per Stripe',
  'cart.orderSummary': 'Užsakymo santrauka',
  'checkout.title': 'Apmokėjimas',
  'checkout.buyerType': 'Pirkėjo tipas',
  'checkout.private': 'Privatus asmuo',
  'checkout.privateSub': 'Asmeninis pirkimas',
  'checkout.company': 'Įmonė / Organizacija',
  'checkout.companySub': 'B2B su PVM sąskaita',
  'checkout.companyDetails': 'Įmonės duomenys',
  'checkout.companyName': 'Įmonės pavadinimas',
  'checkout.companyNamePh': 'UAB Acme',
  'checkout.vatNumberLabel': 'PVM kodas (rekomenduojama)',
  'checkout.vatValidating': 'Tikrinamas PVM kodas…',
  'checkout.streetPh': 'Gatvė ir numeris',
  'checkout.shippingTitle': 'Pristatymas',
  'checkout.standardDelivery': 'Standartinis pristatymas',
  'checkout.billingTitle': 'Sąskaitos adresas',
  'checkout.sameAsShipping': 'Toks pat kaip pristatymo adresas',
  'checkout.secureCheckout': 'Saugus mokėjimas per Stripe',
  'checkout.buyerProtection': "14 dienų teisė atsisakyti",
  'checkout.firstNamePh': 'Jonė',
  'checkout.lastNamePh': 'Petraitytė',
  'checkout.processingBtn': 'Apdorojama…',
  'checkout.termsShort': 'Sąlygos',
  'checkout.privacyShort': 'Privatumas',
  'checkout.detailsStep': 'Duomenys',
  'checkout.shippingBilling': 'Pristatymas ir sąskaita',
  'checkout.paymentStep': 'Mokėjimas',
  'checkout.secureViaStripe': 'Saugu per Stripe',
  'checkout.acceptTerms': 'Sutinku su',
  'checkout.and': 'ir',
  'register.firstNamePh': 'Jonas',
  'register.lastNamePh': 'Petraitis',
  'register.termsLink': 'Paslaugų taisyklėmis',
  'register.privacyLink': 'Privatumo politika',
  'product.clickToZoom': 'Spustelėkite, kad padidintumėte',
  'product.deliveryEstimate': 'Pristatymo laikas',
  'product.selectCountry': 'Pasirinkite šalį',
  'product.inStockShort': 'Sandėlyje',
  'product.outOfStockShort': 'Nėra sandėlyje',
  'product.askQuestion': 'Užduoti klausimą',
  'product.askQuestionPh': 'Sveiki, turiu klausimą dėl šios detalės. Ar ji tinka mano automobiliui?',
  'product.soldBy': 'Pardavėjas',
  'product.yourReview': 'Jūsų atsiliepimas',
  'product.reviewTitlePh': 'Apibendrinkite savo patirtį',
  'product.reviewBodyPh': 'Pasidalykite patirtimi su šia detale — montavimas, kokybė, pristatymas…',
  'product.noReviewsYet': 'Dar nėra atsiliepimų.',
  'product.beFirstReview': 'Būkite pirmas, kuris įvertins šią detalę!',
  'product.notFound': 'Produktas nerastas',
  'product.browseAll': 'Naršyti visas detales',
  'product.qualityAssessment': 'Kokybės įvertinimas',
  'product.aiAssessed': 'AI įvertinta pagal nuotraukas',
  'product.aiDisclaimer': 'Automatinis vizualinis vertinimas — patikrinkite pagal nuotraukas.',
  'product.newSeller': 'Naujas pardavėjas',
  'product.description': 'Produkto aprašymas',
  'product.keyFeatures': 'Pagrindinės savybės',
  'product.compatibility': 'Suderinamumas su transporto priemone',
  'product.oemNumbersTitle': 'OEM numeriai',
  'product.totalSales': 'Bendras pardavimas',
  'product.aboutSeller': 'Apie pardavėją',
  'product.moreFromSeller': 'Daugiau iš šio pardavėjo',
  'product.youMayAlsoLike': 'Jums taip pat gali patikti',
  'product.copyOem': 'Kopijuoti OEM kodą',
  'product.securePayment': 'Saugus mokėjimas',
  'product.newLabel': 'Naujas',
  'product.sellerInfoNa': 'Pardavėjo informacija nepasiekiama',
  'home.heroBadge': '4.2M+ detalių prieinama',
  'home.heroTitle1': 'Surask savo',
  'home.heroTitle2': 'auto detalę',
  'home.heroPara': "Europos internetinė parduotuvė kokybiškoms naudotoms ir atnaujintoms automobilių dalims. Ieškokite pagal OEM kodą arba modelį.",
  'home.searchPlaceholder': 'Įveskite OEM kodą arba detalės numerį (pvz., OEM-A123-4567)',
  'home.searchByVehicle': 'Ieškoti pagal transporto priemonę',
  'home.searchByVehicleSub': 'Pasirinkite automobilį, kad rastumėte tinkamas detales',
  'home.makeLabel': 'Markė',
  'home.modelLabel': 'Modelis',
  'home.generationLabel': 'Karta',
  'home.partNameLabel': 'Detalės pavadinimas',
  'home.selectMake': 'Pasirinkite markę',
  'home.selectModel': 'Pasirinkite modelį',
  'home.selectGeneration': 'Pasirinkite kartą',
  'home.partPlaceholder': 'pvz., Stabdžių kaladėlės, Generatorius…',
  'home.searchPartsBtn': 'Ieškoti detalių',
  'home.browseByCategoryTitle': 'Naršyti pagal kategoriją',
  'home.browseByCategorySub': 'Rasti detales pagal tipą',
  'common.viewAll': 'Žiūrėti viską',
  'header.shipWithin': 'Siunčiame per 72 darbo valandas',
  'header.returns14': '14 dienų grąžinimas',
  'header.deliveryEU': "Pristatymas į ES, Jungtinę Karalystę ir Norvegiją",
  'header.inclVat': 'Su PVM',
  'header.exclVat': 'Be PVM',
  'cat.air-conditioning-heating-system-radiators': 'Kondicionavimas, šildymas ir radiatoriai',
  'cat.body-body-parts-hook': 'Kėbulas ir kapotas',
  'cat.brake-system': 'Stabdžių sistema',
  'cat.cabin-interior': 'Salonas',
  'cat.devices-switches-electronic-system': 'Elektra ir elektronika',
  'cat.door': 'Durys',
  'cat.engine': 'Variklis',
  'cat.exterior-front-body-parts': 'Priekinis kėbulas',
  'cat.exterior-rear-body-parts': 'Galinis kėbulas',
  'cat.front-axle': 'Priekinis tiltas',
  'cat.fuel-mixture-system': 'Kuro sistema',
  'cat.gas-exhaust-system': 'Išmetimo sistema',
  'cat.gearbox-clutch-transmission': 'Pavarų dėžė, sankaba ir pavara',
  'cat.glass': 'Stiklai',
  'cat.headlight-headlamp-washing-cleaning-system': 'Žibintai ir plovikliai',
  'cat.lighting-system': 'Apšvietimas',
  'cat.other-parts': 'Kitos detalės',
  'cat.rear-axle': 'Galinis tiltas',
  'cat.wheels-tires-caps': 'Ratai ir padangos',
};

// Active language dropdown. Trimmed 2026-04-30 from 22 → 8 languages so every
// language in the dropdown has near-100% UI coverage AND covers the markets we
// actually ship to actively. The dropped languages (sv, da, fi, no, nl, pt,
// ro, cs, hu, bg, hr, sk, sl, el) still have translation data in the
// `translations` map below — just commented out here. Re-enable once the
// hardcoded-string pass on ProductPage / CheckoutPage / CustomerDashboard is
// done.
export const LANGUAGES = {
  en: { name: 'English', flag: '\ud83c\uddec\ud83c\udde7' },
  de: { name: 'Deutsch', flag: '\ud83c\udde9\ud83c\uddea' },
  fr: { name: 'Fran\u00e7ais', flag: '\ud83c\uddeb\ud83c\uddf7' },
  es: { name: 'Espa\u00f1ol', flag: '\ud83c\uddea\ud83c\uddf8' },
  it: { name: 'Italiano', flag: '\ud83c\uddee\ud83c\uddf9' },
  pl: { name: 'Polski', flag: '\ud83c\uddf5\ud83c\uddf1' },
  lv: { name: 'Latvie\u0161u', flag: '\ud83c\uddf1\ud83c\uddfb' },
  lt: { name: 'Lietuvi\u0173', flag: '\ud83c\uddf1\ud83c\uddf9' },
  // sv: { name: 'Svenska', flag: '\ud83c\uddf8\ud83c\uddea' },
  // da: { name: 'Dansk', flag: '\ud83c\udde9\ud83c\uddf0' },
  // fi: { name: 'Suomi', flag: '\ud83c\uddeb\ud83c\uddee' },
  // no: { name: 'Norsk', flag: '\ud83c\uddf3\ud83c\uddf4' },
  // nl: { name: 'Nederlands', flag: '\ud83c\uddf3\ud83c\uddf1' },
  // pt: { name: 'Portugu\u00eas', flag: '\ud83c\uddf5\ud83c\uddf9' },
  // ro: { name: 'Rom\u00e2n\u0103', flag: '\ud83c\uddf7\ud83c\uddf4' },
  // cs: { name: '\u010ce\u0161tina', flag: '\ud83c\udde8\ud83c\uddff' },
  // hu: { name: 'Magyar', flag: '\ud83c\udded\ud83c\uddfa' },
  // bg: { name: '\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438', flag: '\ud83c\udde7\ud83c\uddec' },
  // hr: { name: 'Hrvatski', flag: '\ud83c\udded\ud83c\uddf7' },
  // sk: { name: 'Sloven\u010dina', flag: '\ud83c\uddf8\ud83c\uddf0' },
  // sl: { name: 'Sloven\u0161\u010dina', flag: '\ud83c\uddf8\ud83c\uddee' },
  // el: { name: '\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac', flag: '\ud83c\uddec\ud83c\uddf7' },
};

const translations = { en, de, fr, es, it, pl, sv, da, fi, no, nl, pt, ro, cs, hu, bg, hr, sk, sl, el, lv, lt };

export function createT(language) {
  return function t(key, params = {}) {
    let str = (translations[language] && translations[language][key]) || translations.en[key] || key;
    if (params) {
      Object.keys(params).forEach(k => {
        str = str.replace(new RegExp('\\{' + k + '\\}', 'g'), String(params[k]));
      });
    }
    return str;
  };
}
